import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  List,
  ListItemButton,
  Tabs,
  Tab,
  ListItem,
  ListItemText,
  Button,
  Chip,
  InputBase,
  ToggleButtonGroup,
  ToggleButton,
  MenuItem,
  InputAdornment,
  Switch,
  Divider,
  DialogContent,
  CircularProgress,
  LinearProgress,
  IconButton,
  Popover,
  Alert,
  Tooltip,
} from "@mui/material";

import {
  LightbulbOutlined as LightbulbOutlinedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
} from "@mui/icons-material";
import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";

import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import WcOutlinedIcon from "@mui/icons-material/WcOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import BedtimeIcon from "@mui/icons-material/Bedtime";
import ScheduleIcon from "@mui/icons-material/Schedule";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MedicationIcon from "@mui/icons-material/Medication";
import NotesIcon from "@mui/icons-material/Notes";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ScienceIcon from "@mui/icons-material/Science";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ClearIcon from "@mui/icons-material/Clear";
import PersonIcon from "@mui/icons-material/Person";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
// import ReactQuill, { Quill } from "react-quill-new";
// import QuillTableBetter from "quill-table-better";
// import "react-quill-new/dist/quill.snow.css";
// import "quill-table-better/dist/quill-table-better.css";
import { BASE_URL } from "../../constants";
import axios from "axios";
import DOMPurify from "dompurify";
import { toast } from "react-toastify";
import { TemplateSection } from "./TemplateSelection";

Quill.register(
  {
    "modules/table-better": QuillTableBetter,
  },
  true,
);

/* ---------------- MOCK DATA ---------------- */
const patients = [
  { id: 1, name: "Ramesh Kumar" },
  { id: 2, name: "Sita Devi" },
  { id: 3, name: "Amit Sharma" },
];

const tests = [
  { label: "CBC" },
  { label: "LFT" },
  { label: "KFT" },
  { label: "Chest X-Ray" },
  { label: "Blood Sugar (Fasting)" },
];

// const medicines = [
//   "Paracetamol",
//   "Amoxicillin",
//   "Azithromycin",
//   "Pantoprazole",
//   "Metformin",
// ];

const durationTypes = ["Days", "Weeks", "Months"];

const fields = [
  "medicine",
  "morning",
  "afternoon",
  "evening",
  "night",
  "duration",
  "durationType",
  "note",
];

const emptyRow = () => ({
  medicine: "",
  morning: "",
  afternoon: "",
  evening: "",
  night: "",
  duration: "",
  durationType: "",
});

const isRowEmpty = (row) => fields.every((field) => !row[field]);

const hasClinicalNoteContent = (note) => {
  const plainText = String(note || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .trim();

  return Boolean(plainText);
};

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

// Quill.register({ "modules/table-better": QuillTableBetter }, true);

export default function PatientPrescriptionForm() {
  // const quillRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [rows, setRows] = useState([emptyRow()]);
  const inputRefs = useRef([]);
  const patientInputRef = useRef(null);
  const [isVitalsEditable, setIsVitalsEditable] = useState(false);

  const [symptomPopupOpen, setSymptomPopupOpen] = useState(false);
  const [advicePopupOpen, setAdvicePopupOpen] = useState(false);
  const [diagnosisPopupOpen, setDiagnosisPopupOpen] = useState(false);
  const [investigationPopupOpen, setInvestigationPopupOpen] = useState(false);

  /* ---------- Dialog State ---------- */
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogSearch, setDialogSearch] = useState("");
  const [dialogRowIndex, setDialogRowIndex] = useState(null);
  const [dialogField, setDialogField] = useState(null);
  const [highlightIndex, setHighlightIndex] = useState(0);
  const [editingDiagnosisIndex, setEditingDiagnosisIndex] = useState(null);
  const [editingSymptomsIndex, setEditingSymptomsIndex] = useState(null);

  const [suppressDialogOpen, setSuppressDialogOpen] = useState(false);
  const [focusAfterDelete, setFocusAfterDelete] = useState(null);
  const [focusRowIndex, setFocusRowIndex] = useState(null);

  const [medicineResults, setMedicineResults] = useState([]);
  const [medicineModalOpen, setMedicineModalOpen] = useState(false);
  const [medicineHighlightIndex, setMedicineHighlightIndex] = useState(0);
  const [medicineSearch, setMedicineSearch] = useState("");
  const [selectedEditPatient, setSelectedEditPatient] = useState(null);

  const [saveProgressOpen, setSaveProgressOpen] = useState(false);
  const [saveProgress, setSaveProgress] = useState([]);

  const [templatePopupOpen, setTemplatePopupOpen] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");
  const [prescriptionTemplates, setPrescriptionTemplates] = useState([]);
  const [templateLoading, setTemplateLoading] = useState(false);

  const [diagnosisTemplateAnchor, setDiagnosisTemplateAnchor] = useState(null);
  const [diagnosisTemplateSearch, setDiagnosisTemplateSearch] = useState("");
  const [diagnosisTemplates, setDiagnosisTemplates] = useState([]);
  const [diagnosisTemplateLoading, setDiagnosisTemplateLoading] =
    useState(false);

  const diagnosisTemplateOpen = Boolean(diagnosisTemplateAnchor);

  const [noteTemplateAnchor, setNoteTemplateAnchor] = useState(null);
  const [noteTemplateSearch, setNoteTemplateSearch] = useState("");
  const [noteTemplates, setNoteTemplates] = useState([]);
  const [noteTemplateLoading, setNoteTemplateLoading] = useState(false);

  const noteTemplateOpen = Boolean(noteTemplateAnchor);

  const [investigationTemplateAnchor, setInvestigationTemplateAnchor] =
    useState(null);

  const [investigationTemplateSearch, setInvestigationTemplateSearch] =
    useState("");

  const [investigationTemplates, setInvestigationTemplates] = useState([]);

  const [investigationTemplateLoading, setInvestigationTemplateLoading] =
    useState(false);

  const investigationTemplateOpen = Boolean(investigationTemplateAnchor);

  const [adviceTemplateAnchor, setAdviceTemplateAnchor] = useState(null);
  const [adviceTemplateSearch, setAdviceTemplateSearch] = useState("");
  const [adviceTemplates, setAdviceTemplates] = useState([]);
  const [adviceTemplateLoading, setAdviceTemplateLoading] = useState(false);

  const adviceTemplateOpen = Boolean(adviceTemplateAnchor);

  const [medicineTemplateAnchor, setMedicineTemplateAnchor] = useState(null);
  const [medicineTemplateSearch, setMedicineTemplateSearch] = useState("");
  const [medicineTemplates, setMedicineTemplates] = useState([]);
  const [medicineTemplateLoading, setMedicineTemplateLoading] = useState(false);

  const medicineTemplateOpen = Boolean(medicineTemplateAnchor);

  const [symptomSuggestions, setSymptomSuggestions] = useState([]);
  const [symptomLoading, setSymptomLoading] = useState(false);
  const [clinicalNote, setClinicalNote] = useState("");

  const [diagnosisSuggestions, setDiagnosisSuggestions] = useState([]);
  const [diagnosisLoading, setDiagnosisLoading] = useState(false);

  const [investigationInput, setInvestigationInput] = useState("");
  const [investigationSuggestions, setInvestigationSuggestions] = useState([]);
  const [investigationLoading, setInvestigationLoading] = useState(false);

  const quillRef = useRef(null);
  const toolbarOptions = [
    // [{ header: "1" }, { header: "2" }, { font: [] }],
    // [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    // [{ align: [] }],
    // [{ color: [] }, { background: [] }],
    // ["blockquote"],
    // [{ script: "sub" }, { script: "super" }],
    [{ size: ["small", "medium", "large"] }],
  ];

  const modules = {
    toolbar: toolbarOptions,

    table: false,

    "table-better": {
      language: "en_US",
      menus: [
        "column",
        "row",
        "merge",
        "table",
        "cell",
        "wrap",
        "copy",
        "delete",
      ],
      toolbarTable: true,
    },

    keyboard: {
      bindings: QuillTableBetter.keyboardBindings,
    },
  };

  const handleOpenMedicineTemplates = (event) => {
    event.stopPropagation();

    setMedicineTemplateAnchor(event.currentTarget);
    setMedicineTemplateSearch("");
  };

  const handleCloseMedicineTemplates = () => {
    setMedicineTemplateAnchor(null);
    setMedicineTemplateSearch("");
  };

  const handleOpenAdviceTemplates = (event) => {
    event.stopPropagation();

    setAdviceTemplateAnchor(event.currentTarget);
    setAdviceTemplateSearch("");
  };

  const handleCloseAdviceTemplates = () => {
    setAdviceTemplateAnchor(null);
    setAdviceTemplateSearch("");
  };

  const handleOpenInvestigationTemplates = (event) => {
    event.stopPropagation();

    setInvestigationTemplateAnchor(event.currentTarget);
    setInvestigationTemplateSearch("");
  };

  const handleCloseInvestigationTemplates = () => {
    setInvestigationTemplateAnchor(null);
    setInvestigationTemplateSearch("");
  };

  const handleOpenDiagnosisTemplates = (event) => {
    event.stopPropagation();

    setDiagnosisTemplateAnchor(event.currentTarget);
    setDiagnosisTemplateSearch("");
  };

  const handleCloseDiagnosisTemplates = () => {
    setDiagnosisTemplateAnchor(null);
    setDiagnosisTemplateSearch("");
  };

  const handleOpenNoteTemplates = (event) => {
    event.stopPropagation();
    setNoteTemplateAnchor(event.currentTarget);
    setNoteTemplateSearch("");
    setNoteTemplates([]);
  };

  const handleCloseNoteTemplates = () => {
    setNoteTemplateAnchor(null);
    setNoteTemplateSearch("");
  };

  const handleOpenPrescriptionTemplates = () => {
    setTemplatePopupOpen(true);
    setTemplateSearch("");
  };

  const fetchPrescriptionTemplates = async (search = "") => {
    try {
      setTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/prescription-template`,
        {
          params: {
            search,
          },
        },
      );

      if (data.success) {
        setPrescriptionTemplates(data.data || []);
      } else {
        setPrescriptionTemplates([]);
      }
    } catch (error) {
      console.error("Fetch Prescription Templates Error:", error);

      setPrescriptionTemplates([]);
    } finally {
      setTemplateLoading(false);
    }
  };

  console.log("prescriptionTemplates: ", prescriptionTemplates);

  const fetchDiagnosisTemplates = async (search = "") => {
    try {
      setDiagnosisTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/clinical-diagnosis-template`,
        {
          params: {
            search,
          },
        },
      );

      setDiagnosisTemplates(data.success ? data.data || [] : []);
    } catch (error) {
      console.error("Fetch Diagnosis Templates Error:", error);
      setDiagnosisTemplates([]);
    } finally {
      setDiagnosisTemplateLoading(false);
    }
  };

  const fetchNoteTemplates = async (search = "") => {
    try {
      setNoteTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/note-templates`,
        { params: { search } },
      );

      setNoteTemplates(
        data.success && Array.isArray(data.data) ? data.data : [],
      );
    } catch (error) {
      console.error("Fetch Note Templates Error:", error);
      setNoteTemplates([]);
    } finally {
      setNoteTemplateLoading(false);
    }
  };

  const fetchInvestigationTemplates = async (search = "") => {
    try {
      setInvestigationTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/investigation-template`,
        {
          params: {
            search,
          },
        },
      );

      setInvestigationTemplates(data.success ? data.data || [] : []);
    } catch (error) {
      console.error("Fetch Investigation Templates Error:", error);

      setInvestigationTemplates([]);
    } finally {
      setInvestigationTemplateLoading(false);
    }
  };

  const fetchAdviceTemplates = async (search = "") => {
    try {
      setAdviceTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/advice-template`,
        {
          params: {
            search,
          },
        },
      );

      setAdviceTemplates(data.success ? data.data || [] : []);
    } catch (error) {
      console.error("Fetch Advice Templates Error:", error);
      setAdviceTemplates([]);
    } finally {
      setAdviceTemplateLoading(false);
    }
  };

  const fetchMedicineTemplates = async (search = "") => {
    try {
      setMedicineTemplateLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/medicine-template`,
        {
          params: {
            search,
          },
        },
      );

      setMedicineTemplates(data.success ? data.data || [] : []);
    } catch (error) {
      console.error("Fetch Medicine Templates Error:", error);
      setMedicineTemplates([]);
    } finally {
      setMedicineTemplateLoading(false);
    }
  };

  useEffect(() => {
    if (!medicineTemplateOpen || !medicineTemplateSearch) return;

    const timer = setTimeout(() => {
      fetchMedicineTemplates(medicineTemplateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [medicineTemplateSearch, medicineTemplateOpen]);

  useEffect(() => {
    if (!noteTemplateOpen || !noteTemplateSearch) return;

    const timer = setTimeout(() => {
      fetchNoteTemplates(noteTemplateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [noteTemplateSearch, noteTemplateOpen]);

  useEffect(() => {
    if (!adviceTemplateOpen || !adviceTemplateSearch) return;

    const timer = setTimeout(() => {
      fetchAdviceTemplates(adviceTemplateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [adviceTemplateSearch, adviceTemplateOpen]);

  useEffect(() => {
    if (!investigationTemplateOpen || !investigationTemplateSearch) return;

    const timer = setTimeout(() => {
      fetchInvestigationTemplates(investigationTemplateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [investigationTemplateSearch, investigationTemplateOpen]);

  useEffect(() => {
    if (!templatePopupOpen || !templateSearch) return;

    const timer = setTimeout(() => {
      fetchPrescriptionTemplates(templateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [templateSearch, templatePopupOpen]);

  const [applyingTemplate, setApplyingTemplate] = useState(false);
  const [applyingTemplateName, setApplyingTemplateName] = useState("");

  const handleSelectPrescriptionTemplate = async (template) => {
    try {
      /* ==========================================
       SHOW APPLYING LOADER
    ========================================== */

      setApplyingTemplateName(template.name || "Prescription Template");
      setApplyingTemplate(true);

      // Close template selection popup
      setTemplatePopupOpen(false);

      /* ==========================================
       FETCH TEMPLATE
    ========================================== */

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/prescription-template/${template._id}`,
        {
          headers: {},
        },
      );

      if (!data.success) {
        throw new Error(data.message || "Failed to load prescription template");
      }

      const templateData = data.data;

      setClinicalNote(DOMPurify.sanitize(templateData?.note));

      /* ==========================================
       SYMPTOMS
    ========================================== */

      setSymptoms(
        Array.isArray(templateData?.symptoms) ? templateData.symptoms : [],
      );

      /* ==========================================
       DIAGNOSIS
    ========================================== */

      setDiagnosis(
        Array.isArray(templateData?.diagnosis) ? templateData.diagnosis : [],
      );

      /* ==========================================
       INVESTIGATIONS
    ========================================== */

      setSelectedTests(
        Array.isArray(templateData?.investigations)
          ? templateData.investigations
          : [],
      );

      /* ==========================================
       MEDICINES
    ========================================== */

      const formattedMedicines = Array.isArray(templateData?.medicines)
        ? templateData.medicines
            .filter((item) => item?.medicine?.trim())
            .map((item) => ({
              medicine: item.medicine.trim(),

              morning: String(item.morning ?? "0"),
              afternoon: String(item.afternoon ?? "0"),
              evening: String(item.evening ?? "0"),
              night: String(item.night ?? "0"),

              duration: String(item.duration ?? ""),

              durationType: item.durationType || "",

              note: item.note?.trim() || "",
            }))
        : [];

      setRows([...formattedMedicines, emptyRow()]);

      /* ==========================================
       ADVICE
    ========================================== */

      setAdvices(
        Array.isArray(templateData?.advice) ? templateData.advice : [],
      );

      /*
       * Give React a tiny amount of time to render
       * all populated prescription sections.
       */
      await new Promise((resolve) => setTimeout(resolve, 500));

      setApplyingTemplate(false);

      toast.success(
        `"${templateData.name || template.name}" applied successfully`,
      );
    } catch (error) {
      console.error("Apply Prescription Template Error:", error);

      setApplyingTemplate(false);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to apply prescription template",
      );
    }
  };

  const handleSelectInvestigationTemplate = async (template) => {
    try {
      /* ==========================================
       SHOW APPLYING TEMPLATE LOADER
    ========================================== */

      setApplyingTemplateName(template.name || "Investigation Template");
      setApplyingTemplate(true);

      // Close template popup
      handleCloseInvestigationTemplates();

      /* ==========================================
       FETCH TEMPLATE
    ========================================== */

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/investigation-template/${template._id}`,
      );

      if (!data.success) {
        throw new Error(
          data.message || "Failed to load investigation template",
        );
      }

      const templateInvestigations = Array.isArray(data.data?.investigations)
        ? data.data.investigations
        : [];

      if (!templateInvestigations.length) {
        throw new Error("This template does not contain any investigations");
      }

      /* ==========================================
       CLEAN TEMPLATE DATA
       Also removes duplicates
    ========================================== */
      setSelectedTests([]);
      const cleanInvestigations = [
        ...new Map(
          templateInvestigations
            .map((item) => {
              // String format
              if (typeof item === "string") {
                const name = item.trim();

                return name ? [name.toLowerCase(), name] : null;
              }

              // Object format
              if (item && typeof item === "object") {
                const name = (item.name || item.testName || "").trim();

                return name ? [name.toLowerCase(), item] : null;
              }

              return null;
            })
            .filter(Boolean),
        ).values(),
      ];

      /* ==========================================
       REPLACE EXISTING INVESTIGATIONS
    ========================================== */

      setSelectedTests(cleanInvestigations);

      /* ==========================================
       FINISH
    ========================================== */

      await new Promise((resolve) => setTimeout(resolve, 500));

      setApplyingTemplate(false);

      toast.success(
        `"${data.data?.name || template.name}" investigation template applied`,
      );
    } catch (error) {
      console.error("Load Investigation Template Error:", error);

      setApplyingTemplate(false);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to load investigation template",
      );
    }
  };

  const handleSelectAdviceTemplate = async (template) => {
    try {
      /* ==========================================
       SHOW APPLYING TEMPLATE LOADER
    ========================================== */

      setApplyingTemplateName(template.name || "Advice Template");
      setApplyingTemplate(true);

      // Close advice template popup
      handleCloseAdviceTemplates();

      /* ==========================================
       FETCH COMPLETE TEMPLATE
    ========================================== */

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/advice-template/${template._id}`,
      );

      if (!data.success) {
        throw new Error(data.message || "Failed to load advice template");
      }

      const templateAdvice = Array.isArray(data.data?.advice)
        ? data.data.advice
        : [];

      if (!templateAdvice.length) {
        throw new Error("This template does not contain any advice");
      }

      /* ==========================================
       CLEAN ADVICE
       - Remove empty values
       - Trim values
       - Remove duplicates
       - Case insensitive
    ========================================== */
      setAdvices([]);

      const cleanAdvice = [
        ...new Map(
          templateAdvice
            .filter((item) => typeof item === "string" && item.trim())
            .map((item) => [item.trim().toLowerCase(), item.trim()]),
        ).values(),
      ];

      /* ==========================================
       REPLACE EXISTING ADVICE
    ========================================== */

      setAdvices(cleanAdvice);

      /* ==========================================
       SMALL UI TRANSITION
    ========================================== */

      await new Promise((resolve) => setTimeout(resolve, 500));

      setApplyingTemplate(false);

      toast.success(
        `"${data.data?.name || template.name}" advice template applied`,
      );
    } catch (error) {
      console.error("Load Advice Template Error:", error);

      setApplyingTemplate(false);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to load advice template",
      );
    }
  };

  const handleSelectMedicineTemplate = async (template) => {
    try {
      /* ==========================================
       SHOW APPLYING TEMPLATE LOADER
    ========================================== */

      setApplyingTemplateName(template.name || "Medicine Template");
      setApplyingTemplate(true);

      // Close medicine template popup
      handleCloseMedicineTemplates();

      /* ==========================================
       FETCH COMPLETE TEMPLATE
    ========================================== */

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/medicine-template/${template._id}`,
      );

      if (!data.success) {
        throw new Error(data.message || "Failed to load medicine template");
      }

      const templateMedicines = Array.isArray(data.data?.medicines)
        ? data.data.medicines
        : [];

      if (!templateMedicines.length) {
        throw new Error("This template does not contain any medicines");
      }

      /* ==========================================
       FORMAT MEDICINES
    ========================================== */

      const formattedMedicines = templateMedicines
        .filter(
          (item) =>
            item && typeof item.medicine === "string" && item.medicine.trim(),
        )
        .map((item) => ({
          medicine: item.medicine.trim(),

          morning: String(item.morning ?? "0"),
          afternoon: String(item.afternoon ?? "0"),
          evening: String(item.evening ?? "0"),
          night: String(item.night ?? "0"),

          duration: String(item.duration ?? ""),

          durationType: item.durationType || "",

          note: typeof item.note === "string" ? item.note.trim() : "",
        }));

      /* ==========================================
       REMOVE DUPLICATES INSIDE TEMPLATE
    ========================================== */
      setRows([]);

      const seenMedicines = new Set();

      const cleanMedicines = formattedMedicines.filter((item) => {
        const medicineName = item.medicine.toLowerCase();

        if (seenMedicines.has(medicineName)) {
          return false;
        }

        seenMedicines.add(medicineName);

        return true;
      });

      /* ==========================================
       REPLACE EXISTING MEDICINE TABLE

       Existing rows are completely removed.
       One blank row remains at bottom.
    ========================================== */

      setRows([...cleanMedicines, emptyRow()]);

      /* ==========================================
       SMALL UI TRANSITION
    ========================================== */

      await new Promise((resolve) => setTimeout(resolve, 500));

      setApplyingTemplate(false);

      toast.success(
        `"${data.data?.name || template.name}" medicine template applied`,
      );
    } catch (error) {
      console.error("Load Medicine Template Error:", error);

      setApplyingTemplate(false);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to load medicine template",
      );
    }
  };

  useEffect(() => {
    if (!diagnosisTemplateOpen || !diagnosisTemplateSearch) return;

    const timer = setTimeout(() => {
      fetchDiagnosisTemplates(diagnosisTemplateSearch.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [diagnosisTemplateSearch, diagnosisTemplateOpen]);

  const handleSelectNoteTemplate = async (template) => {
    if (!template?._id) {
      toast.error("Invalid note template");
      return;
    }

    setApplyingTemplateName(template.name || "Clinical Note Template");
    setApplyingTemplate(true);
    handleCloseNoteTemplates();

    try {
      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/note-template/${template._id}`,
      );

      if (!data.success) {
        throw new Error(data.message || "Failed to load note template");
      }

      const note = data.data?.note;

      if (!hasClinicalNoteContent(note)) {
        throw new Error("This note template does not contain a clinical note");
      }

      setClinicalNote(DOMPurify.sanitize(note));
      toast.success(
        `"${data.data?.name || template.name || "Clinical Note"}" note template applied`,
      );
    } catch (error) {
      console.error("Apply Note Template Error:", error);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to load note template",
      );
    } finally {
      setApplyingTemplate(false);
    }
  };

  const handleSelectDiagnosisTemplate = async (template) => {
    try {
      /* ==========================================
       SHOW APPLYING LOADER
    ========================================== */

      setApplyingTemplateName(template.name || "Clinical Diagnosis Template");
      setApplyingTemplate(true);

      // Close diagnosis template popover
      handleCloseDiagnosisTemplates();

      /* ==========================================
       FETCH COMPLETE TEMPLATE
    ========================================== */

      const { data } = await axios.get(
        `${BASE_URL}api/doctor/prescription/clinical-diagnosis-template/${template._id}`,
        {
          headers: {},
        },
      );

      if (!data.success) {
        throw new Error(
          data.message || "Failed to load clinical diagnosis template",
        );
      }

      const templateDiagnosis = Array.isArray(data.data?.diagnosis)
        ? data.data.diagnosis
        : [];

      if (!templateDiagnosis.length) {
        throw new Error("This template does not contain any diagnosis");
      }

      /* ==========================================
       MERGE WITH EXISTING DIAGNOSIS
       - Keep manually entered diagnosis
       - Avoid duplicates
       - Case insensitive comparison
    ========================================== */

      /* Clear/replace existing diagnosis with template values */
      const cleanDiagnosis = [
        ...new Map(
          templateDiagnosis
            .filter((item) => typeof item === "string" && item.trim())
            .map((item) => [item.trim().toLowerCase(), item.trim()]),
        ).values(),
      ];

      setDiagnosis(cleanDiagnosis);

      /* ==========================================
       SMALL UI TRANSITION
    ========================================== */

      await new Promise((resolve) => setTimeout(resolve, 500));

      setApplyingTemplate(false);

      toast.success(
        `"${data.data?.name || template.name}" diagnosis template applied`,
      );
    } catch (error) {
      console.error("Apply Diagnosis Template Error:", error);

      setApplyingTemplate(false);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to apply diagnosis template",
      );
    }
  };

  const updateSaveProgress = (id, status, message = "") => {
    setSaveProgress((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              status,
              message,
            }
          : item,
      ),
    );
  };

  const [loadingDraft, setLoadingDraft] = useState(false);
  const [prescriptionId, setPrescriptionId] = useState(null);

  useEffect(() => {
    const patient = location.state?.selectedPatient;

    if (!patient) return;

    const loadPrescription = async () => {
      try {
        // Always set the selected patient
        setSelectedPatient(patient);

        /* ==========================================
         SET VITALS FROM PATIENT
      ========================================== */

        if (patient.hasVitals) {
          setVitals({
            height: patient.vitals?.height || "",
            weight: patient.vitals?.weight || "",
            pulse: patient.vitals?.pulse || "",
            bp: patient.vitals?.bp || "",
          });
        }

        /* ==========================================
         CHECK WHETHER DRAFT EXISTS
      ========================================== */

        const draftId = patient?.prescriptionId;

        if (!draftId || draftId === "null" || draftId === "undefined") {
          // No draft → just open normal blank prescription
          setPrescriptionId(null);
          return;
        }

        /* ==========================================
         GET DRAFT PRESCRIPTION
      ========================================== */

        setLoadingDraft(true);

        const { data } = await axios.get(
          `${BASE_URL}api/doctor/prescription/draft/${draftId}`,
        );

        if (!data?.success || !data?.data) {
          throw new Error(data?.message || "Failed to load draft prescription");
        }

        const prescription = data.data;

        console.log("Draft prescription:", prescription);

        /*
         * Keep the ID so it can be sent when saving.
         * This does NOT mean edit mode.
         */
        setPrescriptionId(
          prescription?._id || prescription?.prescriptionId || draftId,
        );

        /* ==========================================
         VITALS
      ========================================== */

        setVitals({
          height: prescription?.vitals?.height || "",
          weight: prescription?.vitals?.weight || "",
          pulse: prescription?.vitals?.pulse || "",
          bp: prescription?.vitals?.bp || "",
        });

        /* ==========================================
         CLINICAL NOTE
      ========================================== */

        setClinicalNote(prescription?.note || "");

        /* ==========================================
         SYMPTOMS
      ========================================== */

        setSymptoms(
          Array.isArray(prescription?.symptoms) ? prescription.symptoms : [],
        );

        /* ==========================================
         DIAGNOSIS
      ========================================== */

        setDiagnosis(
          Array.isArray(prescription?.diagnosis) ? prescription.diagnosis : [],
        );

        /* ==========================================
         INVESTIGATIONS
      ========================================== */

        setSelectedTests(
          Array.isArray(prescription?.investigations)
            ? prescription.investigations
                .map((item) => {
                  if (typeof item === "string") {
                    return item;
                  }

                  return (
                    item?.testName || item?.name || item?.testId?.testName || ""
                  );
                })
                .filter(Boolean)
            : [],
        );

        /* ==========================================
         MEDICINES
      ========================================== */

        const formattedMedicines = Array.isArray(prescription?.medicines)
          ? prescription.medicines
              .filter((item) => item?.medicine && item.medicine.trim())
              .map((item) => ({
                medicine: item.medicine.trim(),

                morning: String(item.morning ?? ""),
                afternoon: String(item.afternoon ?? ""),
                evening: String(item.evening ?? ""),
                night: String(item.night ?? ""),

                duration: String(item.duration ?? ""),

                durationType: item.durationType || "",

                note: item.note?.trim() || "",
              }))
          : [];

        /*
         * Keep one empty row at the bottom
         * so the doctor can continue adding medicines.
         */
        setRows([...formattedMedicines, emptyRow()]);

        /* ==========================================
         ADVICE
      ========================================== */

        setAdvices(
          Array.isArray(prescription?.advice)
            ? prescription.advice
            : Array.isArray(prescription?.advicePayload)
              ? prescription.advicePayload
              : [],
        );

        /* ==========================================
         REFERRED DOCTOR
      ========================================== */

        setReferredDoctor(prescription?.referredDoctor || "");

        /* ==========================================
         NEXT VISIT
      ========================================== */

        const nextVisit = prescription?.nextVisitDate;

        if (!nextVisit) {
          setNextVisitMode("after");
          setNextVisitValue("");
          setNextVisitUnit("days");
          setNextVisitDate("");
        } else {
          const afterMatch = String(nextVisit)
            .trim()
            .match(/^(\d+)\s*(days?|weeks?|months?)$/i);

          if (afterMatch) {
            setNextVisitMode("after");

            setNextVisitValue(afterMatch[1]);

            setNextVisitUnit(afterMatch[2].toLowerCase().replace(/s$/, ""));

            setNextVisitDate("");
          } else {
            // Specific date
            setNextVisitMode("date");
            setNextVisitDate(String(nextVisit).substring(0, 10));

            setNextVisitValue("");
            setNextVisitUnit("days");
          }
        }

        /* ==========================================
         CLEAR INPUT BOXES
      ========================================== */

        setSymptomInput("");
        setDiagnosisInput("");
        setInvestigationInput("");
        setAdviceInput("");

        /* ==========================================
         NORMAL PRESCRIPTION MODE
      ========================================== */

        // IMPORTANT:
        // Do NOT do:
        // setIsEditMode(true)

        setIsEditMode(false);
      } catch (error) {
        console.error("Load Draft Prescription Error:", error);

        toast.error(
          error.response?.data?.message ||
            error.message ||
            "Failed to load draft prescription",
        );
      } finally {
        setLoadingDraft(false);

        /*
         * Clear navigation state after processing.
         */
        navigate(location.pathname, {
          replace: true,
          state: null,
        });
      }
    };

    loadPrescription();
  }, [location.pathname, location.state, navigate]);

  useEffect(() => {
    if (location.state?.editMode && location.state?.prescriptionData) {
      const data = location.state.prescriptionData;

      setIsEditMode(true);

      /* ================= VITALS ================= */
      setVitals({
        height: data.vitals?.height || "",
        weight: data.vitals?.weight || "",
        pulse: data.vitals?.pulse || "",
        bp: data.vitals?.bp || "",
      });

      /* ================= SYMPTOMS ================= */
      // if (data.symptoms?.length) {
      //   setSymptomRows(
      //     data.symptoms.map((sym) => ({
      //       id: Date.now() + Math.random(),
      //       symptom: sym,
      //     })),
      //   );
      // }

      /* ================= MEDICINES ================= */
      if (data.medicines?.length) {
        setRows(data.medicines);
      }

      /* ================= INVESTIGATIONS ================= */
      if (data.investigations?.length) {
        const mappedTests = data.investigations.map((inv) => ({
          id: Date.now() + Math.random(),
          testName: inv.testName || inv.testId?.testName,
          testId: inv.testId?._id || null,
          dept: inv.testId?.testDept || "",
          category: "",
          price: inv.testId?.testPrice || "",
          isCustom: inv.isCustom || false,
        }));

        setSelectedEditPatient({ ...data.patient, appId: data.appId });

        mappedTests.push(emptyTestRow()); // add empty row at bottom
        setTestRows(mappedTests);
      }
    }
  }, [location.state]);

  const resetForm = () => {
    setSelectedPatient(null);

    setVitals({
      height: "",
      weight: "",
      pulse: "",
      bp: "",
    });

    // setSymptomRows([emptySymptomRow()]);
    setRows([emptyRow()]);
    setTestRows([emptyTestRow()]);
  };
  const handleCancel = () => {
    if (isEditMode) {
      // go back to previous page
      navigate(-1);
    } else {
      // reset form in create mode
      resetForm();
    }
  };

  const [vitals, setVitals] = useState({
    height: "",
    weight: "",
    pulse: "",
    bp: "",
  });

  // const [history, setHistory] = useState("");
  // const [selectedTests, setSelectedTests] = useState([]);
  const [prescriptionDetailView, setPrescriptionDetailView] = useState(null);
  const [symptoms, setSymptoms] = useState([]);
  const [symptomInput, setSymptomInput] = useState("");
  const symptomInputRef = useRef(null);

  const [diagnosis, setDiagnosis] = useState([]);
  const [diagnosisInput, setDiagnosisInput] = useState("");
  const diagnosisInputRef = useRef(null);

  const [editingInvestigationIndex, setEditingInvestigationIndex] =
    useState(null);

  const handleEditInvestigation = (index) => {
    const value = selectedTests[index];

    if (!value) return;

    setEditingInvestigationIndex(index);
    setInvestigationInput(value);

    // Remove old chip while editing
    setSelectedTests((prev) => prev.filter((_, i) => i !== index));

    setTimeout(() => {
      investigationInputRef.current?.focus();

      const input = investigationInputRef.current;

      if (input) {
        input.setSelectionRange(value.length, value.length);
      }
    }, 50);
  };

  useEffect(() => {
    const query = symptomInput.trim();

    // Don't call API when input is empty
    if (!query) {
      setSymptomSuggestions([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setSymptomLoading(true);

        const { data } = await axios.get(
          `${BASE_URL}api/doctor/prescription/patient-symptoms/search`,
          {
            params: {
              query,
            },
          },
        );

        if (data.success) {
          setSymptomSuggestions(data.data || []);
        }
      } catch (error) {
        console.error("Search Symptoms Error:", error);

        setSymptomSuggestions([]);
      } finally {
        setSymptomLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [symptomInput]);

  const addSymptom = (value) => {
    if (typeof value !== "string") return;

    const symptom = value.trim();

    if (!symptom) return;

    setSymptoms((prev) => {
      const alreadyExists = prev.some(
        (item) => item.trim().toLowerCase() === symptom.toLowerCase(),
      );

      if (alreadyExists) {
        return prev;
      }

      return [...prev, symptom];
    });

    setSymptomInput("");
    setSymptomSuggestions([]);
  };

  const addDiagnosis = (value) => {
    if (typeof value !== "string") return;

    const diagnosisValue = value.trim();

    if (!diagnosisValue) return;

    setDiagnosis((prev) => {
      const alreadyExists = prev.some(
        (item) => item.trim().toLowerCase() === diagnosisValue.toLowerCase(),
      );

      if (alreadyExists) {
        return prev;
      }

      return [...prev, diagnosisValue];
    });

    setDiagnosisInput("");
    setDiagnosisSuggestions([]);
  };

  const handleEditDiagnosis = (index) => {
    const value = diagnosis[index];

    setEditingDiagnosisIndex(index);
    setDiagnosisInput(value);

    // Remove the old chip temporarily
    setDiagnosis((prev) => prev.filter((_, i) => i !== index));

    setTimeout(() => {
      diagnosisInputRef.current?.focus();

      // Move cursor to the end
      const input = diagnosisInputRef.current;
      if (input) {
        input.setSelectionRange(value.length, value.length);
      }
    }, 50);
  };

  const handleEditSymptoms = (index) => {
    const value = symptoms[index];

    if (!value) return;

    setEditingSymptomsIndex(index);
    setSymptomInput(value);

    // Remove the old chip temporarily
    setSymptoms((prev) => prev.filter((_, i) => i !== index));

    setTimeout(() => {
      symptomInputRef.current?.focus();

      const input = symptomInputRef.current;

      if (input) {
        input.setSelectionRange(value.length, value.length);
      }
    }, 50);
  };

  const handleDiagnosisKeyDown1 = (event) => {
    if (event.key === "Enter" && diagnosisPopupOpen) {
      return;
    }

    if ((event.key === "Enter" || event.key === ",") && diagnosisInput.trim()) {
      event.preventDefault();

      addDiagnosis(diagnosisInput.trim());

      return;
    }

    if (event.key === "Backspace" && !diagnosisInput && diagnosis.length > 0) {
      event.preventDefault();

      removeDiagnosis(diagnosis.length - 1);

      return;
    }
  };

  const handleDiagnosisKeyDown = (event) => {
    // Let Autocomplete handle the highlighted suggestion
    if (event.key === "Enter" && diagnosisPopupOpen) {
      return;
    }

    const value = diagnosisInput.trim();

    /* ==========================================
     Enter / Comma
     ========================================== */
    if ((event.key === "Enter" || event.key === ",") && value) {
      event.preventDefault();

      // Editing an existing diagnosis
      if (editingDiagnosisIndex !== null) {
        setDiagnosis((prev) => {
          const updated = [...prev];

          updated.splice(editingDiagnosisIndex, 0, value);

          return updated;
        });

        setEditingDiagnosisIndex(null);
        setDiagnosisInput("");

        return;
      }

      // Adding a new diagnosis
      addDiagnosis(value);

      setDiagnosisInput("");

      return;
    }

    /* ==========================================
     Backspace
     ========================================== */
    if (event.key === "Backspace" && !diagnosisInput && diagnosis.length > 0) {
      event.preventDefault();

      removeDiagnosis(diagnosis.length - 1);

      return;
    }
  };

  const removeDiagnosis = (index) => {
    setDiagnosis((prev) =>
      prev.filter((_, currentIndex) => currentIndex !== index),
    );
  };

  const removeSymptoms = (index) => {
    setSymptoms((prev) =>
      prev.filter((_, currentIndex) => currentIndex !== index),
    );
  };

  const handleSymptomKeyDown = (event) => {
    // Let Autocomplete handle highlighted suggestion
    if (event.key === "Enter" && symptomPopupOpen) {
      return;
    }

    const value = symptomInput.trim();

    if (event.key === "Enter" && value) {
      event.preventDefault();

      /* =========================
       EDIT EXISTING SYMPTOM
    ========================= */
      if (editingSymptomsIndex !== null) {
        setSymptoms((prev) => {
          const updated = [...prev];

          // Since the old chip was removed,
          // insert it back at its original position.
          updated.splice(editingSymptomsIndex, 0, value);

          return updated;
        });

        setEditingSymptomsIndex(null);
        setSymptomInput("");
        setSymptomSuggestions([]);

        return;
      }

      /* =========================
       ADD NEW SYMPTOM
    ========================= */
      addSymptom(value);

      return;
    }

    /* =========================
     BACKSPACE
  ========================= */
    if (event.key === "Backspace" && !symptomInput && symptoms.length) {
      event.preventDefault();

      removeSymptom(symptoms.length - 1);
    }
  };

  const removeSymptom = (index) => {
    setSymptoms((prev) => prev.filter((_, i) => i !== index));
  };

  const searchMedicinesFromAPI = async (keyword, rowIndex) => {
    try {
      setMedicineSearch(keyword); // 👈 keep typed text in modal

      if (!keyword.trim()) {
        setMedicineResults([]);
        setMedicineModalOpen(false);
        return;
      }

      const res = await axios.get(
        `${BASE_URL}api/doctor/prescription/search-medicine?keyword=${keyword}`,
        {
          headers: {},
        },
      );

      setMedicineResults(res.data.data || []);
      setMedicineModalOpen(true);
      setDialogRowIndex(rowIndex);
      setMedicineHighlightIndex(0);
    } catch (err) {
      console.error("Medicine search error", err);
    }
  };

  const [advices, setAdvices] = useState([]);
  const [adviceInput, setAdviceInput] = useState("");
  const adviceInputRef = useRef(null);
  const [adviceSuggestions, setAdviceSuggestions] = useState([]);
  const [adviceLoading, setAdviceLoading] = useState(false);

  const investigationInputRef = useRef(null);

  const [nextVisitMode, setNextVisitMode] = useState("after");
  const [nextVisitValue, setNextVisitValue] = useState("");
  const [nextVisitUnit, setNextVisitUnit] = useState("days");
  const [nextVisitDate, setNextVisitDate] = useState("");

  const [referredDoctor, setReferredDoctor] = useState("");

  const addAdvice = (value) => {
    if (typeof value !== "string") return;

    const advice = value.trim();

    if (!advice) return;

    setAdvices((prev) => {
      const alreadyExists = prev.some(
        (item) => item.trim().toLowerCase() === advice.toLowerCase(),
      );

      if (alreadyExists) {
        return prev;
      }

      return [...prev, advice];
    });

    setAdviceInput("");
    setAdviceSuggestions([]);
  };

  const handleAdviceKeyDown = (event) => {
    // Let Autocomplete handle highlighted suggestion
    if (event.key === "Enter" && advicePopupOpen) {
      return;
    }

    const value = adviceInput.trim();

    if (event.key === "Enter" && value) {
      event.preventDefault();

      /* =========================
       EDIT EXISTING SYMPTOM
    ========================= */
      if (editingAdviceIndex !== null) {
        setAdvices((prev) => {
          const updated = [...prev];

          // Since the old chip was removed,
          // insert it back at its original position.
          updated.splice(editingAdviceIndex, 0, value);

          return updated;
        });

        setEditingAdviceIndex(null);
        setAdviceInput("");
        setAdviceSuggestions([]);

        return;
      }

      /* =========================
       ADD NEW ADVICE
    ========================= */
      addAdvice(value);

      return;
    }

    /* =========================
     BACKSPACE
  ========================= */
    if (event.key === "Backspace" && !adviceInput && advices.length) {
      event.preventDefault();

      removeAdvice(advices.length - 1);
    }
  };

  const removeAdvice = (index) => {
    setAdvices((prev) => prev.filter((_, i) => i !== index));
  };

  // const handleSymptomChange = (value, index) => {
  //   const updated = [...symptomRows];
  //   updated[index].symptom = value;
  //   setSymptomRows(updated);
  // };

  // const handleSymptomKeyDown = (e, index) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();

  //     // add new row
  //     setSymptomRows((prev) => [...prev, emptySymptomRow()]);

  //     // focus next row
  //     setTimeout(() => {
  //       symptomInputRefs.current[index + 1]?.focus();
  //     }, 50);
  //   }

  //   // delete empty row
  //   if (e.key === "Backspace" && !symptomRows[index].symptom) {
  //     e.preventDefault();

  //     setSymptomRows((prev) => {
  //       const updated = prev.filter((_, i) => i !== index);
  //       return updated.length ? updated : [emptySymptomRow()];
  //     });

  //     setTimeout(() => {
  //       symptomInputRefs.current[index - 1]?.focus();
  //     }, 50);
  //   }
  // };

  useEffect(() => {
    setTimeout(() => {
      patientInputRef.current?.focus();
    }, 0);
  }, []);

  /* ---------- Focus new row ---------- */
  useEffect(() => {
    if (focusRowIndex !== null) {
      setTimeout(() => {
        inputRefs.current[focusRowIndex]?.[0]?.focus();
      }, 0);
      setFocusRowIndex(null);
    }
  }, [rows, focusRowIndex]);

  /* ---------- Focus after delete ---------- */
  useEffect(() => {
    if (focusAfterDelete) {
      const { row, col } = focusAfterDelete;
      setTimeout(() => {
        inputRefs.current[row]?.[col]?.focus();
      }, 0);
      setFocusAfterDelete(null);
    }
  }, [rows, focusAfterDelete]);

  const updateCell = (rowIndex, field, value) => {
    setRows((prev) => {
      const updated = [...prev];
      updated[rowIndex][field] = value;
      return updated;
    });
  };

  /* ---------- TABLE KEYBOARD HANDLING ---------- */
  const handleTableKeyDown = (e, rowIndex, colIndex, field) => {
    if (openDialog) return;

    /* 🗑 Delete row on Backspace/Delete (only if row empty) */
    /* 🗑 Delete row ONLY on Shift + Backspace */
    if (e.key === "Backspace" && e.shiftKey) {
      e.preventDefault();

      const confirmDelete = window.confirm("Delete this medicine row?");
      if (!confirmDelete) return;

      setRows((prev) => {
        const updated = prev.filter((_, i) => i !== rowIndex);
        return updated.length ? updated : [emptyRow()];
      });

      const targetRow = rowIndex > 0 ? rowIndex - 1 : 0;

      setTimeout(() => {
        inputRefs.current[targetRow]?.[colIndex]?.focus();
      }, 50);

      return;
    }

    /* ⬆️⬇️ Row navigation */
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      const targetRow = e.key === "ArrowDown" ? rowIndex + 1 : rowIndex - 1;

      inputRefs.current[targetRow]?.[colIndex]?.focus();
      return;
    }

    /* ⬅️➡️ Column navigation */
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
      e.preventDefault();
      const targetCol = e.key === "ArrowRight" ? colIndex + 1 : colIndex - 1;

      inputRefs.current[rowIndex]?.[targetCol]?.focus();
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();

      /* MEDICINE FIELD */
      if (field === "medicine") {
        const value = rows[rowIndex][field];

        // Prevent Enter if medicine empty
        if (!value || value.trim() === "") {
          return;
        }

        // Move to next column (morning)
        inputRefs.current[rowIndex]?.[colIndex + 1]?.focus();
        return;
      }

      /* durationType → open dialog */
      if (field === "durationType") {
        setDialogField(field);
        setDialogRowIndex(rowIndex);
        setDialogSearch(rows[rowIndex][field] || "");
        setHighlightIndex(0);
        setOpenDialog(true);
        return;
      }

      /* NOTE FIELD */
      if (field === "note") {
        const nextRow = rowIndex + 1;

        if (rowIndex === rows.length - 1) {
          setRows((prev) => [...prev, emptyRow()]);
        }

        setTimeout(() => {
          inputRefs.current[nextRow]?.[0]?.focus();
        }, 50);

        return;
      }

      /* Normal move */
      inputRefs.current[rowIndex]?.[colIndex + 1]?.focus();
    }
  };

  /* ---------- Open dialog on typing ---------- */
  const handleTyping = (e, rowIndex, field) => {
    const value = e.target.value;
    updateCell(rowIndex, field, value);

    /* 💊 MEDICINE SEARCH FROM API */
    if (field === "medicine") {
      searchMedicinesFromAPI(value, rowIndex);
      return;
    }

    /* 📅 durationType dialog */
    if (field === "durationType") {
      setDialogField(field);
      setDialogRowIndex(rowIndex);
      setDialogSearch(value);
      setHighlightIndex(0);
      setOpenDialog(true);
    }
  };

  /* ---------- Dialog keyboard navigation ---------- */
  const handleDialogKeyDown = (e, options) => {
    if (!options.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((i) => (i < options.length - 1 ? i + 1 : i));
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((i) => (i > 0 ? i - 1 : 0));
    }

    if (e.key === "Enter") {
      e.preventDefault();
      handleDialogSelect(options[highlightIndex]);
    }

    if (e.key === "Escape") {
      e.preventDefault();
      setOpenDialog(false);
    }
  };

  /* ---------- Select from Dialog ---------- */
  const handleDialogSelect = (value) => {
    setSuppressDialogOpen(true);
    updateCell(dialogRowIndex, dialogField, value);
    setOpenDialog(false);

    setTimeout(() => {
      // after selecting medicine → go to morning column
      if (dialogField === "medicine") {
        inputRefs.current[dialogRowIndex]?.[1]?.focus();
      }

      // after selecting durationType → go to NOTE column
      if (dialogField === "durationType") {
        const noteColIndex = fields.indexOf("note");
        inputRefs.current[dialogRowIndex]?.[noteColIndex]?.focus();
      }

      setSuppressDialogOpen(false);
    }, 50);
  };

  const handleInvestigationKeyDown = (event) => {
    // Let Autocomplete handle highlighted suggestion
    if (event.key === "Enter" && investigationPopupOpen) {
      return;
    }

    const value = investigationInput.trim();

    /* ==========================================
     Enter / Comma
  ========================================== */
    if ((event.key === "Enter" || event.key === ",") && value) {
      event.preventDefault();

      /* Editing existing investigation */
      if (editingInvestigationIndex !== null) {
        setSelectedTests((prev) => {
          const updated = [...prev];

          updated.splice(editingInvestigationIndex, 0, value);

          return updated;
        });

        setEditingInvestigationIndex(null);
        setInvestigationInput("");

        return;
      }

      /* Add new investigation */
      addInvestigation(value);

      setInvestigationInput("");

      return;
    }

    /* ==========================================
     Backspace
  ========================================== */
    if (
      event.key === "Backspace" &&
      !investigationInput &&
      selectedTests.length > 0
    ) {
      event.preventDefault();

      removeInvestigation(selectedTests.length - 1);

      return;
    }
  };

  const removeInvestigation = (index) => {
    setSelectedTests((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  };

  const dialogOptions = dialogField === "durationType" ? durationTypes : [];

  const filteredOptions = dialogOptions.filter((opt) =>
    opt.toLowerCase().includes(dialogSearch.toLowerCase()),
  );

  const [testHeaders, setTestHeaders] = useState([]);
  const [testNameList, setTestNameList] = useState([]);
  // const fetchTestHeaders = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${BASE_URL}api/doctor/common/test-header`,
  //       {
  //         headers: {},
  //       },
  //     );
  //     setTestHeaders(response.data.data);
  //   } catch (error) {
  //     console.error("Error fetching test headers:", error);
  //   } finally {
  //   }
  // };

  const [selectedTests, setSelectedTests] = useState([]);

  const emptyTestRow = () => ({
    id: Date.now(),
    testName: "",
    testId: null,
    dept: "",
    category: "",
    price: "",
    isCustom: false,
  });

  const [testRows, setTestRows] = useState([emptyTestRow()]);

  const [modalOpen, setModalOpen] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [search, setSearch] = useState("");
  const [filteredTests, setFilteredTests] = useState([]);
  const [testHighlightIndex, setTestHighlightIndex] = useState(0);
  const testInputRefs = useRef([]);

  useEffect(() => {
    if (activeTab === 1) {
      setTimeout(() => {
        testInputRefs.current[0]?.focus();
      }, 100);
    }
  }, [activeTab]);
  useEffect(() => {
    const lastIndex = testRows.length - 1;
    testInputRefs.current[lastIndex]?.focus();
  }, [testRows]);

  useEffect(() => {
    const result = testHeaders.filter((t) =>
      t.testName.toLowerCase().includes(search.toLowerCase()),
    );
    setFilteredTests(result);
    setTestHighlightIndex(0);
  }, [search, testHeaders]);

  const handleTestTyping = (value, rowIndex) => {
    const updated = [...testRows];
    updated[rowIndex].testName = value;
    updated[rowIndex].isCustom = true;
    setTestRows(updated);

    setSearch(value);
    setActiveRowIndex(rowIndex);
    setModalOpen(true);
  };

  // Select test
  const selectTest = (testObj) => {
    const updatedRows = [...testRows];

    updatedRows[activeRowIndex] = {
      ...updatedRows[activeRowIndex],
      testName: testObj.testName,
      testId: testObj._id,
      dept: testObj.testDept,
      category: testObj.testCat,
      price: testObj.testPrice,
      isCustom: false,
    };

    if (activeRowIndex === testRows.length - 1) {
      updatedRows.push(emptyTestRow());
    }

    setTestRows(updatedRows);
    setModalOpen(false);
    setSearch("");

    setTimeout(() => {
      testInputRefs.current[activeRowIndex + 1]?.focus();
    }, 50);
  };

  const acceptManualTest = () => {
    if (!search.trim()) return;

    const updatedRows = [...testRows];

    updatedRows[activeRowIndex] = {
      ...updatedRows[activeRowIndex],
      testName: search,
      testId: null,
      dept: "",
      category: "",
      price: "",
      isCustom: true,
    };

    if (activeRowIndex === testRows.length - 1) {
      updatedRows.push(emptyTestRow());
    }

    setTestRows(updatedRows);
    setModalOpen(false);
    setSearch("");

    setTimeout(() => {
      testInputRefs.current[activeRowIndex + 1]?.focus();
    }, 50);
  };

  // Keyboard navigation inside modal
  const handleTestModalKeyDown = (e) => {
    if (!modalOpen) return;

    if (e.key === "ArrowDown") {
      setTestHighlightIndex((prev) =>
        prev < filteredTests.length - 1 ? prev + 1 : prev,
      );
    }

    if (e.key === "ArrowUp") {
      setTestHighlightIndex((prev) => (prev > 0 ? prev - 1 : 0));
    }

    if (e.key === "Enter") {
      e.preventDefault();

      if (filteredTests.length > 0) {
        selectTest(filteredTests[testHighlightIndex]);
      } else {
        acceptManualTest();
      }
    }

    if (e.key === "Escape") {
      setModalOpen(false);
    }
  };

  const buildPrescriptionPayload = () => {
    /* ---------- Vitals ---------- */
    const vitalsPayload = {
      height: vitals.height || "",
      weight: vitals.weight || "",
      pulse: vitals.pulse || "",
      bp: vitals.bp || "",
    };

    const notePayload = clinicalNote;

    const symptomsPayload = symptoms;
    const diagnosisPayload = diagnosis;
    const investigationsPayload = selectedTests;

    const medicinesPayload = rows
      .filter((row) => !isRowEmpty(row))
      .map((row) => ({
        medicine: row.medicine,
        morning: row.morning,
        afternoon: row.afternoon,
        evening: row.evening,
        night: row.night,
        duration: row.duration,
        durationType: row.durationType,
        note: row.note,
      }));

    const advicePayload = advices;
    const nextVisit = nextVisitValue + " " + nextVisitUnit;
    let nextVisitDatePayload = null;
    if (nextVisitMode === "after" && nextVisitValue !== "") {
      nextVisitDatePayload = nextVisit;
    } else if (nextVisitMode === "date" && nextVisitDate !== "") {
      nextVisitDatePayload = nextVisitDate;
    }
    const referredDoctorPayload = referredDoctor;

    /* ---------- FINAL ---------- */
    return {
      patientId: selectedPatient?.patientId || null,
      appointmentMongoId: selectedPatient?.appointmentMongoId,
      vitals: vitalsPayload,
      note: notePayload,
      symptoms: symptomsPayload,
      diagnosis: diagnosisPayload,
      investigations: investigationsPayload,
      medicines: medicinesPayload,
      advices: advicePayload,
      nextVisitDate: nextVisitDatePayload,
      referredDoctor: referredDoctorPayload,
    };
  };

  const resetPrescriptionForm = () => {
    setSelectedPatient(null);
    /* =========================
     Vitals
  ========================= */
    setVitals({
      height: "",
      weight: "",
      pulse: "",
      bp: "",
    });

    setClinicalNote("");

    /* =========================
     Symptoms
  ========================= */
    setSymptoms([]);
    setSymptomInput("");

    /* =========================
     Diagnosis
  ========================= */
    setDiagnosis([]);
    setDiagnosisInput("");

    /* =========================
     Investigations
  ========================= */
    setSelectedTests([]);

    /* =========================
     Medicines
  ========================= */
    setRows([emptyRow()]);

    /* =========================
     Advice
  ========================= */
    setAdvices([]);
    setAdviceInput("");

    /* =========================
     Next Visit
  ========================= */
    setNextVisitValue("");
    setNextVisitUnit("days");
    setNextVisitDate("");

    /* =========================
     Referred Doctor
  ========================= */
    setReferredDoctor("");

    /* =========================
     Tabs
  ========================= */
    setActiveTab(0);

    /* =========================
     Prescription payload
  ========================= */
    setPendingPrescriptionPayload(null);

    /* =========================
     Template Selection
  ========================= */
    setTemplateSelections({
      diagnosis: {
        selected: false,
        name: "",
      },
      note: {
        selected: false,
        name: "",
      },
      investigation: {
        selected: false,
        name: "",
      },
      medicine: {
        selected: false,
        name: "",
      },
      advice: {
        selected: false,
        name: "",
      },
      prescription: {
        selected: false,
        name: "",
      },
    });

    /* =========================
     Template Detail View
  ========================= */
    setPrescriptionDetailView(null);
  };
  const handleFinalSavePrescription = async () => {
    const payload = pendingPrescriptionPayload;
    console.log(payload);

    if (!payload) {
      toast.error("Prescription data not found");
      return;
    }

    if (
      templateSelections.note.selected &&
      !hasClinicalNoteContent(payload.note)
    ) {
      toast.error("Add a clinical note before saving it as a template");
      return;
    }

    /* ==========================================
     Validate Template Names
  ========================================== */
    for (const [type, template] of Object.entries(templateSelections)) {
      if (template.selected && !template.name.trim()) {
        toast.error(`Enter a name for the ${type} template`);
        return;
      }
    }

    /* ==========================================
     Build Progress Items
  ========================================== */

    const progressItems = [
      {
        id: "prescription",
        label: "Prescription",
        status: "pending",
      },

      {
        id: "master",
        label: "Clinical Master Data",
        status: "pending",
      },
    ];

    if (templateSelections.diagnosis.selected) {
      progressItems.push({
        id: "diagnosis",
        label: "Clinical Diagnosis Template",
        status: "pending",
      });
    }

    if (templateSelections.note.selected) {
      progressItems.push({
        id: "note",
        label: "Clinical Note Template",
        status: "pending",
      });
    }

    if (templateSelections.investigation.selected) {
      progressItems.push({
        id: "investigation",
        label: "Investigation Template",
        status: "pending",
      });
    }

    if (templateSelections.medicine.selected) {
      progressItems.push({
        id: "medicine",
        label: "Medicine Template",
        status: "pending",
      });
    }

    if (templateSelections.advice.selected) {
      progressItems.push({
        id: "advice",
        label: "Advice Template",
        status: "pending",
      });
    }

    if (templateSelections.prescription.selected) {
      progressItems.push({
        id: "prescriptionTemplate",
        label: "Entire Prescription Template",
        status: "pending",
      });
    }

    setSaveProgress(progressItems);

    // close template selection dialog
    setTemplateDialogOpen(false);

    // open saving dialog
    setSaveProgressOpen(true);

    try {
      /* ==========================================
       1. SAVE PRESCRIPTION
    ========================================== */

      updateSaveProgress("prescription", "saving");

      const { data } = await axios.post(
        `${BASE_URL}api/doctor/prescription/create`,
        payload,
        {
          headers: {},
        },
      );

      if (!data.success) {
        updateSaveProgress(
          "prescription",
          "error",
          data.message || "Failed to save",
        );

        toast.error(data.message || "Failed to save prescription");
        return;
      }

      updateSaveProgress("prescription", "success", "Prescription saved");

      /* ==========================================
       2. SAVE MASTER DATA
    ========================================== */

      updateSaveProgress("master", "saving");

      const masterRequests = [];

      (payload.symptoms || [])
        .filter((name) => name?.trim())
        .forEach((name) => {
          masterRequests.push(
            axios.post(`${BASE_URL}api/doctor/prescription/patient-symptom`, {
              name: name.trim(),
            }),
          );
        });

      (payload.diagnosis || [])
        .filter((name) => name?.trim())
        .forEach((name) => {
          masterRequests.push(
            axios.post(
              `${BASE_URL}api/doctor/prescription/clinical-diagnosis`,
              {
                name: name.trim(),
              },
            ),
          );
        });

      (payload.investigations || [])
        .filter((name) => name?.trim())
        .forEach((name) => {
          masterRequests.push(
            axios.post(`${BASE_URL}api/doctor/prescription/investigation`, {
              name: name.trim(),
            }),
          );
        });

      (payload.advices || [])
        .filter((name) => name?.trim())
        .forEach((name) => {
          masterRequests.push(
            axios.post(`${BASE_URL}api/doctor/prescription/advice`, {
              name: name.trim(),
            }),
          );
        });

      await Promise.allSettled(masterRequests);

      updateSaveProgress("master", "success", "Master data updated");

      /* ==========================================
       3. TEMPLATE REQUESTS
    ========================================== */

      const templateTasks = [];

      /* Clinical Diagnosis */
      if (templateSelections.diagnosis.selected) {
        templateTasks.push({
          id: "diagnosis",

          request: () =>
            axios.post(
              `${BASE_URL}api/doctor/prescription/clinical-diagnosis-template`,
              {
                name: templateSelections.diagnosis.name.trim(),
                diagnosis: payload.diagnosis || [],
              },
            ),
        });
      }

      /* Clinical Note */
      if (templateSelections.note.selected) {
        templateTasks.push({
          id: "note",

          request: () =>
            axios.post(`${BASE_URL}api/doctor/prescription/note-template`, {
              name: templateSelections.note.name.trim(),
              note: payload.note || "",
            }),
        });
      }

      /* Investigation */
      if (templateSelections.investigation.selected) {
        templateTasks.push({
          id: "investigation",

          request: () =>
            axios.post(
              `${BASE_URL}api/doctor/prescription/investigation-template`,
              {
                name: templateSelections.investigation.name.trim(),
                investigations: payload.investigations || [],
              },
            ),
        });
      }

      /* Medicine */
      if (templateSelections.medicine.selected) {
        templateTasks.push({
          id: "medicine",

          request: () =>
            axios.post(`${BASE_URL}api/doctor/prescription/medicine-template`, {
              name: templateSelections.medicine.name.trim(),
              medicines: payload.medicines || [],
            }),
        });
      }

      /* Advice */
      if (templateSelections.advice.selected) {
        templateTasks.push({
          id: "advice",

          request: () =>
            axios.post(`${BASE_URL}api/doctor/prescription/advice-template`, {
              name: templateSelections.advice.name.trim(),
              advice: payload.advicePayload || [],
            }),
        });
      }

      /* Entire Prescription */
      if (templateSelections.prescription.selected) {
        templateTasks.push({
          id: "prescriptionTemplate",

          request: () =>
            axios.post(
              `${BASE_URL}api/doctor/prescription/prescription-template`,
              {
                name: templateSelections.prescription.name.trim(),
                note: payload.note || "",
                symptoms: payload.symptoms || [],
                diagnosis: payload.diagnosis || [],
                investigations: payload.investigations || [],
                medicines: payload.medicines || [],
                advice: payload.advicePayload || [],
              },
            ),
        });
      }

      /* ==========================================
       4. SAVE TEMPLATES INDIVIDUALLY
    ========================================== */

      for (const task of templateTasks) {
        updateSaveProgress(task.id, "saving");

        try {
          await task.request();

          updateSaveProgress(task.id, "success", "Template saved");
        } catch (error) {
          console.error(`${task.id} template error:`, error);

          updateSaveProgress(
            task.id,
            "error",
            error.response?.data?.message || "Failed to save template",
          );
        }
      }

      /* ==========================================
       5. COMPLETE
    ========================================== */

      toast.success("Prescription saved successfully");

      // Keep success states visible briefly
      await new Promise((resolve) => setTimeout(resolve, 1200));

      resetPrescriptionForm();
      navigate("/dashboard/patient");
    } catch (error) {
      console.error("Save Prescription Error:", error);

      updateSaveProgress(
        "prescription",
        "error",
        error.response?.data?.message || "Failed to save",
      );

      toast.error(
        error.response?.data?.message ||
          "Something went wrong while saving prescription",
      );
    }
  };
  const handleSubmitPrescription = () => {
    const payload = buildPrescriptionPayload();

    if (!payload.patientId) {
      toast.error("Select patient first");
      return;
    }

    setPendingPrescriptionPayload(payload);

    // Reset template selections every time dialog opens
    setTemplateSelections({
      diagnosis: {
        selected: false,
        name: "",
      },
      note: {
        selected: false,
        name: "",
      },
      investigation: {
        selected: false,
        name: "",
      },
      medicine: {
        selected: false,
        name: "",
      },
      advice: {
        selected: false,
        name: "",
      },
      prescription: {
        selected: false,
        name: "",
      },
    });

    setTemplateDialogOpen(true);
  };

  const [savingDraft, setSavingDraft] = useState(false);
  const handleSavePrescriptionAsDraft = async () => {
    const payload = pendingPrescriptionPayload;

    if (!payload) {
      toast.error("Prescription data not found");
      return;
    }

    try {
      setSavingDraft(true);

      const { data } = await axios.post(
        `${BASE_URL}api/doctor/prescription/hold`,
        payload,
      );

      if (!data.success) {
        toast.error(data.message || "Failed to save prescription as draft");
        return;
      }

      toast.success("Prescription saved as draft");

      setHoldDialogOpen(false);
      setPendingPrescriptionPayload(null);

      resetPrescriptionForm();

      navigate("/dashboard/patient");
    } catch (error) {
      console.error("Save Prescription Draft Error:", error);

      toast.error(
        error.response?.data?.message ||
          "Something went wrong while saving prescription as draft",
      );
    } finally {
      setSavingDraft(false);
    }
  };

  const handlePrintHeldInvestigations = () => {
    const payload = pendingPrescriptionPayload;
    const investigations = Array.isArray(payload?.investigations)
      ? payload.investigations
          .map((item) =>
            typeof item === "string"
              ? item.trim()
              : String(item?.testName || item?.name || "").trim(),
          )
          .filter(Boolean)
      : [];

    if (!investigations.length) {
      toast.info("Add an advised investigation before printing");
      return;
    }

    const patient = selectedPatient || {};
    const age = patient.dob
      ? Math.max(
          0,
          new Date().getFullYear() - new Date(patient.dob).getFullYear(),
        )
      : "—";
    const patientDetails = [
      ["Patient Name", patient.name || "—"],
      ["Patient ID", patient.patientId || patient.appointmentId || "—"],
      ["Age / Gender", `${age}${patient.gender ? ` / ${patient.gender}` : ""}`],
      ["Mobile", patient.mobile || "—"],
      ["Appointment ID", patient.appointmentId || "—"],
      ["Printed On", new Date().toLocaleString()],
    ];

    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      toast.error("Unable to open the print window. Please allow pop-ups.");
      return;
    }

    printWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Advised Investigations</title>
          <style>
            @page { margin: 18mm; }
            * { box-sizing: border-box; }
            body {
              margin: 0;
              color: #0f172a;
              font-family: Arial, Helvetica, sans-serif;
              font-size: 12px;
            }
            .header { border-bottom: 2px solid #2563eb; padding-bottom: 12px; }
            .title { margin: 0; color: #1d4ed8; font-size: 20px; font-weight: 700; }
            .subtitle { margin: 4px 0 0; color: #64748b; font-size: 12px; }
            .patient-info {
              display: grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 10px 24px;
              margin: 18px 0 24px;
              padding: 14px;
              border: 1px solid #bfdbfe;
              border-radius: 8px;
              background: #eff6ff;
            }
            .patient-item { display: flex; gap: 6px; min-width: 0; }
            .label { color: #475569; font-weight: 700; white-space: nowrap; }
            .value { color: #0f172a; overflow-wrap: anywhere; }
            .section-title {
              margin: 0 0 10px;
              color: #0f172a;
              font-size: 15px;
              font-weight: 700;
            }
            ol { margin: 0; padding-left: 22px; }
            li { padding: 9px 10px; border-bottom: 1px solid #e2e8f0; }
            li:first-child { border-top: 1px solid #e2e8f0; }
            .footer { margin-top: 30px; color: #94a3b8; font-size: 10px; }
            @media print { .no-print { display: none; } }
          </style>
        </head>
        <body>
          <header class="header">
            <h1 class="title">Advised Investigations</h1>
            <p class="subtitle">Pending prescription</p>
          </header>
          <section class="patient-info">
            ${patientDetails
              .map(
                ([label, value]) => `
                  <div class="patient-item">
                    <span class="label">${escapeHtml(label)}:</span>
                    <span class="value">${escapeHtml(value)}</span>
                  </div>`,
              )
              .join("")}
          </section>
          <main>
            <h2 class="section-title">Investigations</h2>
            <ol>
              ${investigations.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}
            </ol>
          </main>
          <p class="footer">This is an investigation request from a pending prescription.</p>
          <script>window.onload = () => window.print();</script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleHoldPrescription = () => {
    const payload = buildPrescriptionPayload();

    if (!payload.patientId) {
      toast.error("Select patient first");
      return;
    }

    setPendingPrescriptionPayload(payload);

    // Reset template selections every time dialog opens
    setTemplateSelections({
      diagnosis: {
        selected: false,
        name: "",
      },
      note: {
        selected: false,
        name: "",
      },
      investigation: {
        selected: false,
        name: "",
      },
      medicine: {
        selected: false,
        name: "",
      },
      advice: {
        selected: false,
        name: "",
      },
      prescription: {
        selected: false,
        name: "",
      },
    });

    setHoldDialogOpen(true);
  };

  const isSaveProcessComplete =
    saveProgress.length > 0 &&
    saveProgress.every(
      (item) => item.status === "success" || item.status === "error",
    );

  useEffect(() => {
    const query = diagnosisInput.trim();

    if (!query) {
      setDiagnosisSuggestions([]);
      setDiagnosisLoading(false);
      return;
    }

    const controller = new AbortController();

    const timer = setTimeout(async () => {
      try {
        setDiagnosisLoading(true);

        const { data } = await axios.get(
          `${BASE_URL}api/doctor/prescription/clinical-diagnosis/search`,
          {
            params: {
              query,
            },
            signal: controller.signal,
          },
        );

        if (data.success) {
          const selectedNames = new Set(
            diagnosis.map((item) => item.trim().toLowerCase()),
          );

          const suggestions = (data.data || []).filter(
            (item) =>
              typeof item === "string" &&
              item.trim() &&
              !selectedNames.has(item.trim().toLowerCase()),
          );

          setDiagnosisSuggestions(suggestions);
        } else {
          setDiagnosisSuggestions([]);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.code !== "ERR_CANCELED") {
          console.error("Search Diagnosis Error:", error);
          setDiagnosisSuggestions([]);
        }
      } finally {
        setDiagnosisLoading(false);
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [diagnosisInput, diagnosis]);

  useEffect(() => {
    const query = investigationInput.trim();

    if (!query) {
      setInvestigationSuggestions([]);
      setInvestigationLoading(false);
      return;
    }

    const controller = new AbortController();

    const timer = setTimeout(async () => {
      try {
        setInvestigationLoading(true);

        const { data } = await axios.get(
          `${BASE_URL}api/doctor/prescription/investigation/search`,
          {
            params: {
              query,
            },
            signal: controller.signal,
          },
        );

        if (data.success) {
          const existing = new Set(
            selectedTests
              .filter((item) => typeof item === "string")
              .map((item) => item.trim().toLowerCase()),
          );

          const suggestions = (data.data || []).filter(
            (item) =>
              typeof item === "string" &&
              item.trim() &&
              !existing.has(item.trim().toLowerCase()),
          );

          setInvestigationSuggestions(suggestions);
        } else {
          setInvestigationSuggestions([]);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.code !== "ERR_CANCELED") {
          console.error("Search Investigation Error:", error);

          setInvestigationSuggestions([]);
        }
      } finally {
        setInvestigationLoading(false);
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [investigationInput, selectedTests]);

  useEffect(() => {
    const query = adviceInput.trim();

    if (!query) {
      setAdviceSuggestions([]);
      setAdviceLoading(false);
      return;
    }

    const controller = new AbortController();

    const timer = setTimeout(async () => {
      try {
        setAdviceLoading(true);

        const { data } = await axios.get(
          `${BASE_URL}api/doctor/prescription/advice/search`,
          {
            params: {
              query,
            },
            signal: controller.signal,
          },
        );

        if (data.success) {
          const existing = new Set(
            advices
              .filter((item) => typeof item === "string")
              .map((item) => item.trim().toLowerCase()),
          );

          const suggestions = (data.data || []).filter(
            (item) =>
              typeof item === "string" &&
              item.trim() &&
              !existing.has(item.trim().toLowerCase()),
          );

          setAdviceSuggestions(suggestions);
        } else {
          setAdviceSuggestions([]);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.code !== "ERR_CANCELED") {
          console.error("Search Advice Error:", error);
          setAdviceSuggestions([]);
        }
      } finally {
        setAdviceLoading(false);
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [adviceInput, advices]);

  const addInvestigation = (value) => {
    const text = value.trim();

    if (!text) return;

    setSelectedTests((prev) => {
      if (prev.some((item) => item.toLowerCase() === text.toLowerCase())) {
        return prev;
      }

      return [...prev, text];
    });

    setInvestigationInput("");
  };

  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [holdDialogOpen, setHoldDialogOpen] = useState(false);
  const [pendingPrescriptionPayload, setPendingPrescriptionPayload] =
    useState(null);

  const [templateSelections, setTemplateSelections] = useState({
    diagnosis: {
      selected: false,
      name: "",
    },
    note: {
      selected: false,
      name: "",
    },
    investigation: {
      selected: false,
      name: "",
    },
    medicine: {
      selected: false,
      name: "",
    },
    advice: {
      selected: false,
      name: "",
    },
    prescription: {
      selected: false,
      name: "",
    },
  });

  const handleTemplateSwitch = (type, checked) => {
    setTemplateSelections((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        selected: checked,
        name: checked ? prev[type].name : "",
      },
    }));
  };

  const handleTemplateNameChange = (type, value) => {
    setTemplateSelections((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        name: value,
      },
    }));
  };

  const handleMedicineSelect = (medicine) => {
    const updated = [...rows];
    updated[dialogRowIndex].medicine = medicine.name;

    setRows(updated);
    setMedicineModalOpen(false);
    setMedicineSearch(""); // 👈 reset search

    setTimeout(() => {
      inputRefs.current[dialogRowIndex]?.[1]?.focus();
    }, 50);
  };

  const handleMedicineModalKeyDown = (e) => {
    if (!medicineModalOpen) return;

    if (e.key === "ArrowDown") {
      setMedicineHighlightIndex((prev) =>
        prev < medicineResults.length - 1 ? prev + 1 : prev,
      );
    }

    if (e.key === "ArrowUp") {
      setMedicineHighlightIndex((prev) => (prev > 0 ? prev - 1 : 0));
    }

    if (e.key === "Enter") {
      e.preventDefault();
      handleMedicineSelect(medicineResults[medicineHighlightIndex]);
    }

    if (e.key === "Escape") {
      setMedicineModalOpen(false);
    }
  };

  const calculateAge = (dobString) => {
    if (!dobString) return "";

    const dob = new Date(dobString);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  };

  const handleUpdatePrescription = async () => {
    const payload = buildPrescriptionPayload();

    try {
      const { data } = await axios.put(
        `${BASE_URL}api/doctor/prescription/update/${location.state?.prescriptionData?.appointmentId}`,
        payload,
        {
          headers: {},
        },
      );

      alert(data.message);

      if (data.success) {
        navigate(-1);
      }
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  const [editingAdviceIndex, setEditingAdviceIndex] = useState(null);
  const handleEditAdvice = (index) => {
    const value = advices[index];

    if (!value) return;

    setEditingAdviceIndex(index);
    setAdviceInput(value);

    // Remove old chip temporarily
    setAdvices((prev) => prev.filter((_, i) => i !== index));

    setTimeout(() => {
      adviceInputRef.current?.focus();

      const input = adviceInputRef.current;

      if (input) {
        input.setSelectionRange(value.length, value.length);
      }
    }, 50);
  };

  return (
    <Box sx={{ background: "#f4f6fb", minHeight: "100vh" }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "16px",
          border: "1px solid #e5e9ef",
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
          background: "#ffffff",
        }}
      >
        {/* ══ Patient selector / info bar ══ */}
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: "1px solid #e5e9ef",
            background: "#ffffff",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "2px",
              background: "linear-gradient(90deg,#2a54a6,#b93acf)",
            },
          }}
        >
          {isEditMode ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {/* Patient info pill */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flex: 1,
                  background:
                    "linear-gradient(135deg, rgba(42,84,166,0.05), rgba(185,58,207,0.03))",
                  border: "1px solid rgba(185,58,207,0.15)",
                  borderRadius: "12px",
                  px: 2,
                  py: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <PersonIcon sx={{ color: "#fff", fontSize: "1.1rem" }} />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      color: "#0a1f44",
                      lineHeight: 1.2,
                      mb: 0.5,
                    }}
                  >
                    {selectedEditPatient?.name}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
                    {[
                      {
                        icon: "🎂",
                        text: `${calculateAge(selectedEditPatient?.dob)} yrs`,
                      },
                      { icon: "⚧", text: selectedEditPatient?.gender },
                      { icon: "📱", text: selectedEditPatient?.mobile },
                    ].map((item) => (
                      <Box
                        key={item.text}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.4,
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "0.72rem", color: "#64748b" }}
                        >
                          {item.icon} {item.text}
                        </Typography>
                      </Box>
                    ))}
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        background: "rgba(185,58,207,0.08)",
                        border: "1px solid rgba(185,58,207,0.2)",
                        borderRadius: "100px",
                        px: 1,
                        py: "1px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.68rem",
                          fontWeight: 700,
                          background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundClip: "text",
                        }}
                      >
                        ID: {selectedEditPatient?.appId}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Button
                onClick={handleCancel}
                startIcon={<ClearIcon sx={{ fontSize: "0.9rem !important" }} />}
                sx={{
                  textTransform: "none",
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  borderRadius: "10px",
                  px: 2,
                  py: 0.75,
                  flexShrink: 0,
                  border: "1.5px solid rgba(239,68,68,0.25)",
                  background: "rgba(239,68,68,0.06)",
                  color: "#dc2626",
                  "&:hover": {
                    background: "rgba(239,68,68,0.12)",
                    borderColor: "rgba(239,68,68,0.4)",
                  },
                }}
              >
                Cancel Edit
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: "100%",
              }}
            >
              {/* ================= LEFT : PATIENT SELECTION ================= */}
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                }}
              >
                {/* Patient Icon */}

                {/* Patient Information */}
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,

                    minHeight: 52,

                    px: 1.5,
                    py: 0.8,

                    borderRadius: "10px",

                    bgcolor: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  {/* LEFT — Name + Patient ID */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: "11px",
                        flexShrink: 0,
                        mr: 1,
                        background:
                          "linear-gradient(135deg, rgba(37,99,235,.10), rgba(59,130,246,.05))",

                        color: "#2563eb",
                        border: "1px solid #bfdbfe",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: "1.15rem" }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                          mb: 0.35,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: ".84rem",
                            fontWeight: 700,
                            color: "#0f172a",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {selectedPatient?.name || "Patient not selected"}
                        </Typography>

                        {selectedPatient?.appointmentId && (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",

                              px: 0.7,
                              py: 0.15,

                              borderRadius: "5px",

                              bgcolor: "#eff6ff",
                              border: "1px solid #bfdbfe",

                              flexShrink: 0,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: ".59rem",
                                fontWeight: 700,
                                color: "#2563eb",
                              }}
                            >
                              ID: {selectedPatient.appointmentId}
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      {/* Patient details */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1.4,
                        }}
                      >
                        {/* Age */}
                        {selectedPatient?.dob && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.4,
                            }}
                          >
                            <CakeOutlinedIcon
                              sx={{
                                fontSize: ".75rem",
                                color: "#94a3b8",
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: ".65rem",
                                color: "#64748b",
                                fontWeight: 500,
                              }}
                            >
                              {calculateAge(selectedPatient.dob)} yrs
                            </Typography>
                          </Box>
                        )}

                        {/* Gender */}
                        {selectedPatient?.gender && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.4,
                            }}
                          >
                            <WcOutlinedIcon
                              sx={{
                                fontSize: ".75rem",
                                color: "#94a3b8",
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: ".65rem",
                                color: "#64748b",
                                fontWeight: 500,
                              }}
                            >
                              {selectedPatient.gender}
                            </Typography>
                          </Box>
                        )}

                        {/* Mobile */}
                        {selectedPatient?.mobile && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.4,
                            }}
                          >
                            <PhoneOutlinedIcon
                              sx={{
                                fontSize: ".72rem",
                                color: "#94a3b8",
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: ".65rem",
                                color: "#64748b",
                                fontWeight: 500,
                              }}
                            >
                              {selectedPatient.mobile}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* RIGHT — Read Only Status */}
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                      },

                      alignItems: "center",
                      gap: 0.5,

                      px: 0.9,
                      py: 0.35,

                      borderRadius: "7px",

                      bgcolor: "#f1f5f9",
                      border: "1px solid #e2e8f0",

                      flexShrink: 0,
                    }}
                  >
                    <LockOutlinedIcon
                      sx={{
                        fontSize: ".68rem",
                        color: "#64748b",
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: ".59rem",
                        fontWeight: 700,
                        color: "#64748b",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Patient Selected
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* ================= DIVIDER ================= */}
              <Box
                sx={{
                  width: "1px",
                  height: 44,
                  bgcolor: "#e2e8f0",
                  mx: 0.5,
                  display: {
                    xs: "none",
                    md: "block",
                  },
                }}
              />

              {/* ================= RIGHT : TEMPLATE ================= */}
              <Box
                sx={{
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: ".62rem",
                    fontWeight: 600,
                    color: "#94a3b8",
                  }}
                >
                  Have a saved prescription?
                </Typography>

                <Button
                  onClick={handleOpenPrescriptionTemplates}
                  variant="outlined"
                  startIcon={
                    <LibraryBooksOutlinedIcon
                      sx={{
                        fontSize: ".95rem !important",
                      }}
                    />
                  }
                  sx={{
                    height: 40,
                    px: 1.75,

                    textTransform: "none",
                    whiteSpace: "nowrap",

                    fontSize: ".76rem",
                    fontWeight: 700,

                    // Green theme
                    color: "#15803d",
                    bgcolor: "#f0fdf4",

                    border: "1px solid #bbf7d0",
                    borderRadius: "9px",

                    transition: "all .15s ease",

                    "& .MuiButton-startIcon": {
                      color: "#16a34a",
                    },

                    "&:hover": {
                      bgcolor: "#dcfce7",
                      color: "#166534",
                      borderColor: "#4ade80",
                      boxShadow: "0 3px 10px rgba(22,163,74,.12)",
                      transform: "translateY(-1px)",
                    },

                    "&:active": {
                      transform: "translateY(0)",
                      bgcolor: "#bbf7d0",
                      boxShadow: "none",
                    },
                  }}
                >
                  Load Prescription Template
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            px: 2.5,
            pt: 2,
            pb: 0,
            background: "#fff",
            borderBottom: "1px solid #e2e8f0",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, value) => setActiveTab(value)}
            variant="fullWidth"
            sx={{
              minHeight: 72,

              "& .MuiTabs-flexContainer": {
                gap: 1,
              },

              "& .MuiTabs-indicator": {
                display: "none",
              },

              "& .MuiTab-root": {
                minHeight: 72,
                textTransform: "none",
                alignItems: "stretch",
                borderRadius: "10px 10px 0 0",
                border: "1px solid transparent",
                borderBottom: "none",
                px: 1.5,
                py: 1,
                color: "#64748b",
                transition: "all .15s ease",

                "&:hover": {
                  bgcolor: "#f8fafc",
                },
              },

              "& .MuiTab-root.Mui-selected": {
                bgcolor: "#fff",
                color: "#0f172a",
                // borderColor: "#e2e8f0",
                bgcolor: "#daf8ff",

                // covers parent bottom border
                position: "relative",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  height: "2px",
                  bgcolor: "#fff",
                  bottom: "-1px",
                  left: 0,
                  right: 0,
                },
              },
            }}
          >
            {/* ================= CLINICAL ================= */}
            <Tab
              disableRipple
              label={
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                    textAlign: "left",
                  }}
                >
                  <Box
                    sx={{
                      width: activeTab === 0 ? 42 : 36,
                      height: activeTab === 0 ? 42 : 36,
                      flexShrink: 0,
                      borderRadius: activeTab === 0 ? "11px" : "9px",
                      bgcolor: activeTab === 0 ? "primary.main" : "#eff6ff",
                      color: activeTab === 0 ? "#fff" : "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow:
                        activeTab === 0
                          ? "0 5px 14px rgba(37,99,235,.28)"
                          : "none",
                      transition: "all .2s ease",
                    }}
                  >
                    <MedicalInformationIcon
                      sx={{
                        fontSize: "1.05rem",
                      }}
                    />
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: "0.82rem",
                        fontWeight: 700,
                        lineHeight: 1.3,
                        color: activeTab === 0 ? "#0f172a" : "#475569",
                      }}
                    >
                      Clinical Assessment
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.64rem",
                        color: "#94a3b8",
                        mt: 0.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vitals, note, symptoms & diagnosis
                    </Typography>
                  </Box>
                </Box>
              }
            />

            {/* ================= INVESTIGATION ================= */}
            <Tab
              disableRipple
              label={
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                    textAlign: "left",
                  }}
                >
                  <Box
                    sx={{
                      width: activeTab === 1 ? 42 : 36,
                      height: activeTab === 1 ? 42 : 36,
                      flexShrink: 0,
                      borderRadius: activeTab === 1 ? "11px" : "9px",
                      bgcolor: activeTab === 1 ? "primary.main" : "#eff6ff",
                      color: activeTab === 1 ? "#fff" : "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow:
                        activeTab === 1
                          ? "0 5px 14px rgba(37,99,235,.28)"
                          : "none",
                      transition: "all .2s ease",
                    }}
                  >
                    <ScienceIcon
                      sx={{
                        fontSize: "1.05rem",
                      }}
                    />
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: "0.82rem",
                        fontWeight: 700,
                        lineHeight: 1.3,
                        color: activeTab === 1 ? "#0f172a" : "#475569",
                      }}
                    >
                      Investigations / Tests
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.64rem",
                        color: "#94a3b8",
                        mt: 0.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Laboratory & diagnostic tests
                    </Typography>
                  </Box>
                </Box>
              }
            />

            {/* ================= MEDICINE ================= */}
            <Tab
              disableRipple
              label={
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                    textAlign: "left",
                  }}
                >
                  <Box
                    sx={{
                      width: activeTab === 2 ? 42 : 36,
                      height: activeTab === 2 ? 42 : 36,
                      flexShrink: 0,
                      borderRadius: activeTab === 2 ? "11px" : "9px",
                      bgcolor: activeTab === 2 ? "primary.main" : "#eff6ff",
                      color: activeTab === 2 ? "#fff" : "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow:
                        activeTab === 2
                          ? "0 5px 14px rgba(37,99,235,.28)"
                          : "none",
                      transition: "all .2s ease",
                    }}
                  >
                    <MedicationIcon
                      sx={{
                        fontSize: "1.05rem",
                      }}
                    />
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: "0.82rem",
                        fontWeight: 700,
                        lineHeight: 1.3,
                        color: activeTab === 2 ? "#0f172a" : "#475569",
                      }}
                    >
                      Medicines
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.64rem",
                        color: "#94a3b8",
                        mt: 0.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Medicines, dosage & duration
                    </Typography>
                  </Box>
                </Box>
              }
            />

            {/* ================= ADVICE ================= */}
            <Tab
              disableRipple
              label={
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                    textAlign: "left",
                  }}
                >
                  <Box
                    sx={{
                      width: activeTab === 3 ? 42 : 36,
                      height: activeTab === 3 ? 42 : 36,
                      flexShrink: 0,
                      borderRadius: activeTab === 3 ? "11px" : "9px",
                      bgcolor: activeTab === 3 ? "primary.main" : "#eff6ff",
                      color: activeTab === 3 ? "#fff" : "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow:
                        activeTab === 3
                          ? "0 5px 14px rgba(37,99,235,.28)"
                          : "none",
                      transition: "all .2s ease",
                    }}
                  >
                    <AssignmentTurnedInOutlinedIcon
                      sx={{
                        fontSize: activeTab === 3 ? "1.2rem" : "1.05rem",
                      }}
                    />
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: activeTab === 3 ? ".88rem" : ".82rem",
                        fontWeight: activeTab === 3 ? 800 : 700,
                        color: activeTab === 3 ? "#0f172a" : "#475569",
                      }}
                    >
                      Advice & Follow-up
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: ".64rem",
                        color: "#94a3b8",
                        mt: 0.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Advice, next visit & referral
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </Tabs>
        </Box>

        <Box sx={{ p: 2.5 }}>
          {activeTab === 0 && (
            <Box
              sx={{
                display: "grid",
                gap: 2,
              }}
            >
              {/* =====================================================
      PATIENT VITALS
  ===================================================== */}
              <Box
                sx={{
                  bgcolor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                }}
              >
                {/* ==========================================
      MAIN HEADER
  ========================================== */}
                <Box
                  sx={{
                    px: 2,
                    py: 1.25,
                    bgcolor: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "8px",
                        bgcolor: "#eff6ff",
                        color: "#2563eb",
                        border: "1px solid #2563eb",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MonitorHeartOutlinedIcon sx={{ fontSize: "1rem" }} />
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".8rem",
                          fontWeight: 700,
                          color: "#0f172a",
                          lineHeight: 1.3,
                        }}
                      >
                        Patient Vitals & Clinical Note
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".64rem",
                          color: "#94a3b8",
                          mt: 0.15,
                        }}
                      >
                        Record patient vitals and additional clinical
                        observations
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* ==========================================
      TWO COLUMN CONTENT
  ========================================== */}
                <Box
                  sx={{
                    display: "grid",

                    gridTemplateColumns: {
                      xs: "1fr",
                      md: "minmax(360px, 42%) 1fr",
                    },

                    alignItems: "stretch",
                  }}
                >
                  {/* ==========================================
        LEFT - VITALS
    ========================================== */}
                  <Box
                    sx={{
                      p: 2,

                      borderRight: {
                        xs: "none",
                        md: "1px solid #e2e8f0",
                      },

                      borderBottom: {
                        xs: "1px solid #e2e8f0",
                        md: "none",
                      },

                      bgcolor: "#fff",
                    }}
                  >
                    {/* Vitals Header */}
                    <Box
                      sx={{
                        mb: 1.5,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: ".72rem",
                            fontWeight: 700,
                            color: "#334155",
                          }}
                        >
                          Patient Vitals
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: ".61rem",
                            color: "#94a3b8",
                            mt: 0.15,
                          }}
                        >
                          Basic measurements
                        </Typography>
                      </Box>

                      {/* Edit Toggle */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,

                          pl: 0.9,
                          pr: 0.25,
                          py: 0.2,

                          borderRadius: "8px",

                          bgcolor: isVitalsEditable ? "#ecfdf5" : "#f8fafc",

                          border: isVitalsEditable
                            ? "1px solid #a7f3d0"
                            : "1px solid #e2e8f0",

                          transition: "all .15s ease",
                        }}
                      >
                        <EditIcon
                          sx={{
                            fontSize: ".75rem",
                            color: isVitalsEditable ? "#10b981" : "#94a3b8",
                          }}
                        />

                        <Typography
                          sx={{
                            fontSize: ".61rem",
                            fontWeight: 700,

                            color: isVitalsEditable ? "#047857" : "#64748b",

                            whiteSpace: "nowrap",
                          }}
                        >
                          Edit
                        </Typography>

                        <Switch
                          size="small"
                          checked={isVitalsEditable}
                          onChange={(e) =>
                            setIsVitalsEditable(e.target.checked)
                          }
                          sx={{
                            ml: -0.25,

                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#10b981",

                              "& + .MuiSwitch-track": {
                                bgcolor: "#10b981",
                                opacity: 1,
                              },
                            },

                            "& .MuiSwitch-track": {
                              bgcolor: "#cbd5e1",
                              opacity: 1,
                            },
                          }}
                        />
                      </Box>
                    </Box>

                    {/* Vitals Inputs */}
                    <Box
                      sx={{
                        display: "grid",

                        gridTemplateColumns: {
                          xs: "repeat(2, 1fr)",
                        },

                        gap: 1.25,
                      }}
                    >
                      {[
                        {
                          label: "Height",
                          key: "height",
                          icon: "📏",
                          unit: "cm",
                        },
                        {
                          label: "Weight",
                          key: "weight",
                          icon: "⚖️",
                          unit: "kg",
                        },
                        {
                          label: "Pulse",
                          key: "pulse",
                          icon: "💓",
                          unit: "bpm",
                        },
                        {
                          label: "Blood Pressure",
                          key: "bp",
                          icon: "🩺",
                          unit: "mmHg",
                        },
                      ].map((v) => (
                        <Box key={v.key}>
                          <Typography
                            sx={{
                              fontSize: ".65rem",
                              fontWeight: 600,
                              color: "#64748b",
                              mb: 0.55,
                            }}
                          >
                            {v.icon} {v.label}
                          </Typography>

                          <TextField
                            fullWidth
                            size="small"
                            disabled={!isVitalsEditable}
                            value={vitals[v.key] || ""}
                            onChange={(e) =>
                              setVitals((prev) => ({
                                ...prev,
                                [v.key]: e.target.value,
                              }))
                            }
                            InputProps={{
                              endAdornment: (
                                <Typography
                                  sx={{
                                    fontSize: ".61rem",
                                    color: "#94a3b8",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {v.unit}
                                </Typography>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                height: 42,
                                borderRadius: "8px",

                                bgcolor: isVitalsEditable
                                  ? "#f8fafc"
                                  : "#f1f5f9",

                                transition: "all .15s ease",

                                "& fieldset": {
                                  borderColor: "#e2e8f0",
                                },

                                "&:hover fieldset": {
                                  borderColor: isVitalsEditable
                                    ? "#94a3b8"
                                    : "#e2e8f0",
                                },

                                "&.Mui-focused": {
                                  bgcolor: "#fff",
                                  boxShadow: "0 0 0 3px rgba(37,99,235,.08)",
                                },

                                "&.Mui-focused fieldset": {
                                  borderColor: "#2563eb",
                                  borderWidth: "1px",
                                },

                                "& input": {
                                  fontSize: ".84rem",
                                  fontWeight: 700,
                                  color: "#0f172a",
                                },

                                "&.Mui-disabled": {
                                  bgcolor: "#f8fafc",

                                  "& fieldset": {
                                    borderColor: "#e2e8f0",
                                  },

                                  "& input": {
                                    WebkitTextFillColor: "#64748b",
                                  },
                                },
                              },
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* ==========================================
        RIGHT - CLINICAL NOTE
    ========================================== */}
                  {/* ==========================================
    RIGHT - CLINICAL NOTE - RED THEME
========================================== */}
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#fff",
                      minWidth: 0,
                    }}
                  >
                    <Box
                      sx={{
                        mb: 1.25,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: ".72rem",
                            fontWeight: 700,
                            color: "#334155",
                          }}
                        >
                          Clinical Note
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: ".61rem",
                            color: "#94a3b8",
                            mt: 0.15,
                          }}
                        >
                          Observations, findings and remarks
                        </Typography>
                      </Box>

                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleOpenNoteTemplates}
                        startIcon={
                          <LibraryBooksOutlinedIcon
                            sx={{ fontSize: ".85rem !important" }}
                          />
                        }
                        sx={{
                          height: 30,
                          px: 1.15,
                          textTransform: "none",
                          whiteSpace: "nowrap",
                          fontSize: ".66rem",
                          fontWeight: 700,
                          color: "#a16207",
                          bgcolor: "#fff",
                          border: "1px solid #fde68a",
                          borderRadius: "7px",
                          "&:hover": {
                            bgcolor: "#fefce8",
                            borderColor: "#eab308",
                          },
                        }}
                      >
                        Load Template
                      </Button>
                    </Box>

                    {/* Quill Editor */}
                    <Box
                      sx={{
                        border: "1px solid #fde68a",
                        borderRadius: "9px",
                        overflow: "hidden",
                        bgcolor: "#fff",

                        transition: "all .15s ease",

                        "&:hover": {
                          borderColor: "#fcd34d",
                        },

                        "&:focus-within": {
                          borderColor: "#eab308",
                          boxShadow: "0 0 0 3px rgba(234,179,8,.10)",
                        },

                        "& .ql-toolbar": {
                          border: "none !important",
                          borderBottom: "1px solid #fde68a !important",

                          bgcolor: "#fefce8",

                          px: "8px !important",
                          py: "6px !important",
                        },

                        /* Toolbar groups */
                        "& .ql-formats": {
                          marginRight: "8px !important",
                        },

                        /* Toolbar buttons */
                        "& .ql-toolbar button": {
                          width: "25px !important",
                          height: "25px !important",
                          padding: "3px !important",

                          borderRadius: "5px",

                          transition: "all .12s ease",

                          "&:hover": {
                            bgcolor: "#fef9c3",
                          },
                        },

                        /* Default toolbar icon */
                        "& .ql-toolbar button .ql-stroke": {
                          stroke: "#64748b",
                        },

                        "& .ql-toolbar button .ql-fill": {
                          fill: "#64748b",
                        },

                        /* Hover icon */
                        "& .ql-toolbar button:hover .ql-stroke": {
                          stroke: "#ca8a04",
                        },

                        "& .ql-toolbar button:hover .ql-fill": {
                          fill: "#ca8a04",
                        },

                        /* Selected toolbar button */
                        "& .ql-toolbar button.ql-active": {
                          bgcolor: "#fef9c3",
                        },

                        "& .ql-toolbar button.ql-active .ql-stroke": {
                          stroke: "#ca8a04",
                        },

                        "& .ql-toolbar button.ql-active .ql-fill": {
                          fill: "#ca8a04",
                        },

                        /* Picker */
                        "& .ql-picker-label": {
                          borderRadius: "5px",
                          fontSize: ".72rem",
                          color: "#64748b",

                          "&:hover": {
                            color: "#ca8a04",
                            bgcolor: "#fef9c3",
                          },
                        },

                        "& .ql-picker.ql-expanded .ql-picker-label": {
                          color: "#ca8a04",
                          borderColor: "#fcd34d",
                        },

                        /* Picker dropdown */
                        "& .ql-picker-options": {
                          border: "1px solid #fde68a !important",
                          borderRadius: "7px",
                          boxShadow: "0 8px 20px rgba(161,98,7,.10)",
                        },

                        /* Editor container */
                        "& .ql-container": {
                          border: "none !important",
                          fontFamily: "inherit",
                          fontSize: ".82rem",
                        },

                        "& .ql-editor": {
                          minHeight: "125px",
                          maxHeight: "220px",

                          overflowY: "auto",

                          px: "12px",
                          py: "10px",

                          color: "#334155",
                          lineHeight: 1.6,

                          bgcolor: "#fff",
                        },

                        /* Placeholder */
                        "& .ql-editor.ql-blank::before": {
                          color: "#94a3b8",
                          fontStyle: "normal",
                        },

                        /* Selection */
                        "& .ql-editor ::selection": {
                          bgcolor: "#fef9c3",
                        },

                        /* Blockquote */
                        "& .ql-editor blockquote": {
                          borderLeft: "4px solid #eab308",
                          bgcolor: "#fefce8",

                          px: 1.2,
                          py: 0.5,

                          borderRadius: "0 6px 6px 0",

                          color: "#854d0e",
                        },

                        /* Links */
                        "& .ql-editor a": {
                          color: "#ca8a04",
                        },
                      }}
                    >
                      <ReactQuill
                        ref={quillRef}
                        theme="snow"
                        modules={modules}
                        value={clinicalNote}
                        onChange={setClinicalNote}
                        placeholder="Enter clinical observations, examination findings or additional remarks..."
                      />
                    </Box>

                    {/* Bottom Hint */}
                    <Box
                      sx={{
                        mt: 0.65,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          width: 5,
                          height: 5,
                          borderRadius: "50%",
                          bgcolor: "#ef4444",
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: ".6rem",
                          color: "#94a3b8",
                        }}
                      >
                        Clinical notes will be included with the prescription
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* =====================================================
      SYMPTOMS + DIAGNOSIS
  ===================================================== */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    lg: "1fr 1fr",
                  },
                  gap: 2,
                }}
              >
                {/* =================================================
        SYMPTOMS
    ================================================= */}
                <Box
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    overflow: "visible",
                    boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.25,
                      bgcolor: "#f8fafc",
                      borderBottom: "1px solid #e2e8f0",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,

                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Icon */}
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "8px",

                          bgcolor: "#fef2f2",
                          color: "#dc2626",

                          border: "1px solid #fecaca",

                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",

                          flexShrink: 0,
                        }}
                      >
                        <HistoryEduIcon sx={{ fontSize: "1rem" }} />
                      </Box>

                      {/* Title */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: ".8rem",
                            fontWeight: 700,
                            color: "#0f172a",
                            lineHeight: 1.3,
                          }}
                        >
                          Symptoms / Patient History
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: ".64rem",
                            color: "#94a3b8",
                            mt: 0.15,
                          }}
                        >
                          Record symptoms and relevant patient history
                        </Typography>
                      </Box>
                    </Box>

                    {/* Count */}
                    {symptoms.length > 0 && (
                      <Box
                        sx={{
                          px: 0.9,
                          py: 0.35,

                          borderRadius: "999px",

                          bgcolor: "#fef2f2",
                          border: "1px solid #fecaca",

                          flexShrink: 0,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: ".62rem",
                            fontWeight: 700,
                            color: "#dc2626",
                          }}
                        >
                          {symptoms.length} added
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  <Box sx={{ p: 2 }}>
                    <Box
                      sx={{
                        minHeight: 54,

                        border: "1px solid #e2e8f0",
                        borderRadius: "10px",

                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        flexWrap: "wrap",

                        gap: 0.75,

                        px: 1,
                        py: 0.8,

                        cursor: "text",

                        bgcolor: "#fff",

                        transition: "all .15s ease",

                        "&:hover": {
                          borderColor: "#cbd5e1",
                        },

                        "&:focus-within": {
                          borderColor: "#ef4444",
                          boxShadow: "0 0 0 3px rgba(239,68,68,.08)",
                        },
                      }}
                      onClick={() => symptomInputRef.current?.focus()}
                    >
                      {/* =====Selected Symptoms========= */}
                      {/* {symptoms.map((symptom, index) => (
                        <Chip
                          key={`${symptom}-${index}`}
                          label={symptom}
                          onDelete={() => removeSymptom(index)}
                          size="small"
                          sx={{
                            height: 29,
                            borderRadius: "7px",
                            bgcolor: "#fef2f2",
                            color: "#b91c1c",
                            border: "1px solid #fecaca",
                            fontSize: ".74rem",
                            fontWeight: 600,
                            "& .MuiChip-label": {
                              px: 1,
                            },
                            "& .MuiChip-deleteIcon": {
                              fontSize: 16,
                              color: "#ef4444",
                              "&:hover": {
                                color: "#b91c1c",
                              },
                            },
                            "&:hover": {
                              bgcolor: "#fee2e2",
                            },
                          }}
                        />
                      ))} */}
                      {symptoms.map((item, index) => (
                        <Box
                          key={`${item}-${index}`}
                          sx={{
                            position: "relative",
                            display: "inline-flex",
                            alignItems: "center",
                            maxWidth: "100%",
                            m: 0.5,
                          }}
                        >
                          {/* Edit Button */}
                          <Tooltip title="Edit symptom" arrow>
                            <IconButton
                              size="small"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleEditSymptoms(index);
                              }}
                              sx={{
                                position: "absolute",

                                top: -7,
                                left: -7,

                                width: 17,
                                height: 17,

                                zIndex: 2,

                                bgcolor: "#fff",
                                color: "#dc2626",

                                border: "1px solid #fca5a5",

                                boxShadow: "0 1px 3px rgba(15,23,42,.15)",

                                "&:hover": {
                                  bgcolor: "#fef2f2",
                                  color: "#b91c1c",
                                  borderColor: "#f87171",
                                },
                              }}
                            >
                              <EditOutlinedIcon
                                sx={{
                                  fontSize: ".58rem",
                                }}
                              />
                            </IconButton>
                          </Tooltip>

                          {/* Symptoms Chip */}
                          <Chip
                            label={item}
                            onDelete={() => removeSymptoms(index)}
                            size="small"
                            sx={{
                              height: 29,
                              borderRadius: "7px",

                              bgcolor: "#fef2f2",
                              color: "#dc2626",

                              border: "1px solid #fca5a5",

                              fontSize: ".74rem",
                              fontWeight: 600,

                              "& .MuiChip-label": {
                                px: 1,
                                pl: 1.2,
                              },

                              "& .MuiChip-deleteIcon": {
                                fontSize: 16,
                                color: "#ef4444",

                                "&:hover": {
                                  color: "#b91c1c",
                                },
                              },

                              "&:hover": {
                                bgcolor: "#fee2e2",
                              },
                            }}
                          />
                        </Box>
                      ))}

                      {/* =====Search / Custom Input====== */}
                      <Autocomplete
                        freeSolo
                        disableClearable
                        options={symptomSuggestions}
                        inputValue={symptomInput}
                        loading={symptomLoading}
                        filterOptions={(options) => options}
                        open={symptomPopupOpen}
                        onOpen={() => setSymptomPopupOpen(true)}
                        onClose={() => setSymptomPopupOpen(false)}
                        /* ======Typing===== */
                        onInputChange={(event, newValue, reason) => {
                          if (reason === "input") {
                            setSymptomInput(newValue);
                          }
                        }}
                        /* ==== Dropdown Selection / Free Solo Enter === */
                        onChange={(event, newValue, reason) => {
                          if (!newValue) return;

                          if (reason === "selectOption") {
                            // Directly create chip from selected suggestion
                            addSymptom(newValue);

                            // Clear input after creating chip
                            setSymptomInput("");

                            // Close dropdown
                            setSymptomPopupOpen(false);

                            return;
                          }

                          if (reason === "createOption") {
                            // Free-typed custom symptom
                            addSymptom(newValue);

                            setSymptomInput("");
                            setSymptomPopupOpen(false);

                            return;
                          }
                        }}
                        noOptionsText={
                          symptomInput.trim()
                            ? "No matching symptom found"
                            : "Start typing to search"
                        }
                        loadingText="Searching symptoms..."
                        sx={{
                          flex: 1,
                          minWidth: 180,

                          "& .MuiAutocomplete-inputRoot": {
                            p: "0 !important",
                          },

                          "& .MuiAutocomplete-endAdornment": {
                            right: "2px !important",
                          },
                        }}
                        slotProps={{
                          paper: {
                            sx: {
                              mt: 0.75,

                              borderRadius: "10px",

                              border: "1px solid #fecaca",

                              boxShadow:
                                "0 10px 30px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.04)",

                              overflow: "hidden",

                              bgcolor: "#fff",
                            },
                          },

                          listbox: {
                            sx: {
                              p: 0.6,
                              maxHeight: 250,

                              "& .MuiAutocomplete-option": {
                                minHeight: 38,

                                borderRadius: "7px",

                                px: 1.2,
                                py: 0.8,

                                mb: 0.2,

                                fontSize: ".78rem",
                                fontWeight: 500,

                                color: "#334155",

                                transition: "all .12s ease",

                                "&:hover": {
                                  bgcolor: "#fef2f2",
                                  color: "#b91c1c",
                                },

                                "&.Mui-focused": {
                                  bgcolor: "#fef2f2",
                                  color: "#b91c1c",
                                },

                                '&[aria-selected="true"]': {
                                  bgcolor: "#fee2e2",
                                  color: "#b91c1c",
                                },
                              },
                            },
                          },
                        }}
                        renderOption={(props, option) => {
                          const { key, ...optionProps } = props;

                          return (
                            <Box
                              component="li"
                              key={key}
                              {...optionProps}
                              sx={{
                                display: "flex !important",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 25,
                                  height: 25,

                                  borderRadius: "6px",

                                  bgcolor: "#fef2f2",
                                  color: "#dc2626",

                                  border: "1px solid #fecaca",

                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",

                                  flexShrink: 0,
                                }}
                              >
                                <HistoryEduIcon
                                  sx={{
                                    fontSize: ".75rem",
                                  }}
                                />
                              </Box>

                              <Box
                                sx={{
                                  minWidth: 0,
                                  flex: 1,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: ".78rem",
                                    fontWeight: 600,
                                    color: "#334155",

                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontSize: ".6rem",
                                    color: "#94a3b8",
                                    mt: 0.1,
                                  }}
                                >
                                  From symptom master
                                </Typography>
                              </Box>
                            </Box>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputRef={symptomInputRef}
                            variant="standard"
                            placeholder={
                              symptoms.length
                                ? "Search or add another..."
                                : "Search symptom or enter custom symptom..."
                            }
                            onKeyDown={handleSymptomKeyDown}
                            InputProps={{
                              ...params.InputProps,

                              disableUnderline: true,

                              endAdornment: symptomLoading ? (
                                <CircularProgress
                                  size={15}
                                  sx={{
                                    color: "#ef4444",
                                    mr: 0.5,
                                  }}
                                />
                              ) : null,
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                p: "0 !important",
                              },

                              "& input": {
                                fontSize: ".82rem",
                                color: "#334155",

                                p: "4px !important",

                                minWidth: "160px",

                                "&::placeholder": {
                                  color: "#94a3b8",
                                  opacity: 1,
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </Box>

                    <Box
                      sx={{
                        mt: 0.7,
                        ml: 0.25,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",

                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: ".62rem",
                          color: "#94a3b8",
                        }}
                      >
                        Search from symptom master or enter a custom symptom
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* ==== DIAGNOSIS ======== */}
                <Box
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                  }}
                >
                  {/* Header */}
                  <Box
                    sx={{
                      px: 2,
                      py: 1.25,
                      bgcolor: "#f8fafc",
                      borderBottom: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "8px",
                          bgcolor: "#ecfdf5",
                          color: "#059669",
                          border: "1px solid #059669",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <MedicalInformationIcon sx={{ fontSize: "1rem" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: ".8rem",
                            fontWeight: 700,
                            color: "#0f172a",
                            lineHeight: 1.3,
                          }}
                        >
                          Clinical Diagnosis
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: ".64rem",
                            color: "#94a3b8",
                            mt: 0.15,
                          }}
                        >
                          Add confirmed or suspected clinical diagnosis
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        flexShrink: 0,
                      }}
                    >
                      {/* Diagnosis count */}
                      {diagnosis.length > 0 && (
                        <Box
                          sx={{
                            px: 0.9,
                            py: 0.35,
                            borderRadius: "999px",
                            bgcolor: "#ecfdf5",
                            border: "1px solid #a7f3d0",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: ".62rem",
                              fontWeight: 700,
                              color: "#047857",
                            }}
                          >
                            {diagnosis.length} added
                          </Typography>
                        </Box>
                      )}

                      {/* Load Template */}
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleOpenDiagnosisTemplates}
                        startIcon={
                          <LibraryBooksOutlinedIcon
                            sx={{
                              fontSize: ".85rem !important",
                            }}
                          />
                        }
                        sx={{
                          height: 30,
                          px: 1.15,

                          textTransform: "none",
                          whiteSpace: "nowrap",

                          fontSize: ".66rem",
                          fontWeight: 700,

                          color: "#047857",
                          bgcolor: "#fff",

                          border: "1px solid #a7f3d0",
                          borderRadius: "7px",

                          "&:hover": {
                            bgcolor: "#ecfdf5",
                            borderColor: "#34d399",
                          },
                        }}
                      >
                        Load Template
                      </Button>
                    </Box>
                  </Box>

                  {/* Content */}
                  <Box sx={{ p: 2 }}>
                    <Box
                      sx={{
                        minHeight: 54,

                        border: "1px solid #e2e8f0",
                        borderRadius: "10px",

                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        flexWrap: "wrap",

                        gap: 0.75,

                        px: 1,
                        py: 0.8,

                        cursor: "text",

                        bgcolor: "#fff",

                        transition: "all .15s ease",

                        "&:hover": {
                          borderColor: "#cbd5e1",
                        },

                        "&:focus-within": {
                          borderColor: "#16a34a",
                          boxShadow: "0 0 0 3px rgba(22,163,74,.08)",
                        },
                      }}
                      onClick={() => diagnosisInputRef.current?.focus()}
                    >
                      {/* ========================================
          Selected Symptoms
      ======================================== */}
                      {diagnosis.map((item, index) => (
                        <Box
                          key={`${item}-${index}`}
                          sx={{
                            position: "relative",
                            display: "inline-flex",
                            alignItems: "center",
                            maxWidth: "100%",
                            m: 0.5,
                          }}
                        >
                          {/* Edit Button */}
                          <Tooltip title="Edit diagnosis" arrow>
                            <IconButton
                              size="small"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleEditDiagnosis(index);
                              }}
                              sx={{
                                position: "absolute",

                                top: -7,
                                left: -7,

                                width: 17,
                                height: 17,

                                zIndex: 2,

                                bgcolor: "#fff",
                                color: "#16a34a",

                                border: "1px solid #86efac",

                                boxShadow: "0 1px 3px rgba(15,23,42,.15)",

                                "&:hover": {
                                  bgcolor: "#f0fdf4",
                                  color: "#15803d",
                                  borderColor: "#4ade80",
                                },
                              }}
                            >
                              <EditOutlinedIcon
                                sx={{
                                  fontSize: ".58rem",
                                }}
                              />
                            </IconButton>
                          </Tooltip>

                          {/* Diagnosis Chip */}
                          <Chip
                            label={item}
                            onDelete={() => removeDiagnosis(index)}
                            size="small"
                            sx={{
                              height: 29,
                              borderRadius: "7px",
                              bgcolor: "#ecfdf5",
                              color: "#059669",
                              border: "1px solid #059669",
                              fontSize: ".74rem",
                              fontWeight: 600,
                              "& .MuiChip-label": {
                                px: 1,
                                pl: 1.2,
                              },

                              "& .MuiChip-deleteIcon": {
                                fontSize: 16,
                                color: "#10b981",

                                "&:hover": {
                                  color: "#047857",
                                },
                              },

                              "&:hover": {
                                bgcolor: "#dcfce7",
                              },
                            }}
                          />
                        </Box>
                      ))}

                      <Autocomplete
                        freeSolo
                        disableClearable
                        options={diagnosisSuggestions}
                        inputValue={diagnosisInput}
                        loading={diagnosisLoading}
                        open={diagnosisPopupOpen}
                        onOpen={() => setDiagnosisPopupOpen(true)}
                        onClose={() => setDiagnosisPopupOpen(false)}
                        filterOptions={(options) => options}
                        onInputChange={(event, newValue, reason) => {
                          if (reason === "input") {
                            setDiagnosisInput(newValue);
                          }
                        }}
                        onChange={(event, newValue, reason) => {
                          if (!newValue) return;

                          if (reason === "selectOption") {
                            // Directly create diagnosis chip
                            addDiagnosis(newValue);

                            setDiagnosisInput("");
                            setDiagnosisPopupOpen(false);

                            return;
                          }

                          if (reason === "createOption") {
                            // Free-typed custom diagnosis
                            addDiagnosis(newValue);

                            setDiagnosisInput("");
                            setDiagnosisPopupOpen(false);

                            return;
                          }
                        }}
                        noOptionsText={
                          diagnosisInput.trim()
                            ? "No matching diagnosis found"
                            : "Start typing to search"
                        }
                        loadingText="Searching diagnosis..."
                        sx={{
                          flex: 1,
                          minWidth: 180,

                          "& .MuiAutocomplete-inputRoot": {
                            p: "0 !important",
                          },

                          "& .MuiAutocomplete-endAdornment": {
                            right: "2px !important",
                          },
                        }}
                        slotProps={{
                          paper: {
                            sx: {
                              mt: 0.75,

                              borderRadius: "10px",

                              // Green border
                              border: "1px solid #bbf7d0",

                              boxShadow:
                                "0 10px 30px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.04)",

                              overflow: "hidden",
                              bgcolor: "#fff",
                            },
                          },

                          listbox: {
                            sx: {
                              p: 0.6,
                              maxHeight: 250,

                              "& .MuiAutocomplete-option": {
                                minHeight: 38,

                                borderRadius: "7px",

                                px: 1.2,
                                py: 0.8,

                                mb: 0.2,

                                fontSize: ".78rem",
                                fontWeight: 500,

                                color: "#334155",

                                transition: "all .12s ease",

                                // Green hover
                                "&:hover": {
                                  bgcolor: "#f0fdf4",
                                  color: "#15803d",
                                },

                                // Green keyboard focus
                                "&.Mui-focused": {
                                  bgcolor: "#f0fdf4",
                                  color: "#15803d",
                                },

                                // Green selected
                                '&[aria-selected="true"]': {
                                  bgcolor: "#dcfce7",
                                  color: "#15803d",
                                },

                                '&[aria-selected="true"].Mui-focused': {
                                  bgcolor: "#dcfce7",
                                  color: "#15803d",
                                },
                              },
                            },
                          },
                        }}
                        renderOption={(props, option) => {
                          const { key, ...optionProps } = props;

                          return (
                            <Box
                              component="li"
                              key={key}
                              {...optionProps}
                              sx={{
                                display: "flex !important",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              {/* Green Icon */}
                              <Box
                                sx={{
                                  width: 25,
                                  height: 25,

                                  borderRadius: "6px",

                                  bgcolor: "#f0fdf4",
                                  color: "#16a34a",

                                  border: "1px solid #bbf7d0",

                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",

                                  flexShrink: 0,
                                }}
                              >
                                <MedicalInformationIcon
                                  sx={{
                                    fontSize: ".75rem",
                                  }}
                                />
                              </Box>

                              <Box
                                sx={{
                                  minWidth: 0,
                                  flex: 1,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: ".78rem",
                                    fontWeight: 600,
                                    color: "#334155",

                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontSize: ".6rem",
                                    color: "#94a3b8",
                                    mt: 0.1,
                                  }}
                                >
                                  From clinical diagnosis master
                                </Typography>
                              </Box>
                            </Box>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputRef={diagnosisInputRef}
                            variant="standard"
                            placeholder={
                              diagnosis.length
                                ? "Search or add another..."
                                : "Search diagnosis or enter custom diagnosis..."
                            }
                            onKeyDown={handleDiagnosisKeyDown}
                            InputProps={{
                              ...params.InputProps,

                              disableUnderline: true,

                              endAdornment: diagnosisLoading ? (
                                <CircularProgress
                                  size={15}
                                  sx={{
                                    color: "#16a34a",
                                    mr: 0.5,
                                  }}
                                />
                              ) : null,
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                p: "0 !important",
                              },

                              "& input": {
                                fontSize: ".82rem",
                                color: "#334155",

                                p: "4px !important",

                                minWidth: "160px",

                                "&::placeholder": {
                                  color: "#94a3b8",
                                  opacity: 1,
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </Box>

                    <Box
                      sx={{
                        mt: 0.7,
                        ml: 0.25,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",

                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: ".62rem",
                          color: "#94a3b8",
                        }}
                      >
                        Search from diagnosis master or enter a custom diagnosis
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {activeTab === 1 && (
            <Box
              sx={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: "14px",
                overflow: "visible",
                boxShadow: "0 1px 3px rgba(15,23,42,0.04)",
              }}
            >
              {/* Content */}
              <Box
                sx={{
                  bgcolor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  overflow: "visible",
                  boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                }}
              >
                {/* ================= HEADER ================= */}
                <Box
                  sx={{
                    px: 2,
                    py: 1.25,
                    bgcolor: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {/* Icon */}
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        flexShrink: 0,
                        borderRadius: "8px",
                        bgcolor: "#eff6ff",
                        border: "1px solid #1976d2",
                        color: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ScienceIcon sx={{ fontSize: "1rem" }} />
                    </Box>

                    {/* Title */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".8rem",
                          fontWeight: 700,
                          color: "#0f172a",
                          lineHeight: 1.3,
                        }}
                      >
                        Investigation / Test
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".64rem",
                          color: "#94a3b8",
                          mt: 0.15,
                        }}
                      >
                        Search and add laboratory or diagnostic investigations
                      </Typography>
                    </Box>
                  </Box>

                  {/* Selected count */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.75,
                      flexShrink: 0,
                    }}
                  >
                    {/* Selected Count */}
                    {selectedTests.length > 0 && (
                      <Box
                        sx={{
                          px: 1,
                          py: 0.4,
                          borderRadius: "999px",
                          bgcolor: "#eff6ff",
                          border: "1px solid #bfdbfe",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: ".64rem",
                            fontWeight: 700,
                            color: "#2563eb",
                          }}
                        >
                          {selectedTests.length} selected
                        </Typography>
                      </Box>
                    )}

                    {/* Load Template */}
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={handleOpenInvestigationTemplates}
                      startIcon={
                        <LibraryBooksOutlinedIcon
                          sx={{
                            fontSize: ".85rem !important",
                          }}
                        />
                      }
                      sx={{
                        height: 30,
                        px: 1.15,
                        textTransform: "none",
                        whiteSpace: "nowrap",
                        fontSize: ".66rem",
                        fontWeight: 700,

                        color: "#1d4ed8",
                        bgcolor: "#fff",

                        border: "1px solid #bfdbfe",
                        borderRadius: "7px",

                        "&:hover": {
                          bgcolor: "#eff6ff",
                          borderColor: "#60a5fa",
                        },
                      }}
                    >
                      Load Template
                    </Button>
                  </Box>
                </Box>

                {/* ================= CONTENT ================= */}

                <Box sx={{ p: 2 }}>
                  <Box
                    sx={{
                      minHeight: 54,
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",

                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                      flexWrap: "wrap",

                      gap: 0.75,

                      px: 1,
                      py: 0.8,

                      cursor: "text",

                      bgcolor: "#fff",

                      transition: "all .15s ease",

                      "&:hover": {
                        borderColor: "#bfdbfe",
                      },

                      "&:focus-within": {
                        borderColor: "#2563eb",
                        boxShadow: "0 0 0 3px rgba(37,99,235,.10)",
                      },
                    }}
                    onClick={() => investigationInputRef.current?.focus()}
                  >
                    {/* Chips */}
                    {selectedTests.map((item, index) => (
                      <Box
                        key={`${item}-${index}`}
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          maxWidth: "100%",
                          m: 0.5,
                        }}
                      >
                        {/* Edit Button */}
                        <Tooltip title="Edit investigation" arrow>
                          <IconButton
                            size="small"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleEditInvestigation(index);
                            }}
                            sx={{
                              position: "absolute",
                              top: -7,
                              left: -7,

                              width: 17,
                              height: 17,

                              zIndex: 2,

                              bgcolor: "#fff",
                              color: "#2563eb",

                              border: "1px solid #93c5fd",

                              boxShadow: "0 1px 3px rgba(15,23,42,.15)",

                              "&:hover": {
                                bgcolor: "#eff6ff",
                                color: "#1d4ed8",
                                borderColor: "#60a5fa",
                              },
                            }}
                          >
                            <EditOutlinedIcon
                              sx={{
                                fontSize: ".58rem",
                              }}
                            />
                          </IconButton>
                        </Tooltip>

                        {/* Investigation Chip */}
                        <Chip
                          label={item}
                          onDelete={() => removeInvestigation(index)}
                          size="small"
                          sx={{
                            height: 29,
                            borderRadius: "7px",

                            bgcolor: "#eff6ff",
                            color: "#2563eb",

                            border: "1px solid #93c5fd",

                            fontSize: ".74rem",
                            fontWeight: 600,

                            "& .MuiChip-label": {
                              px: 1,
                              pl: 1.2,
                            },

                            "& .MuiChip-deleteIcon": {
                              fontSize: 16,
                              color: "#3b82f6",

                              "&:hover": {
                                color: "#1d4ed8",
                              },
                            },

                            "&:hover": {
                              bgcolor: "#dbeafe",
                            },
                          }}
                        />
                      </Box>
                    ))}

                    {/* Autocomplete */}
                    <Autocomplete
                      freeSolo
                      disableClearable
                      options={investigationSuggestions}
                      inputValue={investigationInput}
                      loading={investigationLoading}
                      open={investigationPopupOpen}
                      onOpen={() => setInvestigationPopupOpen(true)}
                      onClose={() => setInvestigationPopupOpen(false)}
                      filterOptions={(options) => options}
                      onInputChange={(event, newValue, reason) => {
                        if (reason === "input") {
                          setInvestigationInput(newValue);
                        }
                      }}
                      onChange={(event, newValue, reason) => {
                        if (!newValue) return;

                        if (reason === "selectOption") {
                          addInvestigation(newValue);
                          setInvestigationInput("");
                          setInvestigationPopupOpen(false);
                          return;
                        }

                        if (reason === "createOption") {
                          addInvestigation(newValue);
                          setInvestigationInput("");
                          setInvestigationPopupOpen(false);
                          return;
                        }
                      }}
                      noOptionsText={
                        investigationInput.trim()
                          ? "No matching investigation found"
                          : "Start typing to search"
                      }
                      loadingText="Searching investigations..."
                      sx={{
                        flex: 1,
                        minWidth: 180,

                        "& .MuiAutocomplete-inputRoot": {
                          p: "0 !important",
                        },

                        "& .MuiAutocomplete-endAdornment": {
                          right: "2px !important",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputRef={investigationInputRef}
                          variant="standard"
                          placeholder={
                            selectedTests.length
                              ? "Search or add another..."
                              : "Search investigation or enter custom investigation..."
                          }
                          onKeyDown={handleInvestigationKeyDown}
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,

                            endAdornment: investigationLoading ? (
                              <CircularProgress
                                size={15}
                                sx={{
                                  color: "#2563eb",
                                  mr: 0.5,
                                }}
                              />
                            ) : null,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              p: "0 !important",
                            },

                            "& input": {
                              fontSize: ".82rem",
                              color: "#334155",
                              p: "4px !important",
                              minWidth: "160px",

                              "&::placeholder": {
                                color: "#94a3b8",
                                opacity: 1,
                              },
                            },
                          }}
                        />
                      )}
                      /* Keep your existing renderOption, paper, and listbox styles */
                      slotProps={{
                        paper: {
                          sx: {
                            mt: 0.75,
                            borderRadius: "10px",
                            border: "1px solid #bfdbfe",
                            boxShadow:
                              "0 10px 30px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.04)",
                            overflow: "hidden",
                            bgcolor: "#fff",
                          },
                        },

                        listbox: {
                          sx: {
                            p: 0.6,
                            maxHeight: 280,

                            "& .MuiAutocomplete-option": {
                              minHeight: 42,
                              borderRadius: "8px",
                              px: 1.1,
                              py: 0.8,
                              mb: 0.25,
                              transition: "all .12s ease",

                              "&:hover": {
                                bgcolor: "#eff6ff",
                                color: "#1d4ed8",
                              },

                              "&.Mui-focused": {
                                bgcolor: "#eff6ff",
                                color: "#1d4ed8",
                              },

                              '&[aria-selected="true"]': {
                                bgcolor: "#dbeafe",
                                color: "#1d4ed8",
                              },
                            },
                          },
                        },
                      }}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;

                        return (
                          <Box
                            component="li"
                            key={key}
                            {...optionProps}
                            sx={{
                              display: "flex !important",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                width: 28,
                                height: 28,
                                flexShrink: 0,
                                borderRadius: "7px",
                                bgcolor: "#eff6ff",
                                color: "#2563eb",
                                border: "1px solid #bfdbfe",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <ScienceIcon sx={{ fontSize: ".8rem" }} />
                            </Box>

                            <Box
                              sx={{
                                flex: 1,
                                minWidth: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  fontSize: ".78rem",
                                  color: "#334155",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {option}
                              </Typography>

                              <Typography
                                sx={{
                                  mt: 0.1,
                                  fontSize: ".6rem",
                                  color: "#94a3b8",
                                }}
                              >
                                From investigation master
                              </Typography>
                            </Box>
                          </Box>
                        );
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      mt: 0.75,
                      px: 0.25,

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",

                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: ".62rem",
                        color: "#94a3b8",
                      }}
                    >
                      Search from investigation master or enter a custom
                      investigation
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: ".6rem",
                        color: "#94a3b8",

                        display: {
                          xs: "none",
                          sm: "block",
                        },
                      }}
                    >
                      ↑ ↓ Navigate · Enter Select · ⌫ Remove
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {activeTab === 2 && (
            <Box
              sx={{
                background: "#fff",
                border: "1px solid #e5e9ef",
                borderRadius: "14px",
                overflow: "hidden",
                boxShadow: "0 1px 6px rgba(10,31,68,0.05)",
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.25,
                  bgcolor: "#f8fafc",
                  borderBottom: "1px solid #c2d1e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                }}
              >
                {/* Left */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 30,
                      height: 30,
                      borderRadius: "8px",

                      bgcolor: "#ffedd5",
                      color: "#ea580c",
                      border: "1px solid #ea580c",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MedicationIcon sx={{ fontSize: "1rem" }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: ".8rem",
                        fontWeight: 700,
                        color: "#0f172a",
                        lineHeight: 1.3,
                      }}
                    >
                      Medicines & Dosage
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: ".64rem",
                        color: "#94a3b8",
                        mt: 0.1,
                      }}
                    >
                      Add medicines, dosage, duration and instructions
                    </Typography>
                  </Box>
                </Box>

                {/* Right */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    flexShrink: 0,
                  }}
                >
                  {/* Medicine Count */}
                  {rows.filter((row) => row.medicine?.trim()).length > 0 && (
                    <Box
                      sx={{
                        px: 1,
                        py: 0.4,
                        borderRadius: "999px",

                        bgcolor: "#fff7ed",
                        border: "1px solid #fed7aa",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: ".64rem",
                          fontWeight: 700,
                          color: "#c2410c",
                        }}
                      >
                        {rows.filter((row) => row.medicine?.trim()).length}{" "}
                        added
                      </Typography>
                    </Box>
                  )}

                  {/* Load Template */}
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={handleOpenMedicineTemplates}
                    startIcon={
                      <LibraryBooksOutlinedIcon
                        sx={{
                          fontSize: ".85rem !important",
                        }}
                      />
                    }
                    sx={{
                      height: 30,
                      px: 1.15,

                      textTransform: "none",
                      whiteSpace: "nowrap",

                      fontSize: ".66rem",
                      fontWeight: 700,

                      color: "#c2410c",
                      bgcolor: "#fff",

                      border: "1px solid #fed7aa",
                      borderRadius: "7px",

                      "&:hover": {
                        bgcolor: "#fff7ed",
                        borderColor: "#fb923c",
                      },
                    }}
                  >
                    Load Template
                  </Button>
                </Box>
              </Box>
              <Table
                stickyHeader
                size="small"
                sx={{
                  tableLayout: "fixed",
                  borderCollapse: "separate",
                  borderSpacing: 0,

                  "& .MuiTableCell-root": {
                    borderRight: "1px solid #edf2f7",
                  },

                  "& .MuiTableCell-root:last-child": {
                    borderRight: "none",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& .MuiTableCell-head": {
                        background: "#f8fafc",
                        color: "#475569",
                        fontWeight: 700,
                        py: 1.2,
                        px: 1,
                        borderBottom: "2px solid #dbe4ec",
                      },
                    }}
                  >
                    {/* Serial No */}
                    <TableCell
                      align="center"
                      sx={{
                        width: 55,
                        fontSize: ".7rem",
                      }}
                    >
                      #
                    </TableCell>

                    {fields.map((f) => {
                      const meta = {
                        medicine: {
                          label: "Medicine",
                          icon: (
                            <MedicationIcon
                              sx={{ fontSize: "1rem", color: "primary.main" }}
                            />
                          ),
                        },
                        morning: {
                          label: "Morning",
                        },
                        afternoon: {
                          label: "Afternoon",
                        },
                        evening: {
                          label: "Evening",
                        },
                        night: {
                          label: "Night",
                        },
                        duration: {
                          label: "Duration",
                        },
                        durationType: {
                          label: "Frequency",
                        },
                        note: {
                          label: "Note",
                        },
                      }[f];

                      return (
                        <TableCell
                          key={f}
                          align="center"
                          sx={{
                            width:
                              f === "medicine"
                                ? "25%"
                                : [
                                      "morning",
                                      "afternoon",
                                      "evening",
                                      "night",
                                      "duration",
                                    ].includes(f)
                                  ? 80
                                  : f === "durationType"
                                    ? 100
                                    : "auto",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: ".62rem",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: ".4px",
                            }}
                          >
                            {meta.label}
                          </Typography>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row, rowIndex) => {
                    if (!inputRefs.current[rowIndex])
                      inputRefs.current[rowIndex] = [];

                    return (
                      <TableRow
                        hover
                        key={rowIndex}
                        sx={{
                          backgroundColor:
                            rowIndex % 2 === 0 ? "#fff" : "#fafbfc",

                          transition: ".15s",

                          "&:hover": {
                            backgroundColor: "#f5f9ff",
                          },

                          "& .MuiTableCell-root": {
                            py: 1,
                            px: 0.75,
                            borderBottom: "1px solid #edf2f7",
                          },
                        }}
                      >
                        {/* Serial Number */}

                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            background: "#fafbfc",
                            fontSize: ".82rem",
                          }}
                        >
                          {rowIndex + 1}
                        </TableCell>

                        {fields.map((field, colIndex) => {
                          const isDose = [
                            "morning",
                            "afternoon",
                            "evening",
                            "night",
                            "duration",
                          ].includes(field);

                          return (
                            <TableCell
                              key={field}
                              align={isDose ? "center" : "left"}
                            >
                              <TextField
                                fullWidth
                                size="small"
                                value={row[field]}
                                inputRef={(el) =>
                                  (inputRefs.current[rowIndex][colIndex] = el)
                                }
                                onChange={(e) => {
                                  if (isDose && !/^\d*$/.test(e.target.value))
                                    return;

                                  handleTyping(
                                    { target: { value: e.target.value } },
                                    rowIndex,
                                    field,
                                  );
                                }}
                                onBlur={() => {
                                  if (isDose && !row[field])
                                    updateCell(rowIndex, field, "0");
                                }}
                                onKeyDown={(e) =>
                                  handleTableKeyDown(
                                    e,
                                    rowIndex,
                                    colIndex,
                                    field,
                                  )
                                }
                                inputProps={{
                                  style: isDose
                                    ? {
                                        textAlign: "center",
                                        fontWeight: 700,
                                        fontSize: "1rem",
                                      }
                                    : {
                                        fontSize: ".85rem",
                                      },
                                  inputMode: isDose ? "numeric" : "text",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: 1,
                                    background: isDose ? "#f8fafc" : "#fff",

                                    "& fieldset": {
                                      borderColor: "#dbe4ec",
                                    },

                                    "&:hover fieldset": {
                                      borderColor: "primary.light",
                                    },

                                    "&.Mui-focused fieldset": {
                                      borderColor: "primary.main",
                                    },
                                  },
                                }}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          )}

          {activeTab === 3 && (
            <Box
              sx={{
                display: "grid",
                gap: 2,
              }}
            >
              {/* =====================================================
        ADVICE
    ===================================================== */}
              <Box
                sx={{
                  bgcolor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                }}
              >
                {/* Section heading */}
                <Box
                  sx={{
                    px: 2,
                    py: 1.25,
                    bgcolor: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                  }}
                >
                  {/* LEFT */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "8px",

                        bgcolor: "#fefce8",
                        color: "#ca8a04",
                        border: "1px solid #ca8a04",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <TipsAndUpdatesOutlinedIcon sx={{ fontSize: "1rem" }} />
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".8rem",
                          fontWeight: 700,
                          color: "#0f172a",
                        }}
                      >
                        Patient Advice
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".64rem",
                          color: "#94a3b8",
                        }}
                      >
                        Add instructions and recommendations for the patient
                      </Typography>
                    </Box>
                  </Box>

                  {/* RIGHT */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.75,
                      flexShrink: 0,
                    }}
                  >
                    {/* Count */}
                    {advices.length > 0 && (
                      <Box
                        sx={{
                          px: 1,
                          py: 0.4,
                          borderRadius: "999px",

                          bgcolor: "#fefce8",
                          border: "1px solid #fef08a",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: ".64rem",
                            fontWeight: 700,
                            color: "#a16207",
                          }}
                        >
                          {advices.length} added
                        </Typography>
                      </Box>
                    )}

                    {/* Load Template */}
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={handleOpenAdviceTemplates}
                      startIcon={
                        <LibraryBooksOutlinedIcon
                          sx={{
                            fontSize: ".85rem !important",
                          }}
                        />
                      }
                      sx={{
                        height: 30,
                        px: 1.15,

                        textTransform: "none",
                        whiteSpace: "nowrap",

                        fontSize: ".66rem",
                        fontWeight: 700,

                        color: "#a16207",
                        bgcolor: "#fff",

                        border: "1px solid #fde68a",
                        borderRadius: "7px",

                        "&:hover": {
                          bgcolor: "#fefce8",
                          borderColor: "#eab308",
                        },
                      }}
                    >
                      Load Template
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ p: 2 }}>
                  <Box
                    sx={{
                      minHeight: 54,
                      width: "100%",

                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",

                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",

                      gap: 0.75,

                      px: 1.25,
                      py: 0.8,

                      cursor: "text",

                      backgroundColor: "#fff",

                      transition: "all .15s ease",

                      "&:hover": {
                        borderColor: "#cbd5e1",
                      },

                      "&:focus-within": {
                        borderColor: "#facc15",
                        boxShadow: "0 0 0 3px rgba(234,179,8,.10)",
                      },
                    }}
                    onClick={() => adviceInputRef.current?.focus()}
                  >
                    {/* ==========================================
        ADVICE CHIPS
    ========================================== */}

                    {advices.map((item, index) => (
                      <Box
                        key={`${item}-${index}`}
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",

                          maxWidth: "100%",

                          m: 0.25,
                        }}
                      >
                        {/* Edit Button */}
                        <Tooltip title="Edit advice" arrow>
                          <IconButton
                            size="small"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleEditAdvice(index);
                            }}
                            sx={{
                              position: "absolute",

                              top: -7,
                              left: -7,

                              width: 17,
                              height: 17,

                              zIndex: 2,

                              p: 0,

                              bgcolor: "#fff",
                              color: "#ca8a04",

                              border: "1px solid #fde047",

                              boxShadow: "0 1px 3px rgba(15,23,42,.15)",

                              transition: "all .15s ease",

                              "&:hover": {
                                bgcolor: "#fefce8",
                                color: "#a16207",
                                borderColor: "#facc15",

                                transform: "scale(1.05)",
                              },
                            }}
                          >
                            <EditOutlinedIcon
                              sx={{
                                fontSize: ".58rem",
                              }}
                            />
                          </IconButton>
                        </Tooltip>

                        {/* Advice Chip */}
                        <Chip
                          label={item}
                          onDelete={() => removeAdvice(index)}
                          size="small"
                          sx={{
                            height: 29,

                            maxWidth: "100%",

                            borderRadius: "7px",

                            bgcolor: "#fefce8",
                            color: "#a16207",

                            border: "1px solid #fde047",

                            fontSize: ".74rem",
                            fontWeight: 600,

                            "& .MuiChip-label": {
                              px: 1,
                              pl: 1.25,

                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            },

                            "& .MuiChip-deleteIcon": {
                              fontSize: 16,

                              color: "#eab308",

                              mr: 0.4,

                              "&:hover": {
                                color: "#a16207",
                              },
                            },

                            "&:hover": {
                              bgcolor: "#fef9c3",
                            },
                          }}
                        />
                      </Box>
                    ))}

                    {/* ==========================================
        ADVICE SEARCH / INPUT
    ========================================== */}
                    {/* advice autocomplete */}
                    <Autocomplete
                      freeSolo
                      disableClearable
                      options={adviceSuggestions}
                      inputValue={adviceInput}
                      loading={adviceLoading}
                      filterOptions={(options) => options}
                      open={advicePopupOpen}
                      onOpen={() => setAdvicePopupOpen(true)}
                      onClose={() => setAdvicePopupOpen(false)}
                      /* ===== Typing ===== */
                      onInputChange={(event, newValue, reason) => {
                        if (reason === "input") {
                          setAdviceInput(newValue);
                        }
                      }}
                      /* ===== Dropdown Selection / Free Solo Enter ===== */
                      onChange={(event, newValue, reason) => {
                        if (!newValue) return;

                        if (reason === "selectOption") {
                          addAdvice(newValue);
                          setAdviceInput("");
                          setAdvicePopupOpen(false);
                          return;
                        }

                        if (reason === "createOption") {
                          addAdvice(newValue);
                          setAdviceInput("");
                          setAdvicePopupOpen(false);
                          return;
                        }
                      }}
                      noOptionsText={
                        adviceInput.trim()
                          ? "No matching advice found"
                          : "Start typing to search"
                      }
                      loadingText="Searching advice..."
                      sx={{
                        flex: 1,
                        minWidth: 180,

                        "& .MuiAutocomplete-inputRoot": {
                          p: "0 !important",
                        },

                        "& .MuiAutocomplete-endAdornment": {
                          right: "2px !important",
                        },
                      }}
                      slotProps={{
                        paper: {
                          sx: {
                            mt: 0.75,

                            borderRadius: "10px",

                            border: "1px solid #fde68a",

                            boxShadow:
                              "0 10px 30px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.04)",

                            overflow: "hidden",

                            bgcolor: "#fff",
                          },
                        },

                        listbox: {
                          sx: {
                            p: 0.6,
                            maxHeight: 250,

                            "& .MuiAutocomplete-option": {
                              minHeight: 38,

                              borderRadius: "7px",

                              px: 1.2,
                              py: 0.8,

                              mb: 0.2,

                              fontSize: ".78rem",
                              fontWeight: 500,

                              color: "#334155",

                              transition: "all .12s ease",

                              "&:hover": {
                                bgcolor: "#fef9c3",
                                color: "#a16207",
                              },

                              "&.Mui-focused": {
                                bgcolor: "#fef9c3",
                                color: "#a16207",
                              },

                              '&[aria-selected="true"]': {
                                bgcolor: "#fef3c7",
                                color: "#a16207",
                              },
                            },
                          },
                        },
                      }}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;

                        return (
                          <Box
                            component="li"
                            key={key}
                            {...optionProps}
                            sx={{
                              display: "flex !important",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            {/* Advice Icon */}
                            <Box
                              sx={{
                                width: 25,
                                height: 25,

                                borderRadius: "6px",

                                bgcolor: "#fefce8",
                                color: "#ca8a04",

                                border: "1px solid #fde68a",

                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                                flexShrink: 0,
                              }}
                            >
                              <TipsAndUpdatesOutlinedIcon
                                sx={{
                                  fontSize: ".75rem",
                                }}
                              />
                            </Box>

                            {/* Advice Text */}
                            <Box
                              sx={{
                                minWidth: 0,
                                flex: 1,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: ".78rem",
                                  fontWeight: 600,
                                  color: "#334155",

                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {option}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: ".6rem",
                                  color: "#94a3b8",
                                  mt: 0.1,
                                }}
                              >
                                From advice master
                              </Typography>
                            </Box>
                          </Box>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputRef={adviceInputRef}
                          variant="standard"
                          placeholder={
                            advices.length
                              ? "Search or add another..."
                              : "Search advice or enter custom advice..."
                          }
                          onKeyDown={handleAdviceKeyDown}
                          InputProps={{
                            ...params.InputProps,

                            disableUnderline: true,

                            endAdornment: adviceLoading ? (
                              <CircularProgress
                                size={15}
                                sx={{
                                  color: "#ca8a04",
                                  mr: 0.5,
                                }}
                              />
                            ) : null,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              p: "0 !important",
                            },

                            "& input": {
                              fontSize: ".82rem",
                              color: "#334155",

                              p: "4px !important",

                              minWidth: "160px",

                              "&::placeholder": {
                                color: "#94a3b8",
                                opacity: 1,
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </Box>

                  {/* Helper Text */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,

                      mt: 0.7,
                      ml: 0.25,
                    }}
                  >
                    <TipsAndUpdatesOutlinedIcon
                      sx={{
                        fontSize: ".72rem",
                        color: "#ca8a04",
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: ".62rem",
                        color: "#94a3b8",
                      }}
                    >
                      Search from advice suggestions or type your own. Press
                      Enter or Comma to add.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* =====================================================
        FOLLOW UP + REFERRAL
    ===================================================== */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    md: "1fr 1fr",
                  },
                  gap: 2,
                }}
              >
                {/* ================= NEXT VISIT ================= */}
                <Box
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.25,
                      bgcolor: "#f8fafc",
                      borderBottom: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          marginRight: 1,
                          borderRadius: "8px",
                          bgcolor: "#ecfdf5",
                          color: "#059669",
                          border: "1px solid #059669",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <EventRepeatOutlinedIcon sx={{ fontSize: "1rem" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: ".8rem",
                            fontWeight: 700,
                            color: "#0f172a",
                          }}
                        >
                          Next Visit
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: ".64rem",
                            color: "#94a3b8",
                          }}
                        >
                          Schedule the patient's follow-up
                        </Typography>
                      </Box>
                    </Box>

                    <ToggleButtonGroup
                      exclusive
                      value={nextVisitMode}
                      onChange={(e, value) => {
                        if (value) setNextVisitMode(value);
                      }}
                      size="small"
                      sx={{
                        "& .MuiToggleButton-root": {
                          textTransform: "none",
                          fontSize: ".72rem",
                          fontWeight: 600,
                          px: 1.5,
                          py: 0.6,
                          color: "#64748b",
                          borderColor: "#e2e8f0",

                          "&.Mui-selected": {
                            bgcolor: "#eff6ff",
                            color: "primary.main",
                            borderColor: "#bfdbfe",

                            "&:hover": {
                              bgcolor: "#dbeafe",
                            },
                          },
                        },
                      }}
                    >
                      <ToggleButton value="after">After Period</ToggleButton>

                      <ToggleButton value="date">Select Date</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>

                  <Box sx={{ p: 2 }}>
                    {/* After / Date switch */}
                    {/* <ToggleButtonGroup
                      exclusive
                      value={nextVisitMode}
                      onChange={(e, value) => {
                        if (value) setNextVisitMode(value);
                      }}
                      size="small"
                      sx={{
                        mb: 1.5,

                        "& .MuiToggleButton-root": {
                          textTransform: "none",
                          fontSize: ".72rem",
                          fontWeight: 600,
                          px: 1.5,
                          py: 0.6,
                          color: "#64748b",
                          borderColor: "#e2e8f0",

                          "&.Mui-selected": {
                            bgcolor: "#eff6ff",
                            color: "primary.main",
                            borderColor: "#bfdbfe",

                            "&:hover": {
                              bgcolor: "#dbeafe",
                            },
                          },
                        },
                      }}
                    >
                      <ToggleButton value="after">After Period</ToggleButton>

                      <ToggleButton value="date">Select Date</ToggleButton>
                    </ToggleButtonGroup> */}

                    {nextVisitMode === "after" ? (
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "1fr",
                            sm: "1fr 160px",
                          },
                          gap: 1.5,
                          alignItems: "end",
                        }}
                      >
                        {/* Follow-up Value */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: ".68rem",
                              fontWeight: 600,
                              color: "#64748b",
                              mb: 0.65,
                            }}
                          >
                            Follow-up After
                          </Typography>

                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            value={nextVisitValue}
                            onChange={(e) => setNextVisitValue(e.target.value)}
                            placeholder="e.g. 7"
                            inputProps={{
                              min: 1,
                            }}
                            sx={fieldStyle}
                          />
                        </Box>

                        {/* Period */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: ".68rem",
                              fontWeight: 600,
                              color: "#64748b",
                              mb: 0.65,
                            }}
                          >
                            Period
                          </Typography>

                          <TextField
                            select
                            fullWidth
                            size="small"
                            value={nextVisitUnit}
                            onChange={(e) => setNextVisitUnit(e.target.value)}
                            sx={fieldStyle}
                          >
                            <MenuItem value="days">Days</MenuItem>
                            <MenuItem value="weeks">Weeks</MenuItem>
                            <MenuItem value="months">Months</MenuItem>
                          </TextField>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography
                          sx={{
                            fontSize: ".68rem",
                            fontWeight: 600,
                            color: "#64748b",
                            mb: 0.65,
                          }}
                        >
                          Select Date
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          type="date"
                          value={nextVisitDate}
                          onChange={(e) => setNextVisitDate(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarMonthOutlinedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: "#94a3b8",
                                  }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          sx={fieldStyle}
                        />
                      </>
                    )}
                  </Box>
                </Box>

                {/* ================= REFERRED TO ================= */}
                <Box
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 1px 3px rgba(15,23,42,.04)",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.25,
                      bgcolor: "#f8fafc",
                      borderBottom: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "8px",
                        bgcolor: "#f5f3ff",
                        color: "#7c3aed",
                        border: "1px solid #7c3aed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PersonSearchOutlinedIcon sx={{ fontSize: "1rem" }} />
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".8rem",
                          fontWeight: 700,
                          color: "#0f172a",
                        }}
                      >
                        Referred To
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".64rem",
                          color: "#94a3b8",
                        }}
                      >
                        Refer patient to another doctor or specialist
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ p: 2 }}>
                    <Typography
                      sx={{
                        fontSize: ".68rem",
                        fontWeight: 600,
                        color: "#64748b",
                        mb: 0.65,
                      }}
                    >
                      Doctor / Specialist
                    </Typography>

                    <TextField
                      fullWidth
                      size="small"
                      value={referredDoctor}
                      onChange={(e) => setReferredDoctor(e.target.value)}
                      placeholder="Enter doctor or specialist name..."
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonSearchOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: "#94a3b8",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      sx={fieldStyle}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {/* <Box
            sx={{
              mt: 2.5,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
            }}
          >
            {!isEditMode ? (
              <Button
                onClick={handleSubmitPrescription}
                variant="contained"
                startIcon={<SaveIcon sx={{ fontSize: "0.95rem !important" }} />}
                sx={{
                  background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  borderRadius: "10px",
                  px: 3,
                  py: 1,
                  boxShadow: "0 4px 14px rgba(185,58,207,0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg,#1e3d8a,#a02db8)",
                    boxShadow: "0 6px 20px rgba(185,58,207,0.4)",
                  },
                }}
              >
                Save Prescription
              </Button>
            ) : (
              <Button
                onClick={handleUpdatePrescription}
                variant="contained"
                startIcon={<EditIcon sx={{ fontSize: "0.95rem !important" }} />}
                sx={{
                  background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  borderRadius: "10px",
                  px: 3,
                  py: 1,
                  boxShadow: "0 4px 14px rgba(16,185,129,0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg,#064e3b,#0f6e56)",
                    boxShadow: "0 6px 20px rgba(16,185,129,0.4)",
                  },
                }}
              >
                Update Prescription
              </Button>
            )}
          </Box> */}
        </Box>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            right: 0,
            left: 0,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1.5,

            px: { xs: 2, md: 3 },
            py: 1.5,

            background: "rgba(255,255,255,0.96)",
            backdropFilter: "blur(10px)",
            borderTop: "1px solid #e2e8f0",
            boxShadow: "0 -4px 20px rgba(15,23,42,0.08)",
          }}
        >
          {!isEditMode ? (
            <Box sx={{ display: "flex", gap: 1.25 }}>
              {/* Hold */}
              <Button
                onClick={handleHoldPrescription}
                variant="outlined"
                startIcon={
                  <PauseCircleOutlineRoundedIcon
                    sx={{ fontSize: "1rem !important" }}
                  />
                }
                sx={{
                  color: "#c2410c",
                  backgroundColor: "#fff7ed",
                  border: "1px solid #fdba74",

                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.85rem",

                  borderRadius: "10px",
                  px: 2.5,
                  py: 1,

                  transition: "all .2s ease",

                  "&:hover": {
                    backgroundColor: "#ffedd5",
                    borderColor: "#f97316",
                    color: "#9a3412",
                    boxShadow: "0 4px 12px rgba(249,115,22,.18)",
                  },
                }}
              >
                Hold this prescription
              </Button>

              {/* Proceed To Save */}
              <Button
                onClick={handleSubmitPrescription}
                variant="contained"
                startIcon={<SaveIcon sx={{ fontSize: "0.95rem !important" }} />}
                sx={{
                  background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  borderRadius: "10px",
                  px: 3,
                  py: 1,
                  boxShadow: "0 4px 14px rgba(16,185,129,0.25)",

                  "&:hover": {
                    background: "linear-gradient(135deg,#064e3b,#0f6e56)",
                    boxShadow: "0 6px 20px rgba(16,185,129,0.35)",
                  },
                }}
              >
                Proceed To Save
              </Button>
            </Box>
          ) : (
            <Button
              onClick={handleUpdatePrescription}
              variant="contained"
              startIcon={<EditIcon sx={{ fontSize: "0.95rem !important" }} />}
              sx={{
                background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                color: "#fff",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.85rem",
                borderRadius: "10px",
                px: 3,
                py: 1,
                boxShadow: "0 4px 14px rgba(16,185,129,0.25)",

                "&:hover": {
                  background: "linear-gradient(135deg,#064e3b,#0f6e56)",
                  boxShadow: "0 6px 20px rgba(16,185,129,0.35)",
                },
              }}
            >
              Update Prescription
            </Button>
          )}
        </Box>
      </Paper>

      {/* ══ Duration type / generic dialog ══ */}
      <Dialog
        open={openDialog}
        fullWidth
        maxWidth="xs"
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "1px solid #e5e9ef",
            boxShadow: "0 20px 60px rgba(10,31,68,0.15)",
          },
        }}
      >
        <Box sx={{ px: 2.5, py: 2, borderBottom: "1px solid #e5e9ef" }}>
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.92rem", color: "#0a1f44" }}
          >
            {dialogField === "medicine"
              ? "Select Medicine"
              : "Select Duration Type"}
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <TextField
            fullWidth
            autoFocus
            placeholder="Type to search…"
            value={dialogSearch}
            onChange={(e) => {
              setDialogSearch(e.target.value);
              setHighlightIndex(0);
            }}
            onKeyDown={(e) => handleDialogKeyDown(e, filteredOptions)}
            size="small"
            sx={{
              mb: 1.5,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                "& fieldset": { borderColor: "#e5e9ef" },
                "&.Mui-focused fieldset": {
                  borderColor: "#b93acf",
                  borderWidth: "1.5px",
                },
              },
            }}
          />
          <List sx={{ py: 0 }}>
            {filteredOptions.map((opt, index) => (
              <ListItemButton
                key={opt}
                selected={index === highlightIndex}
                onClick={() => handleDialogSelect(opt)}
                sx={{
                  borderRadius: "8px",
                  mb: 0.3,
                  fontSize: "0.85rem",
                  "&.Mui-selected": {
                    background:
                      "linear-gradient(135deg,rgba(42,84,166,0.1),rgba(185,58,207,0.08))",
                    border: "1px solid rgba(185,58,207,0.18)",
                  },
                }}
              >
                {opt}
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Dialog>

      {/* ══ Medicine selection dialog ══ */}
      <Dialog
        open={medicineModalOpen}
        onClose={() => setMedicineModalOpen(false)}
        maxWidth="sm"
        fullWidth
        onKeyDown={handleMedicineModalKeyDown}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "1px solid #e5e9ef",
            boxShadow: "0 20px 60px rgba(10,31,68,0.15)",
          },
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: "1px solid #e5e9ef",
            display: "flex",
            alignItems: "center",
            gap: 1.25,
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "8px",
              background: "linear-gradient(135deg,#f97316,#b93acf)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MedicationIcon sx={{ color: "#fff", fontSize: "0.95rem" }} />
          </Box>
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.92rem", color: "#0a1f44" }}
          >
            Select Medicine
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <TextField
            fullWidth
            autoFocus
            placeholder="Search medicine…"
            value={medicineSearch}
            onChange={(e) => {
              setMedicineSearch(e.target.value);
              searchMedicinesFromAPI(e.target.value, dialogRowIndex);
            }}
            size="small"
            sx={{
              mb: 1.5,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                "& fieldset": { borderColor: "#e5e9ef" },
                "&.Mui-focused fieldset": {
                  borderColor: "#b93acf",
                  borderWidth: "1.5px",
                },
              },
            }}
          />
          <List sx={{ maxHeight: 350, overflow: "auto", py: 0 }}>
            {medicineResults.length > 0 ? (
              medicineResults.map((med, index) => (
                <ListItem key={med._id} disablePadding>
                  <ListItemButton
                    selected={medicineHighlightIndex === index}
                    onClick={() => handleMedicineSelect(med)}
                    sx={{
                      borderRadius: "10px",
                      mb: 0.3,
                      "&.Mui-selected": {
                        background:
                          "linear-gradient(135deg,rgba(249,115,22,0.1),rgba(185,58,207,0.08))",
                        border: "1px solid rgba(185,58,207,0.2)",
                      },
                      "&:hover": { background: "rgba(42,84,166,0.04)" },
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color: "#0a1f44",
                          }}
                        >
                          {med.name}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          sx={{ fontSize: "0.72rem", color: "#64748b" }}
                        >
                          {med.brand}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))
            ) : (
              <ListItem>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: "0.82rem", color: "#94a3b8" }}>
                      No medicine found
                    </Typography>
                  }
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Dialog>

      <Dialog
        open={templateDialogOpen}
        onClose={() => setTemplateDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(15,23,42,.18)",
          },
        }}
      >
        {/* ================= HEADER ================= */}
        <Box
          sx={{
            px: 2.5,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #e2e8f0",
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.3 }}>
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "10px",
                bgcolor: "primary.main",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 10px rgba(37,99,235,.20)",
              }}
            >
              <SaveIcon sx={{ fontSize: "1.1rem" }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".95rem",
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                Save Prescription
              </Typography>

              <Typography
                sx={{
                  fontSize: ".7rem",
                  color: "#64748b",
                  mt: 0.2,
                }}
              >
                Optionally save reusable templates before completing the
                prescription
              </Typography>
            </Box>
          </Box>

          <Button
            onClick={() => setTemplateDialogOpen(false)}
            sx={{
              minWidth: 34,
              width: 34,
              height: 34,
              borderRadius: "8px",
              color: "#64748b",
            }}
          >
            <CloseIcon sx={{ fontSize: "1.1rem" }} />
          </Button>
        </Box>

        {/* ================= CONTENT ================= */}
        <DialogContent
          sx={{
            p: 2.5,
            bgcolor: "#f8fafc",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.25,
            }}
          >
            <TemplateSection
              icon={<DescriptionOutlinedIcon />}
              color="blue"
              title="Entire Prescription"
              subtitle="Save this complete prescription structure as a template"
              selected={templateSelections.prescription.selected}
              templateName={templateSelections.prescription.name}
              onSwitch={(checked) =>
                handleTemplateSwitch("prescription", checked)
              }
              onNameChange={(value) =>
                handleTemplateNameChange("prescription", value)
              }
              highlighted
            >
              <Box
                sx={{
                  mb: 1.25,
                  p: 1.25,
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  bgcolor: "#f8fafc",

                  display: "grid",
                  gridTemplateColumns: {
                    xs: "repeat(2, 1fr)",
                    sm: "repeat(3, 1fr)",
                    md: "repeat(6, 1fr)",
                  },
                  gap: 0,
                }}
              >
                {[
                  {
                    label: "Height",
                    value: pendingPrescriptionPayload?.vitals?.height
                      ? `${pendingPrescriptionPayload.vitals.height} cm`
                      : "—",
                  },
                  {
                    label: "Weight",
                    value: pendingPrescriptionPayload?.vitals?.weight
                      ? `${pendingPrescriptionPayload.vitals.weight} kg`
                      : "—",
                  },
                  {
                    label: "Pulse",
                    value: pendingPrescriptionPayload?.vitals?.pulse
                      ? `${pendingPrescriptionPayload.vitals.pulse} bpm`
                      : "—",
                  },
                  {
                    label: "Blood Pressure",
                    value: pendingPrescriptionPayload?.vitals?.bp || "—",
                  },
                  {
                    label: "Next Visit",
                    value: pendingPrescriptionPayload?.nextVisitDate || "—",
                  },
                  {
                    label: "Referred To",
                    value: pendingPrescriptionPayload?.referredDoctor || "—",
                  },
                ].map((item, index, arr) => (
                  <Box
                    key={item.label}
                    sx={{
                      px: 1.25,
                      py: 0.5,
                      minWidth: 0,

                      borderRight: {
                        xs: "none",
                        md:
                          index < arr.length - 1 ? "1px solid #e2e8f0" : "none",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: ".58rem",
                        fontWeight: 700,
                        color: "#94a3b8",
                        textTransform: "uppercase",
                        letterSpacing: ".45px",
                        mb: 0.35,
                      }}
                    >
                      {item.label}
                    </Typography>

                    <Typography
                      title={String(item.value)}
                      sx={{
                        fontSize: ".75rem",
                        fontWeight: 700,
                        color: "#334155",
                        lineHeight: 1.3,

                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {!prescriptionDetailView && (
                <Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(5, 1fr)",
                      },
                      gap: 1,
                    }}
                  >
                    {[
                      {
                        key: "symptoms",
                        label: "Symptoms",
                        value:
                          pendingPrescriptionPayload?.symptoms?.length || 0,
                        color: "#dc2626",
                        bg: "#fef2f2",
                        border: "#fecaca",
                      },
                      {
                        key: "diagnosis",
                        label: "Diagnosis",
                        value:
                          pendingPrescriptionPayload?.diagnosis?.length || 0,
                        color: "#16a34a",
                        bg: "#f0fdf4",
                        border: "#bbf7d0",
                      },
                      {
                        key: "investigations",
                        label: "Investigations",
                        value:
                          pendingPrescriptionPayload?.investigations?.length ||
                          0,
                        color: "#2563eb",
                        bg: "#eff6ff",
                        border: "#bfdbfe",
                      },
                      {
                        key: "medicines",
                        label: "Medicines",
                        value:
                          pendingPrescriptionPayload?.medicines?.length || 0,
                        color: "#ea580c",
                        bg: "#fff7ed",
                        border: "#fed7aa",
                      },
                      {
                        key: "advice",
                        label: "Advice",
                        value:
                          pendingPrescriptionPayload?.advicePayload?.length ||
                          0,
                        color: "#ca8a04",
                        bg: "#fefce8",
                        border: "#fef08a",
                      },
                    ].map((item) => (
                      <Box
                        key={item.key}
                        sx={{
                          position: "relative",

                          bgcolor: item.bg,
                          border: `1px solid ${item.border}`,
                          borderRadius: "10px",

                          p: 1.25,

                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",

                          transition: "all .15s ease",

                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 10px rgba(15,23,42,.07)",
                          },
                        }}
                      >
                        {/* Count */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "1rem",
                              fontWeight: 800,
                              color: item.color,
                              lineHeight: 1,
                            }}
                          >
                            {item.value}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: ".65rem",
                              fontWeight: 600,
                              color: "#64748b",
                              mt: 0.45,
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Box>

                        {/* View Details */}
                        <Box
                          onClick={() => setPrescriptionDetailView(item.key)}
                          title={`View ${item.label}`}
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,

                            width: 27,
                            height: 27,

                            borderRadius: "7px",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            bgcolor: "#fff",
                            color: item.color,

                            border: `1px solid ${item.border}`,

                            cursor: "pointer",

                            transition: "all .15s ease",

                            "&:hover": {
                              bgcolor: item.color,
                              color: "#fff",
                              transform: "scale(1.05)",
                            },
                          }}
                        >
                          <VisibilityIcon sx={{ fontSize: ".9rem" }} />
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {/* =====================================================
      DETAIL VIEW
  ===================================================== */}
              {prescriptionDetailView && (
                <Box>
                  {/* Detail Header */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1.25,
                      pb: 1,
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".78rem",
                          fontWeight: 700,
                          color: "#0f172a",
                          textTransform: "capitalize",
                        }}
                      >
                        {prescriptionDetailView === "investigations"
                          ? "Investigations"
                          : prescriptionDetailView === "medicines"
                            ? "Medicines"
                            : prescriptionDetailView === "diagnosis"
                              ? "Clinical Diagnosis"
                              : prescriptionDetailView === "advice"
                                ? "Patient Advice"
                                : "Symptoms / Patient History"}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".63rem",
                          color: "#94a3b8",
                          mt: 0.15,
                        }}
                      >
                        Prescription details
                      </Typography>
                    </Box>

                    <Button
                      size="small"
                      startIcon={
                        <ArrowBackIcon sx={{ fontSize: ".85rem !important" }} />
                      }
                      onClick={() => setPrescriptionDetailView(null)}
                      sx={{
                        textTransform: "none",
                        fontSize: ".68rem",
                        fontWeight: 600,
                        borderRadius: "7px",
                        color: "#475569",
                        bgcolor: "#f8fafc",
                        border: "1px solid #e2e8f0",

                        "&:hover": {
                          bgcolor: "#f1f5f9",
                        },
                      }}
                    >
                      Back to Overview
                    </Button>
                  </Box>

                  {/* =================================================
          SYMPTOMS
      ================================================= */}
                  {prescriptionDetailView === "symptoms" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.7,
                      }}
                    >
                      {(pendingPrescriptionPayload?.symptoms || []).length >
                      0 ? (
                        pendingPrescriptionPayload.symptoms.map(
                          (item, index) => (
                            <Chip
                              key={`${item}-${index}`}
                              label={item}
                              size="small"
                              sx={{
                                borderRadius: "7px",
                                bgcolor: "#fef2f2", // red-50
                                color: "#b91c1c", // red-700
                                border: "1px solid #fecaca", // red-200
                                fontWeight: 600,
                                fontSize: ".72rem",

                                "&:hover": {
                                  bgcolor: "#fee2e2", // red-100
                                },
                              }}
                            />
                          ),
                        )
                      ) : (
                        <EmptyText text="No symptoms added" />
                      )}
                    </Box>
                  )}

                  {/* =================================================
          DIAGNOSIS
      ================================================= */}
                  {prescriptionDetailView === "diagnosis" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.7,
                      }}
                    >
                      {(pendingPrescriptionPayload?.diagnosis || []).length >
                      0 ? (
                        pendingPrescriptionPayload.diagnosis.map(
                          (item, index) => (
                            <Chip
                              key={`${item}-${index}`}
                              label={item}
                              size="small"
                              sx={{
                                borderRadius: "7px",
                                bgcolor: "#f0fdf4",
                                color: "#15803d",
                                border: "1px solid #bbf7d0",
                                fontWeight: 600,
                                fontSize: ".72rem",
                              }}
                            />
                          ),
                        )
                      ) : (
                        <EmptyText text="No diagnosis added" />
                      )}
                    </Box>
                  )}

                  {/* =================================================
          INVESTIGATIONS
      ================================================= */}
                  {prescriptionDetailView === "investigations" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.7,
                      }}
                    >
                      {(pendingPrescriptionPayload?.investigations || [])
                        .length > 0 ? (
                        pendingPrescriptionPayload.investigations.map(
                          (item, index) => (
                            <Chip
                              key={`${item}-${index}`}
                              label={item}
                              size="small"
                              sx={{
                                borderRadius: "7px",
                                bgcolor: "#eff6ff",
                                color: "#1d4ed8",
                                border: "1px solid #bfdbfe",
                                fontWeight: 600,
                                fontSize: ".72rem",
                              }}
                            />
                          ),
                        )
                      ) : (
                        <EmptyText text="No investigations added" />
                      )}
                    </Box>
                  )}

                  {/* =================================================
          MEDICINES
      ================================================= */}
                  {prescriptionDetailView === "medicines" && (
                    <>
                      {(pendingPrescriptionPayload?.medicines || []).length >
                      0 ? (
                        <Box
                          sx={{
                            border: "1px solid #fed7aa",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {pendingPrescriptionPayload.medicines.map(
                            (medicine, index) => (
                              <Box
                                key={`${medicine.medicine}-${index}`}
                                sx={{
                                  px: 1.25,
                                  py: 1,

                                  bgcolor: index % 2 === 0 ? "#fff" : "#fffaf5",

                                  borderBottom:
                                    index <
                                    pendingPrescriptionPayload.medicines
                                      .length -
                                      1
                                      ? "1px solid #ffedd5"
                                      : "none",

                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 2,
                                }}
                              >
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography
                                    sx={{
                                      fontSize: ".76rem",
                                      fontWeight: 700,
                                      color: "#c2410c",
                                    }}
                                  >
                                    {medicine.medicine}
                                  </Typography>

                                  {medicine.note && (
                                    <Typography
                                      sx={{
                                        fontSize: ".64rem",
                                        color: "#9a3412",
                                        mt: 0.2,
                                        opacity: 0.7,
                                      }}
                                    >
                                      {medicine.note}
                                    </Typography>
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.7,
                                    flexShrink: 0,
                                  }}
                                >
                                  <Chip
                                    size="small"
                                    label={`${medicine.morning || "0"}-${
                                      medicine.afternoon || "0"
                                    }-${medicine.evening || "0"}-${
                                      medicine.night || "0"
                                    }`}
                                    sx={{
                                      height: 25,
                                      bgcolor: "#fff7ed",
                                      color: "#c2410c",
                                      border: "1px solid #fed7aa",
                                      fontWeight: 700,
                                      fontSize: ".65rem",
                                    }}
                                  />

                                  <Chip
                                    size="small"
                                    label={`${medicine.duration || ""} ${
                                      medicine.durationType || ""
                                    }`}
                                    sx={{
                                      height: 25,
                                      bgcolor: "#ffedd5",
                                      color: "#9a3412",
                                      border: "1px solid #fed7aa",
                                      fontWeight: 600,
                                      fontSize: ".65rem",
                                    }}
                                  />
                                </Box>
                              </Box>
                            ),
                          )}
                        </Box>
                      ) : (
                        <EmptyText text="No medicines added" />
                      )}
                    </>
                  )}

                  {/* =================================================
          ADVICE
      ================================================= */}
                  {prescriptionDetailView === "advice" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.7,
                      }}
                    >
                      {(pendingPrescriptionPayload?.advicePayload || [])
                        .length > 0 ? (
                        pendingPrescriptionPayload.advicePayload.map(
                          (item, index) => (
                            <Chip
                              key={`${item}-${index}`}
                              label={item}
                              size="small"
                              sx={{
                                borderRadius: "7px",
                                bgcolor: "#fefce8",
                                color: "#a16207",
                                border: "1px solid #fef08a",
                                fontWeight: 600,
                                fontSize: ".72rem",
                              }}
                            />
                          ),
                        )
                      ) : (
                        <EmptyText text="No advice added" />
                      )}
                    </Box>
                  )}
                </Box>
              )}
            </TemplateSection>

            <TemplateSection
              icon={<MedicalInformationIcon />}
              color="yellow"
              title="Note"
              subtitle="Save this note as a reusable template"
              selected={templateSelections.note.selected}
              templateName={templateSelections.note.name}
              onSwitch={(checked) => handleTemplateSwitch("note", checked)}
              onNameChange={(value) => handleTemplateNameChange("note", value)}
            >
              <Box
                sx={{
                  minHeight: 52,
                  px: 1.25,
                  py: 1,
                  borderRadius: "8px",
                  border: "1px solid #fef08a",
                  bgcolor: "#fefce8",
                  color: "#713f12",
                  fontSize: ".75rem",
                  lineHeight: 1.55,
                  "& p": { m: 0 },
                  "& p + p": { mt: 0.65 },
                  "& ul, & ol": { my: 0.5, pl: 2.5 },
                }}
              >
                {hasClinicalNoteContent(pendingPrescriptionPayload?.note) ? (
                  <Box
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        pendingPrescriptionPayload.note,
                      ),
                    }}
                  />
                ) : (
                  <EmptyText text="No clinical note added" />
                )}
              </Box>
            </TemplateSection>

            <TemplateSection
              icon={<MedicalInformationIcon />}
              color="green"
              title="Clinical Diagnosis"
              subtitle="Save these diagnoses as a reusable template"
              selected={templateSelections.diagnosis.selected}
              templateName={templateSelections.diagnosis.name}
              onSwitch={(checked) => handleTemplateSwitch("diagnosis", checked)}
              onNameChange={(value) =>
                handleTemplateNameChange("diagnosis", value)
              }
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.7,
                }}
              >
                {(pendingPrescriptionPayload?.diagnosis || []).length > 0 ? (
                  pendingPrescriptionPayload.diagnosis.map((item, index) => (
                    <Chip
                      key={`${item}-${index}`}
                      label={item}
                      size="small"
                      sx={{
                        borderRadius: "7px",
                        bgcolor: "#f0fdf4",
                        color: "#15803d",
                        border: "1px solid #bbf7d0",
                        fontWeight: 600,
                        fontSize: ".72rem",
                      }}
                    />
                  ))
                ) : (
                  <EmptyText text="No clinical diagnosis added" />
                )}
              </Box>
            </TemplateSection>

            <TemplateSection
              icon={<ScienceIcon />}
              color="blue"
              title="Investigations"
              subtitle="Save selected investigations as a template"
              selected={templateSelections.investigation.selected}
              templateName={templateSelections.investigation.name}
              onSwitch={(checked) =>
                handleTemplateSwitch("investigation", checked)
              }
              onNameChange={(value) =>
                handleTemplateNameChange("investigation", value)
              }
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.7,
                }}
              >
                {(pendingPrescriptionPayload?.investigations || []).length >
                0 ? (
                  pendingPrescriptionPayload.investigations.map(
                    (item, index) => (
                      <Chip
                        key={`${item}-${index}`}
                        label={item}
                        size="small"
                        sx={{
                          borderRadius: "7px",
                          bgcolor: "#eff6ff",
                          color: "#1d4ed8",
                          border: "1px solid #bfdbfe",
                          fontWeight: 600,
                          fontSize: ".72rem",
                        }}
                      />
                    ),
                  )
                ) : (
                  <EmptyText text="No investigations added" />
                )}
              </Box>
            </TemplateSection>

            <TemplateSection
              icon={<MedicationIcon />}
              color="orange"
              title="Medicines"
              subtitle="Save medicine, dosage and duration as a template"
              selected={templateSelections.medicine.selected}
              templateName={templateSelections.medicine.name}
              onSwitch={(checked) => handleTemplateSwitch("medicine", checked)}
              onNameChange={(value) =>
                handleTemplateNameChange("medicine", value)
              }
            >
              {(pendingPrescriptionPayload?.medicines || []).length > 0 ? (
                <Box
                  sx={{
                    border: "1px solid #fed7aa", // orange-200
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: "#fff",
                  }}
                >
                  {pendingPrescriptionPayload.medicines.map(
                    (medicine, index) => (
                      <Box
                        key={`${medicine.medicine}-${index}`}
                        sx={{
                          px: 1.25,
                          py: 1,

                          bgcolor: index % 2 === 0 ? "#fff" : "#fffaf5",

                          borderBottom:
                            index <
                            pendingPrescriptionPayload.medicines.length - 1
                              ? "1px solid #ffedd5"
                              : "none",

                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 2,

                          transition: "background .15s ease",

                          "&:hover": {
                            bgcolor: "#fff7ed", // orange-50
                          },
                        }}
                      >
                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontSize: ".78rem",
                              fontWeight: 700,
                              color: "#c2410c", // orange-700
                            }}
                          >
                            {medicine.medicine}
                          </Typography>

                          {medicine.note && (
                            <Typography
                              sx={{
                                fontSize: ".66rem",
                                color: "#9a3412", // orange-800
                                mt: 0.25,
                                opacity: 0.75,
                              }}
                            >
                              {medicine.note}
                            </Typography>
                          )}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.75,
                            flexShrink: 0,
                          }}
                        >
                          <Box
                            sx={{
                              px: 1,
                              py: 0.45,
                              borderRadius: "6px",

                              bgcolor: "#fff7ed",
                              border: "1px solid #fed7aa",

                              fontSize: ".68rem",
                              fontWeight: 700,
                              color: "#c2410c",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {medicine.morning || "0"}-
                            {medicine.afternoon || "0"}-
                            {medicine.evening || "0"}-{medicine.night || "0"}
                          </Box>

                          <Box
                            sx={{
                              px: 1,
                              py: 0.45,
                              borderRadius: "6px",

                              bgcolor: "#ffedd5", // orange-100
                              border: "1px solid #fed7aa",

                              fontSize: ".68rem",
                              fontWeight: 600,
                              color: "#9a3412",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {medicine.duration} {medicine.durationType}
                          </Box>
                        </Box>
                      </Box>
                    ),
                  )}
                </Box>
              ) : (
                <EmptyText text="No medicines added" />
              )}
            </TemplateSection>

            <TemplateSection
              icon={<LightbulbOutlinedIcon />}
              color="yellow"
              title="Advice"
              subtitle="Save patient advice as a reusable template"
              selected={templateSelections.advice.selected}
              templateName={templateSelections.advice.name}
              onSwitch={(checked) => handleTemplateSwitch("advice", checked)}
              onNameChange={(value) =>
                handleTemplateNameChange("advice", value)
              }
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.7,
                }}
              >
                {(pendingPrescriptionPayload?.advicePayload || []).length >
                0 ? (
                  pendingPrescriptionPayload.advicePayload.map(
                    (item, index) => (
                      <Chip
                        key={`${item}-${index}`}
                        label={item}
                        size="small"
                        sx={{
                          borderRadius: "7px",
                          bgcolor: "#fefce8",
                          color: "#a16207",
                          border: "1px solid #fef08a",
                          fontWeight: 600,
                          fontSize: ".72rem",
                        }}
                      />
                    ),
                  )
                ) : (
                  <EmptyText text="No advice added" />
                )}
              </Box>
            </TemplateSection>
          </Box>
        </DialogContent>

        <Box
          sx={{
            px: 2.5,
            py: 1.75,
            bgcolor: "#fff",
            borderTop: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: ".68rem",
              color: "#94a3b8",
            }}
          >
            Templates are optional. The prescription will be saved regardless.
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => setTemplateDialogOpen(false)}
              sx={{
                textTransform: "none",
                borderRadius: "9px",
                fontWeight: 600,
                color: "#475569",
                borderColor: "#cbd5e1",
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={handleFinalSavePrescription}
              sx={{
                textTransform: "none",
                borderRadius: "9px",
                fontWeight: 700,
                px: 2.5,
                boxShadow: "0 4px 12px rgba(37,99,235,.20)",
              }}
            >
              Save Prescription
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={holdDialogOpen}
        onClose={() => setHoldDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(15,23,42,.18)",
          },
        }}
      >
        {/* ================= HEADER ================= */}
        <Box
          sx={{
            px: 2.5,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #e2e8f0",
            bgcolor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
            }}
          >
            {/* Hold Icon */}
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "10px",

                bgcolor: "#fff7ed",
                color: "#c2410c",

                border: "1px solid #fed7aa",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PauseCircleOutlineRoundedIcon
                sx={{
                  fontSize: "1.15rem",
                }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".95rem",
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                Hold Prescription
              </Typography>

              <Typography
                sx={{
                  fontSize: ".7rem",
                  color: "#64748b",
                  mt: 0.2,
                }}
              >
                Save this prescription as a draft for later completion
              </Typography>
            </Box>
          </Box>

          <IconButton
            onClick={() => setHoldDialogOpen(false)}
            size="small"
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              color: "#64748b",

              "&:hover": {
                bgcolor: "#f8fafc",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
        </Box>

        {/* ================= CONTENT ================= */}
        <DialogContent
          sx={{
            p: 2.5,
            bgcolor: "#f8fafc",
          }}
        >
          {/* Information Alert */}
          <Alert
            severity="info"
            icon={
              <InfoOutlinedIcon
                sx={{
                  fontSize: "1.1rem",
                }}
              />
            }
            sx={{
              mb: 1.75,

              borderRadius: "10px",

              bgcolor: "#eff6ff",
              color: "#1e40af",

              border: "1px solid #bfdbfe",

              "& .MuiAlert-icon": {
                color: "#2563eb",
                pt: 0.15,
              },

              "& .MuiAlert-message": {
                width: "100%",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: ".76rem",
                fontWeight: 700,
                mb: 0.35,
              }}
            >
              Prescription placed on hold
            </Typography>

            <Typography
              sx={{
                fontSize: ".7rem",
                lineHeight: 1.55,
                color: "#475569",
              }}
            >
              This patient's prescription will be saved as a draft and will not
              be treated as a completed prescription. You can open it again,
              make changes, and save it when the consultation is completed.
            </Typography>
          </Alert>

          {/* Patient / Prescription Summary */}
          <Box
            sx={{
              p: 1.5,
              borderRadius: "10px",

              bgcolor: "#fff",
              border: "1px solid #e2e8f0",

              display: "flex",
              alignItems: "center",
              gap: 1.25,
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "9px",

                bgcolor: "#f1f5f9",
                color: "#475569",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                flexShrink: 0,
              }}
            >
              <PersonOutlineOutlinedIcon
                sx={{
                  fontSize: "1.1rem",
                }}
              />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: ".78rem",
                  fontWeight: 700,
                  color: "#0f172a",

                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {selectedPatient?.name || "Selected Patient"}
              </Typography>

              <Typography
                sx={{
                  fontSize: ".65rem",
                  color: "#64748b",
                  mt: 0.2,
                }}
              >
                Appointment ID:{" "}
                {selectedPatient?.appointmentId ||
                  pendingPrescriptionPayload?.appointmentId ||
                  "—"}
              </Typography>
            </Box>
          </Box>

          {/* Draft status */}
          <Box
            sx={{
              mt: 1.25,

              display: "flex",
              alignItems: "center",
              gap: 0.75,
            }}
          >
            <Box
              sx={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                bgcolor: "#f97316",
              }}
            />

            <Typography
              sx={{
                fontSize: ".65rem",
                color: "#64748b",
              }}
            >
              The prescription will remain editable until it is finally saved.
            </Typography>
          </Box>
        </DialogContent>

        {/* ================= FOOTER ================= */}
        <Box
          sx={{
            px: 2.5,
            py: 1.75,

            bgcolor: "#fff",

            borderTop: "1px solid #e2e8f0",

            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
          }}
        >
          {/* <Button
            variant="outlined"
            onClick={handlePrintHeldInvestigations}
            startIcon={<PrintOutlinedIcon sx={{ fontSize: "1rem !important" }} />}
            sx={{
              textTransform: "none",
              borderRadius: "9px",
              fontWeight: 700,
              fontSize: ".75rem",
              color: "#1d4ed8",
              borderColor: "#93c5fd",
              px: 1.75,
              "&:hover": {
                bgcolor: "#eff6ff",
                borderColor: "#2563eb",
              },
            }}
          >
            Print Investigations
          </Button> */}

          <Button
            variant="outlined"
            onClick={() => setHoldDialogOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: "9px",

              fontWeight: 600,
              fontSize: ".75rem",

              color: "#475569",
              borderColor: "#cbd5e1",

              px: 2,

              "&:hover": {
                bgcolor: "#f8fafc",
                borderColor: "#94a3b8",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={savingDraft}
            onClick={handleSavePrescriptionAsDraft}
            startIcon={
              savingDraft ? (
                <CircularProgress
                  size={15}
                  thickness={5}
                  sx={{ color: "#fff" }}
                />
              ) : (
                <SaveOutlinedIcon
                  sx={{
                    fontSize: "1rem !important",
                  }}
                />
              )
            }
            sx={{
              textTransform: "none",
              borderRadius: "9px",
              fontWeight: 700,
              fontSize: ".75rem",
              px: 2.25,

              bgcolor: "#c2410c",
              color: "#fff",

              "&:hover": {
                bgcolor: "#9a3412",
              },

              "&.Mui-disabled": {
                bgcolor: "#fdba74",
                color: "#fff",
              },
            }}
          >
            {savingDraft ? "Saving Draft..." : "Save as Draft"}
          </Button>
        </Box>
      </Dialog>

      <Dialog
        open={saveProgressOpen}
        maxWidth="xs"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid #e2e8f0",
            boxShadow: "0 24px 70px rgba(15,23,42,.18)",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 2.5,
            pt: 2.5,
            pb: 2,
            borderBottom: "1px solid #e2e8f0",
            bgcolor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "10px",
                bgcolor: "#eff6ff",
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DescriptionOutlinedIcon sx={{ fontSize: "1.15rem" }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".92rem",
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                Saving Prescription
              </Typography>

              <Typography
                sx={{
                  fontSize: ".68rem",
                  color: "#64748b",
                  mt: 0.15,
                }}
              >
                Please wait while your data is being saved
              </Typography>
            </Box>
          </Box>
        </Box>

        <DialogContent
          sx={{
            p: 2,
            bgcolor: "#f8fafc",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {saveProgress.map((item) => {
              const iconMap = {
                prescription: <DescriptionOutlinedIcon />,
                master: <StorageOutlinedIcon />,
                diagnosis: <PsychologyAltOutlinedIcon />,
                investigation: <ScienceOutlinedIcon />,
                medicine: <MedicationOutlinedIcon />,
                advice: <TipsAndUpdatesOutlinedIcon />,
                prescriptionTemplate: <ArticleOutlinedIcon />,
              };

              const themeMap = {
                prescription: {
                  color: "#2563eb",
                  bg: "#eff6ff",
                },

                master: {
                  color: "#64748b",
                  bg: "#f1f5f9",
                },

                diagnosis: {
                  color: "#16a34a",
                  bg: "#f0fdf4",
                },

                investigation: {
                  color: "#2563eb",
                  bg: "#eff6ff",
                },

                medicine: {
                  color: "#ea580c",
                  bg: "#fff7ed",
                },

                advice: {
                  color: "#ca8a04",
                  bg: "#fefce8",
                },

                prescriptionTemplate: {
                  color: "#7c3aed",
                  bg: "#f5f3ff",
                },
              };

              const theme = themeMap[item.id] || themeMap.master;

              return (
                <Box
                  key={item.id}
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    px: 1.4,
                    py: 1.15,

                    display: "flex",
                    alignItems: "center",
                    gap: 1.1,

                    transition: "all .2s ease",

                    ...(item.status === "saving" && {
                      borderColor: theme.color,
                      boxShadow: `0 0 0 2px ${theme.bg}`,
                    }),
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      flexShrink: 0,
                      borderRadius: "8px",
                      bgcolor: theme.bg,
                      color: theme.color,

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      "& svg": {
                        fontSize: ".95rem",
                      },
                    }}
                  >
                    {iconMap[item.id]}
                  </Box>

                  {/* Text */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: ".76rem",
                        fontWeight: 700,
                        color: "#0f172a",
                      }}
                    >
                      {item.label}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: ".62rem",
                        mt: 0.15,

                        color:
                          item.status === "error"
                            ? "#dc2626"
                            : item.status === "success"
                              ? "#16a34a"
                              : "#94a3b8",
                      }}
                    >
                      {item.status === "pending" && "Waiting..."}

                      {item.status === "saving" && "Saving..."}

                      {item.status === "success" &&
                        (item.message || "Saved successfully")}

                      {item.status === "error" &&
                        (item.message || "Failed to save")}
                    </Typography>
                  </Box>

                  {/* Status */}
                  <Box
                    sx={{
                      width: 28,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {item.status === "saving" && (
                      <CircularProgress
                        size={19}
                        thickness={5}
                        sx={{
                          color: theme.color,
                        }}
                      />
                    )}

                    {item.status === "success" && (
                      <CheckCircleRoundedIcon
                        sx={{
                          fontSize: 21,
                          color: "#16a34a",
                        }}
                      />
                    )}

                    {item.status === "error" && (
                      <ErrorRoundedIcon
                        sx={{
                          fontSize: 21,
                          color: "#dc2626",
                        }}
                      />
                    )}

                    {item.status === "pending" && (
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          bgcolor: "#cbd5e1",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* Overall loading bar */}

          {!isSaveProcessComplete ? (
            <>
              {" "}
              <LinearProgress
                sx={{
                  mt: 2,
                  height: 4,
                  borderRadius: "999px",

                  bgcolor: "#e2e8f0",

                  "& .MuiLinearProgress-bar": {
                    borderRadius: "999px",
                  },
                }}
              />
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: ".62rem",
                  color: "#94a3b8",
                  mt: 1.2,
                }}
              >
                Please don't close this window
              </Typography>
            </>
          ) : (
            <Box
              sx={{
                mt: 2,
                pt: 1.5,
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setSaveProgressOpen(false);
                  setSaveProgress([]);
                }}
                startIcon={<CheckCircleRoundedIcon />}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  px: 2.5,
                  fontSize: ".78rem",
                  fontWeight: 700,
                  boxShadow: "none",

                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                Done
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {templatePopupOpen && (
        <>
          {/* Click outside overlay */}
          <Box
            onClick={() => setTemplatePopupOpen(false)}
            sx={{
              position: "fixed",
              inset: 0,
              zIndex: 1298,
              bgcolor: "transparent",
            }}
          />

          {/* Popup */}
          <Paper
            elevation={0}
            sx={{
              position: "fixed",
              top: 82,
              right: 20,
              zIndex: 1299,

              width: 360,
              maxWidth: "calc(100vw - 32px)",
              maxHeight: "calc(100vh - 110px)",

              display: "flex",
              flexDirection: "column",

              bgcolor: "#fff",

              border: "1px solid #e2e8f0",
              borderRadius: "12px",

              boxShadow:
                "0 20px 45px rgba(15,23,42,.12), 0 4px 12px rgba(15,23,42,.06)",

              overflow: "hidden",
            }}
          >
            {/* ================= HEADER ================= */}
            <Box
              sx={{
                px: 1.75,
                py: 1.4,

                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,

                    borderRadius: "8px",

                    bgcolor: "#f0fdf4",
                    color: "#16a34a",

                    border: "1px solid #bbf7d0",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <DescriptionOutlinedIcon
                    sx={{
                      fontSize: "1rem",
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: ".8rem",
                      fontWeight: 700,
                      color: "#0f172a",
                      lineHeight: 1.3,
                    }}
                  >
                    Prescription Templates
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: ".63rem",
                      color: "#94a3b8",
                      mt: 0.15,
                    }}
                  >
                    Select a template to load
                  </Typography>
                </Box>
              </Box>

              <IconButton
                size="small"
                onClick={() => setTemplatePopupOpen(false)}
                sx={{
                  width: 29,
                  height: 29,

                  color: "#64748b",

                  "&:hover": {
                    bgcolor: "#f1f5f9",
                    color: "#0f172a",
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Box>

            {/* ================= SEARCH ================= */}
            <Box
              sx={{
                px: 1.5,
                py: 1.25,

                bgcolor: "#f8fafc",

                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <TextField
                autoFocus
                fullWidth
                size="small"
                value={templateSearch}
                onChange={(e) => setTemplateSearch(e.target.value)}
                placeholder="Search template..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{
                          fontSize: "1rem",
                          color: "#94a3b8",
                        }}
                      />
                    </InputAdornment>
                  ),

                  endAdornment: templateLoading ? (
                    <InputAdornment position="end">
                      <CircularProgress
                        size={15}
                        sx={{
                          color: "#16a34a",
                        }}
                      />
                    </InputAdornment>
                  ) : templateSearch ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setTemplateSearch("")}
                      >
                        <CloseIcon
                          sx={{
                            fontSize: ".9rem",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: 38,

                    bgcolor: "#fff",

                    borderRadius: "8px",

                    fontSize: ".78rem",

                    "& fieldset": {
                      borderColor: "#dbe4ec",
                    },

                    "&:hover fieldset": {
                      borderColor: "#86efac",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#22c55e",
                      borderWidth: "1px",
                    },

                    "&.Mui-focused": {
                      boxShadow: "0 0 0 3px rgba(34,197,94,.08)",
                    },
                  },
                }}
              />
            </Box>

            {/* ================= LIST ================= */}
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 0.75,

                "&::-webkit-scrollbar": {
                  width: "5px",
                },

                "&::-webkit-scrollbar-thumb": {
                  bgcolor: "#cbd5e1",
                  borderRadius: "10px",
                },
              }}
            >
              {templateLoading && prescriptionTemplates.length === 0 ? (
                <Box
                  sx={{
                    py: 5,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <CircularProgress
                    size={22}
                    sx={{
                      color: "#16a34a",
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: ".7rem",
                      color: "#94a3b8",
                    }}
                  >
                    Loading templates...
                  </Typography>
                </Box>
              ) : prescriptionTemplates.length > 0 ? (
                prescriptionTemplates.map((template) => (
                  <Box
                    key={template._id}
                    onClick={() => handleSelectPrescriptionTemplate(template)}
                    sx={{
                      px: 1.25,
                      py: 1,

                      display: "flex",
                      alignItems: "center",
                      gap: 1,

                      borderRadius: "8px",

                      cursor: "pointer",

                      transition: "all .12s ease",

                      "&:hover": {
                        bgcolor: "#f0fdf4",

                        "& .template-arrow": {
                          color: "#16a34a",
                          transform: "translateX(2px)",
                        },
                      },
                    }}
                  >
                    {/* Icon */}
                    <Box
                      sx={{
                        width: 31,
                        height: 31,

                        flexShrink: 0,

                        borderRadius: "7px",

                        bgcolor: "#f0fdf4",
                        color: "#16a34a",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{
                          fontSize: ".9rem",
                        }}
                      />
                    </Box>

                    {/* Name */}
                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: ".76rem",
                          fontWeight: 600,

                          color: "#334155",

                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {template.name}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".61rem",
                          color: "#94a3b8",
                          mt: 0.15,
                        }}
                      >
                        Prescription template
                      </Typography>
                    </Box>

                    <ChevronRightIcon
                      className="template-arrow"
                      sx={{
                        fontSize: "1rem",
                        color: "#cbd5e1",

                        transition: "all .12s ease",
                      }}
                    />
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    py: 5,
                    px: 2,

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",

                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,

                      borderRadius: "10px",

                      bgcolor: "#f8fafc",
                      color: "#94a3b8",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      mb: 1,
                    }}
                  >
                    <SearchIcon sx={{ fontSize: "1.1rem" }} />
                  </Box>

                  <Typography
                    sx={{
                      fontSize: ".75rem",
                      fontWeight: 600,
                      color: "#475569",
                    }}
                  >
                    No templates found
                  </Typography>

                  {templateSearch && (
                    <Typography
                      sx={{
                        fontSize: ".65rem",
                        color: "#94a3b8",
                        mt: 0.35,
                      }}
                    >
                      No results for "{templateSearch}"
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          </Paper>
        </>
      )}

      <Popover
        open={noteTemplateOpen}
        anchorEl={noteTemplateAnchor}
        onClose={handleCloseNoteTemplates}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,
              width: 340,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: 400,
              borderRadius: "11px",
              border: "1px solid #fde68a",
              boxShadow:
                "0 14px 35px rgba(15,23,42,.12), 0 3px 8px rgba(15,23,42,.05)",
              overflow: "hidden",
            },
          },
        }}
      >
        <Box
          sx={{
            px: 1.5,
            py: 1.2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#fefce8",
            borderBottom: "1px solid #fde68a",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.9 }}>
            <Box
              sx={{
                width: 29,
                height: 29,
                borderRadius: "7px",
                bgcolor: "#fef9c3",
                color: "#a16207",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MedicalInformationIcon sx={{ fontSize: ".9rem" }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: ".76rem",
                  fontWeight: 700,
                  color: "#713f12",
                  lineHeight: 1.3,
                }}
              >
                Note Templates
              </Typography>
              <Typography sx={{ fontSize: ".6rem", color: "#a16207", mt: 0.1 }}>
                Select a template to replace this note
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={handleCloseNoteTemplates}
            sx={{ width: 27, height: 27, color: "#64748b" }}
          >
            <CloseIcon sx={{ fontSize: ".9rem" }} />
          </IconButton>
        </Box>

        <Box sx={{ p: 1.25, borderBottom: "1px solid #f1f5f9" }}>
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={noteTemplateSearch}
            onChange={(event) => {
              setNoteTemplateSearch(event.target.value);
              setNoteTemplates([]);
            }}
            placeholder="Search note template..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: ".95rem", color: "#94a3b8" }} />
                </InputAdornment>
              ),
              endAdornment: noteTemplateLoading ? (
                <InputAdornment position="end">
                  <CircularProgress size={14} sx={{ color: "#ca8a04" }} />
                </InputAdornment>
              ) : noteTemplateSearch ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setNoteTemplateSearch("")}
                  >
                    <CloseIcon sx={{ fontSize: ".85rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff",
                fontSize: ".75rem",
                "& fieldset": { borderColor: "#dbe4ec" },
                "&:hover fieldset": { borderColor: "#fde68a" },
                "&.Mui-focused fieldset": {
                  borderColor: "#ca8a04",
                  borderWidth: "1px",
                },
              },
            }}
          />
        </Box>

        <Box sx={{ maxHeight: 280, overflowY: "auto", p: 0.75 }}>
          {noteTemplateLoading && noteTemplates.length === 0 ? (
            <Box
              sx={{
                py: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={20} sx={{ color: "#ca8a04" }} />
            </Box>
          ) : noteTemplates.length > 0 ? (
            noteTemplates.map((template) => (
              <Box
                key={template._id}
                onClick={() => handleSelectNoteTemplate(template)}
                sx={{
                  px: 1,
                  py: 0.9,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,

                  borderRadius: "8px",

                  cursor: "pointer",
                  transition: "all .12s ease",

                  "&:hover": {
                    bgcolor: "#fefce8",

                    "& .add-note-template": {
                      bgcolor: "#ca8a04",
                      color: "#fff",
                      borderColor: "#ca8a04",
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    flexShrink: 0,
                    borderRadius: "7px",
                    bgcolor: "#fef9c3",
                    color: "#a16207",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NoteAltIcon sx={{ fontSize: ".85rem" }} />
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: ".74rem",
                      fontWeight: 600,
                      color: "#334155",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {template.name || "Untitled note"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: ".59rem",
                      color: "#94a3b8",
                      mt: 0.1,
                    }}
                  >
                    Clinical note template
                  </Typography>
                </Box>

                <Box
                  className="add-note-template"
                  sx={{
                    width: 26,
                    height: 26,
                    flexShrink: 0,
                    borderRadius: "7px",
                    border: "1px solid #fde68a",
                    bgcolor: "#fff",
                    color: "#ca8a04",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all .12s ease",
                  }}
                >
                  <AddCircleIcon sx={{ fontSize: ".95rem" }} />
                </Box>
              </Box>
            ))
          ) : noteTemplateSearch ? (
            <Box sx={{ py: 4, px: 2, textAlign: "center" }}>
              <SearchIcon
                sx={{ fontSize: "1.25rem", color: "#cbd5e1", mb: 0.5 }}
              />
              <Typography
                sx={{ fontSize: ".7rem", fontWeight: 600, color: "#475569" }}
              >
                No note templates found
              </Typography>
            </Box>
          ) : (
            <Box sx={{ py: 4, px: 2, textAlign: "center" }}>
              <Typography sx={{ fontSize: ".7rem", color: "#94a3b8" }}>
                Start typing to search note templates
              </Typography>
            </Box>
          )}
        </Box>
      </Popover>

      <Popover
        open={diagnosisTemplateOpen}
        anchorEl={diagnosisTemplateAnchor}
        onClose={handleCloseDiagnosisTemplates}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,

              width: 340,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: 400,

              borderRadius: "11px",
              border: "1px solid #d1fae5",

              boxShadow:
                "0 14px 35px rgba(15,23,42,.12), 0 3px 8px rgba(15,23,42,.05)",

              overflow: "hidden",
            },
          },
        }}
      >
        {/* ================= HEADER ================= */}
        <Box
          sx={{
            px: 1.5,
            py: 1.2,

            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            bgcolor: "#f0fdf4",
            borderBottom: "1px solid #d1fae5",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.9,
            }}
          >
            <Box
              sx={{
                width: 29,
                height: 29,
                borderRadius: "7px",

                bgcolor: "#dcfce7",
                color: "#16a34a",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MedicalInformationIcon sx={{ fontSize: ".9rem" }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".76rem",
                  fontWeight: 700,
                  color: "#14532d",
                  lineHeight: 1.3,
                }}
              >
                Diagnosis Templates
              </Typography>

              <Typography
                sx={{
                  fontSize: ".6rem",
                  color: "#65a30d",
                  mt: 0.1,
                }}
              >
                Select a template to add
              </Typography>
            </Box>
          </Box>

          <IconButton
            size="small"
            onClick={handleCloseDiagnosisTemplates}
            sx={{
              width: 27,
              height: 27,
              color: "#64748b",

              "&:hover": {
                bgcolor: "#dcfce7",
                color: "#166534",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: ".9rem" }} />
          </IconButton>
        </Box>

        {/* ================= SEARCH ================= */}
        <Box
          sx={{
            p: 1.25,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={diagnosisTemplateSearch}
            onChange={(e) => setDiagnosisTemplateSearch(e.target.value)}
            placeholder="Search diagnosis template..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      fontSize: ".95rem",
                      color: "#94a3b8",
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment: diagnosisTemplateLoading ? (
                <InputAdornment position="end">
                  <CircularProgress
                    size={14}
                    sx={{
                      color: "#10b981",
                    }}
                  />
                </InputAdornment>
              ) : diagnosisTemplateSearch ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setDiagnosisTemplateSearch("")}
                  >
                    <CloseIcon sx={{ fontSize: ".85rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff",
                fontSize: ".75rem",

                "& fieldset": {
                  borderColor: "#dbe4ec",
                },

                "&:hover fieldset": {
                  borderColor: "#86efac",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#10b981",
                  borderWidth: "1px",
                },

                "&.Mui-focused": {
                  boxShadow: "0 0 0 3px rgba(16,185,129,.08)",
                },
              },
            }}
          />
        </Box>

        {/* ================= TEMPLATE LIST ================= */}
        <Box
          sx={{
            maxHeight: 280,
            overflowY: "auto",
            p: 0.75,

            "&::-webkit-scrollbar": {
              width: "5px",
            },

            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#cbd5e1",
              borderRadius: "10px",
            },
          }}
        >
          {diagnosisTemplateLoading && diagnosisTemplates.length === 0 ? (
            /* Loading */
            <Box
              sx={{
                py: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              <CircularProgress
                size={20}
                sx={{
                  color: "#10b981",
                }}
              />

              <Typography
                sx={{
                  fontSize: ".65rem",
                  color: "#94a3b8",
                }}
              >
                Loading templates...
              </Typography>
            </Box>
          ) : diagnosisTemplates.length > 0 ? (
            diagnosisTemplates.map((template) => (
              <Box
                key={template._id}
                onClick={() => handleSelectDiagnosisTemplate(template)}
                sx={{
                  px: 1,
                  py: 0.9,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,

                  borderRadius: "8px",

                  cursor: "pointer",

                  transition: "all .12s ease",

                  "&:hover": {
                    bgcolor: "#f0fdf4",

                    "& .add-template": {
                      bgcolor: "#16a34a",
                      color: "#fff",
                      borderColor: "#16a34a",
                    },
                  },
                }}
              >
                {/* Template Icon */}
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    flexShrink: 0,

                    borderRadius: "7px",

                    bgcolor: "#ecfdf5",
                    color: "#059669",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MedicalInformationIcon
                    sx={{
                      fontSize: ".85rem",
                    }}
                  />
                </Box>

                {/* Name */}
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ".74rem",
                      fontWeight: 600,
                      color: "#334155",

                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {template.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: ".59rem",
                      color: "#94a3b8",
                      mt: 0.1,
                    }}
                  >
                    Clinical diagnosis template
                  </Typography>
                </Box>

                {/* Add */}
                <Box
                  className="add-template"
                  sx={{
                    width: 26,
                    height: 26,

                    flexShrink: 0,

                    borderRadius: "7px",

                    border: "1px solid #bbf7d0",

                    bgcolor: "#fff",
                    color: "#16a34a",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    transition: "all .12s ease",
                  }}
                >
                  <AddCircleIcon
                    sx={{
                      fontSize: ".95rem",
                    }}
                  />
                </Box>
              </Box>
            ))
          ) : (
            /* Empty */
            <Box
              sx={{
                py: 4,
                px: 2,
                textAlign: "center",
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: "1.25rem",
                  color: "#cbd5e1",
                  mb: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: 600,
                  color: "#475569",
                }}
              >
                No templates found
              </Typography>

              {diagnosisTemplateSearch && (
                <Typography
                  sx={{
                    fontSize: ".61rem",
                    color: "#94a3b8",
                    mt: 0.25,
                  }}
                >
                  No results for "{diagnosisTemplateSearch}"
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Popover>

      <Popover
        open={investigationTemplateOpen}
        anchorEl={investigationTemplateAnchor}
        onClose={handleCloseInvestigationTemplates}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,
              width: 340,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: 400,

              borderRadius: "11px",
              border: "1px solid #bfdbfe",

              boxShadow:
                "0 14px 35px rgba(15,23,42,.12), 0 3px 8px rgba(15,23,42,.05)",

              overflow: "hidden",
            },
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 1.5,
            py: 1.2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#eff6ff",
            borderBottom: "1px solid #bfdbfe",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.9,
            }}
          >
            <Box
              sx={{
                width: 29,
                height: 29,
                borderRadius: "7px",
                bgcolor: "#dbeafe",
                color: "#2563eb",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ScienceIcon sx={{ fontSize: ".9rem" }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".76rem",
                  fontWeight: 700,
                  color: "#1e3a8a",
                  lineHeight: 1.3,
                }}
              >
                Investigation Templates
              </Typography>

              <Typography
                sx={{
                  fontSize: ".6rem",
                  color: "#64748b",
                  mt: 0.1,
                }}
              >
                Select a template to add tests
              </Typography>
            </Box>
          </Box>

          <IconButton
            size="small"
            onClick={handleCloseInvestigationTemplates}
            sx={{
              width: 27,
              height: 27,
              color: "#64748b",

              "&:hover": {
                bgcolor: "#dbeafe",
                color: "#1d4ed8",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: ".9rem" }} />
          </IconButton>
        </Box>

        {/* Search */}
        <Box
          sx={{
            p: 1.25,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={investigationTemplateSearch}
            onChange={(e) => setInvestigationTemplateSearch(e.target.value)}
            placeholder="Search investigation template..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      fontSize: ".95rem",
                      color: "#94a3b8",
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment: investigationTemplateLoading ? (
                <InputAdornment position="end">
                  <CircularProgress
                    size={14}
                    sx={{
                      color: "#2563eb",
                    }}
                  />
                </InputAdornment>
              ) : investigationTemplateSearch ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setInvestigationTemplateSearch("")}
                  >
                    <CloseIcon sx={{ fontSize: ".85rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff",
                fontSize: ".75rem",

                "& fieldset": {
                  borderColor: "#dbe4ec",
                },

                "&:hover fieldset": {
                  borderColor: "#93c5fd",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#2563eb",
                  borderWidth: "1px",
                },

                "&.Mui-focused": {
                  boxShadow: "0 0 0 3px rgba(37,99,235,.08)",
                },
              },
            }}
          />
        </Box>

        {/* Template List */}
        <Box
          sx={{
            maxHeight: 280,
            overflowY: "auto",
            p: 0.75,

            "&::-webkit-scrollbar": {
              width: "5px",
            },

            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#cbd5e1",
              borderRadius: "10px",
            },
          }}
        >
          {investigationTemplateLoading &&
          investigationTemplates.length === 0 ? (
            <Box
              sx={{
                py: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              <CircularProgress
                size={20}
                sx={{
                  color: "#2563eb",
                }}
              />

              <Typography
                sx={{
                  fontSize: ".65rem",
                  color: "#94a3b8",
                }}
              >
                Loading templates...
              </Typography>
            </Box>
          ) : investigationTemplates.length > 0 ? (
            investigationTemplates.map((template) => (
              <Box
                key={template._id}
                onClick={() => handleSelectInvestigationTemplate(template)}
                sx={{
                  px: 1,
                  py: 0.9,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,

                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all .12s ease",

                  "&:hover": {
                    bgcolor: "#eff6ff",

                    "& .add-investigation-template": {
                      bgcolor: "#2563eb",
                      color: "#fff",
                      borderColor: "#2563eb",
                    },
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    flexShrink: 0,
                    borderRadius: "7px",

                    bgcolor: "#eff6ff",
                    color: "#2563eb",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ScienceIcon sx={{ fontSize: ".85rem" }} />
                </Box>

                {/* Template Name */}
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ".74rem",
                      fontWeight: 600,
                      color: "#334155",

                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {template.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: ".59rem",
                      color: "#94a3b8",
                      mt: 0.1,
                    }}
                  >
                    Investigation template
                  </Typography>
                </Box>

                {/* Add */}
                <Box
                  className="add-investigation-template"
                  sx={{
                    width: 26,
                    height: 26,
                    flexShrink: 0,

                    borderRadius: "7px",
                    border: "1px solid #bfdbfe",

                    bgcolor: "#fff",
                    color: "#2563eb",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    transition: "all .12s ease",
                  }}
                >
                  <AddCircleIcon sx={{ fontSize: ".95rem" }} />
                </Box>
              </Box>
            ))
          ) : (
            <Box
              sx={{
                py: 4,
                px: 2,
                textAlign: "center",
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: "1.25rem",
                  color: "#cbd5e1",
                  mb: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: 600,
                  color: "#475569",
                }}
              >
                No templates found
              </Typography>

              {investigationTemplateSearch && (
                <Typography
                  sx={{
                    fontSize: ".61rem",
                    color: "#94a3b8",
                    mt: 0.25,
                  }}
                >
                  No results for "{investigationTemplateSearch}"
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Popover>

      <Popover
        open={adviceTemplateOpen}
        anchorEl={adviceTemplateAnchor}
        onClose={handleCloseAdviceTemplates}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,

              width: 340,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: 400,

              borderRadius: "11px",
              border: "1px solid #fde68a",

              boxShadow:
                "0 14px 35px rgba(15,23,42,.12), 0 3px 8px rgba(15,23,42,.05)",

              overflow: "hidden",
            },
          },
        }}
      >
        {/* ================= HEADER ================= */}
        <Box
          sx={{
            px: 1.5,
            py: 1.2,

            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            bgcolor: "#fefce8",
            borderBottom: "1px solid #fde68a",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.9,
            }}
          >
            <Box
              sx={{
                width: 29,
                height: 29,
                borderRadius: "7px",

                bgcolor: "#fef9c3",
                color: "#ca8a04",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TipsAndUpdatesOutlinedIcon
                sx={{
                  fontSize: ".9rem",
                }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".76rem",
                  fontWeight: 700,
                  color: "#713f12",
                  lineHeight: 1.3,
                }}
              >
                Advice Templates
              </Typography>

              <Typography
                sx={{
                  fontSize: ".6rem",
                  color: "#a16207",
                  mt: 0.1,
                }}
              >
                Select a template to add advice
              </Typography>
            </Box>
          </Box>

          <IconButton
            size="small"
            onClick={handleCloseAdviceTemplates}
            sx={{
              width: 27,
              height: 27,
              color: "#64748b",

              "&:hover": {
                bgcolor: "#fef9c3",
                color: "#a16207",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: ".9rem" }} />
          </IconButton>
        </Box>

        {/* ================= SEARCH ================= */}
        <Box
          sx={{
            p: 1.25,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={adviceTemplateSearch}
            onChange={(e) => setAdviceTemplateSearch(e.target.value)}
            placeholder="Search advice template..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      fontSize: ".95rem",
                      color: "#94a3b8",
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment: adviceTemplateLoading ? (
                <InputAdornment position="end">
                  <CircularProgress
                    size={14}
                    sx={{
                      color: "#eab308",
                    }}
                  />
                </InputAdornment>
              ) : adviceTemplateSearch ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setAdviceTemplateSearch("")}
                  >
                    <CloseIcon sx={{ fontSize: ".85rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff",
                fontSize: ".75rem",

                "& fieldset": {
                  borderColor: "#e2e8f0",
                },

                "&:hover fieldset": {
                  borderColor: "#fde047",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#eab308",
                  borderWidth: "1px",
                },

                "&.Mui-focused": {
                  boxShadow: "0 0 0 3px rgba(234,179,8,.10)",
                },
              },
            }}
          />
        </Box>

        {/* ================= LIST ================= */}
        <Box
          sx={{
            maxHeight: 280,
            overflowY: "auto",
            p: 0.75,

            "&::-webkit-scrollbar": {
              width: "5px",
            },

            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#cbd5e1",
              borderRadius: "10px",
            },
          }}
        >
          {adviceTemplateLoading && adviceTemplates.length === 0 ? (
            <Box
              sx={{
                py: 4,

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              <CircularProgress
                size={20}
                sx={{
                  color: "#eab308",
                }}
              />

              <Typography
                sx={{
                  fontSize: ".65rem",
                  color: "#94a3b8",
                }}
              >
                Loading templates...
              </Typography>
            </Box>
          ) : adviceTemplates.length > 0 ? (
            adviceTemplates.map((template) => (
              <Box
                key={template._id}
                onClick={() => handleSelectAdviceTemplate(template)}
                sx={{
                  px: 1,
                  py: 0.9,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,

                  borderRadius: "8px",
                  cursor: "pointer",

                  transition: "all .12s ease",

                  "&:hover": {
                    bgcolor: "#fefce8",

                    "& .add-advice-template": {
                      bgcolor: "#eab308",
                      color: "#fff",
                      borderColor: "#eab308",
                    },
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    flexShrink: 0,

                    borderRadius: "7px",

                    bgcolor: "#fefce8",
                    color: "#ca8a04",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TipsAndUpdatesOutlinedIcon
                    sx={{
                      fontSize: ".85rem",
                    }}
                  />
                </Box>

                {/* Name */}
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ".74rem",
                      fontWeight: 600,
                      color: "#334155",

                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {template.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: ".59rem",
                      color: "#94a3b8",
                      mt: 0.1,
                    }}
                  >
                    Patient advice template
                  </Typography>
                </Box>

                {/* Add */}
                <Box
                  className="add-advice-template"
                  sx={{
                    width: 26,
                    height: 26,
                    flexShrink: 0,

                    borderRadius: "7px",
                    border: "1px solid #fde68a",

                    bgcolor: "#fff",
                    color: "#ca8a04",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    transition: "all .12s ease",
                  }}
                >
                  <AddCircleIcon
                    sx={{
                      fontSize: ".95rem",
                    }}
                  />
                </Box>
              </Box>
            ))
          ) : (
            <Box
              sx={{
                py: 4,
                px: 2,
                textAlign: "center",
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: "1.25rem",
                  color: "#cbd5e1",
                  mb: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: 600,
                  color: "#475569",
                }}
              >
                No templates found
              </Typography>

              {adviceTemplateSearch && (
                <Typography
                  sx={{
                    fontSize: ".61rem",
                    color: "#94a3b8",
                    mt: 0.25,
                  }}
                >
                  No results for "{adviceTemplateSearch}"
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Popover>

      <Popover
        open={medicineTemplateOpen}
        anchorEl={medicineTemplateAnchor}
        onClose={handleCloseMedicineTemplates}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,

              width: 350,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: 420,

              borderRadius: "11px",
              border: "1px solid #fed7aa",

              boxShadow:
                "0 14px 35px rgba(15,23,42,.12), 0 3px 8px rgba(15,23,42,.05)",

              overflow: "hidden",
            },
          },
        }}
      >
        {/* ================= HEADER ================= */}
        <Box
          sx={{
            px: 1.5,
            py: 1.2,

            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            bgcolor: "#fff7ed",
            borderBottom: "1px solid #fed7aa",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.9,
            }}
          >
            <Box
              sx={{
                width: 29,
                height: 29,
                borderRadius: "7px",

                bgcolor: "#ffedd5",
                color: "#ea580c",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MedicationIcon sx={{ fontSize: ".9rem" }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: ".76rem",
                  fontWeight: 700,
                  color: "#7c2d12",
                  lineHeight: 1.3,
                }}
              >
                Medicine Templates
              </Typography>

              <Typography
                sx={{
                  fontSize: ".6rem",
                  color: "#c2410c",
                  mt: 0.1,
                }}
              >
                Select a saved medicine template
              </Typography>
            </Box>
          </Box>

          <IconButton
            size="small"
            onClick={handleCloseMedicineTemplates}
            sx={{
              width: 27,
              height: 27,
              color: "#64748b",

              "&:hover": {
                bgcolor: "#ffedd5",
                color: "#c2410c",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: ".9rem" }} />
          </IconButton>
        </Box>

        {/* ================= SEARCH ================= */}
        <Box
          sx={{
            p: 1.25,
            borderBottom: "1px solid #f1f5f9",
            bgcolor: "#fff",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={medicineTemplateSearch}
            onChange={(e) => setMedicineTemplateSearch(e.target.value)}
            placeholder="Search medicine template..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      fontSize: ".95rem",
                      color: "#94a3b8",
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment: medicineTemplateLoading ? (
                <InputAdornment position="end">
                  <CircularProgress
                    size={14}
                    sx={{
                      color: "#ea580c",
                    }}
                  />
                </InputAdornment>
              ) : medicineTemplateSearch ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setMedicineTemplateSearch("")}
                  >
                    <CloseIcon sx={{ fontSize: ".85rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff",
                fontSize: ".75rem",

                "& fieldset": {
                  borderColor: "#e2e8f0",
                },

                "&:hover fieldset": {
                  borderColor: "#fdba74",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#f97316",
                  borderWidth: "1px",
                },

                "&.Mui-focused": {
                  boxShadow: "0 0 0 3px rgba(249,115,22,.10)",
                },
              },
            }}
          />
        </Box>

        {/* ================= TEMPLATE LIST ================= */}
        <Box
          sx={{
            maxHeight: 290,
            overflowY: "auto",
            p: 0.75,

            "&::-webkit-scrollbar": {
              width: "5px",
            },

            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#cbd5e1",
              borderRadius: "10px",
            },
          }}
        >
          {medicineTemplateLoading && medicineTemplates.length === 0 ? (
            <Box
              sx={{
                py: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              <CircularProgress
                size={20}
                sx={{
                  color: "#ea580c",
                }}
              />

              <Typography
                sx={{
                  fontSize: ".65rem",
                  color: "#94a3b8",
                }}
              >
                Loading templates...
              </Typography>
            </Box>
          ) : medicineTemplates.length > 0 ? (
            medicineTemplates.map((template) => (
              <Box
                key={template._id}
                onClick={() => handleSelectMedicineTemplate(template)}
                sx={{
                  px: 1,
                  py: 0.9,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,

                  borderRadius: "8px",
                  cursor: "pointer",

                  transition: "all .12s ease",

                  "&:hover": {
                    bgcolor: "#fff7ed",

                    "& .medicine-template-add": {
                      bgcolor: "#ea580c",
                      color: "#fff",
                      borderColor: "#ea580c",
                    },
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    flexShrink: 0,

                    borderRadius: "7px",

                    bgcolor: "#fff7ed",
                    color: "#ea580c",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MedicationIcon sx={{ fontSize: ".85rem" }} />
                </Box>

                {/* Name */}
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ".74rem",
                      fontWeight: 600,
                      color: "#334155",

                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {template.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: ".59rem",
                      color: "#94a3b8",
                      mt: 0.1,
                    }}
                  >
                    Medicine & dosage template
                  </Typography>
                </Box>

                {/* Load icon */}
                <Box
                  className="medicine-template-add"
                  sx={{
                    width: 26,
                    height: 26,
                    flexShrink: 0,

                    borderRadius: "7px",
                    border: "1px solid #fed7aa",

                    bgcolor: "#fff",
                    color: "#ea580c",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    transition: "all .12s ease",
                  }}
                >
                  <AddCircleIcon sx={{ fontSize: ".95rem" }} />
                </Box>
              </Box>
            ))
          ) : (
            <Box
              sx={{
                py: 4,
                px: 2,
                textAlign: "center",
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: "1.25rem",
                  color: "#cbd5e1",
                  mb: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: 600,
                  color: "#475569",
                }}
              >
                No medicine templates found
              </Typography>

              {medicineTemplateSearch && (
                <Typography
                  sx={{
                    fontSize: ".61rem",
                    color: "#94a3b8",
                    mt: 0.25,
                  }}
                >
                  No results for "{medicineTemplateSearch}"
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Popover>

      <Dialog
        open={applyingTemplate}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: 380,
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow:
              "0 24px 60px rgba(15,23,42,.18), 0 6px 18px rgba(15,23,42,.08)",
          },
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 3.5,
            textAlign: "center",
            position: "relative",
            overflow: "hidden",

            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background:
                "linear-gradient(90deg,#2563eb,#8b5cf6,#10b981,#2563eb)",
              backgroundSize: "200% 100%",
              animation: "templateGradient 1.5s linear infinite",
            },

            "@keyframes templateGradient": {
              "0%": {
                backgroundPosition: "0% 50%",
              },
              "100%": {
                backgroundPosition: "200% 50%",
              },
            },

            "@keyframes templatePulse": {
              "0%, 100%": {
                transform: "scale(1)",
                opacity: 1,
              },
              "50%": {
                transform: "scale(1.08)",
                opacity: 0.85,
              },
            },
          }}
        >
          {/* Icon / Loader */}
          <Box
            sx={{
              width: 72,
              height: 72,
              mx: "auto",
              mb: 2,

              position: "relative",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Spinner */}
            <CircularProgress
              size={72}
              thickness={2.5}
              sx={{
                position: "absolute",
                color: "primary.main",
              }}
            />

            {/* Inner Icon */}
            <Box
              sx={{
                width: 50,
                height: 50,

                borderRadius: "14px",

                bgcolor: "#eff6ff",
                color: "primary.main",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                animation: "templatePulse 1.5s ease-in-out infinite",
              }}
            >
              <LibraryBooksOutlinedIcon
                sx={{
                  fontSize: "1.45rem",
                }}
              />
            </Box>
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontSize: ".95rem",
              fontWeight: 800,
              color: "#0f172a",
            }}
          >
            Applying Prescription Template
          </Typography>

          {/* Template Name */}
          {applyingTemplateName && (
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.6,

                mt: 1,

                px: 1.2,
                py: 0.5,

                borderRadius: "999px",

                bgcolor: "#f8fafc",
                border: "1px solid #e2e8f0",
              }}
            >
              <DescriptionOutlinedIcon
                sx={{
                  fontSize: ".8rem",
                  color: "#64748b",
                }}
              />

              <Typography
                sx={{
                  maxWidth: 230,

                  fontSize: ".7rem",
                  fontWeight: 700,
                  color: "#475569",

                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {applyingTemplateName}
              </Typography>
            </Box>
          )}

          {/* Description */}
          <Typography
            sx={{
              mt: 1.5,
              fontSize: ".7rem",
              color: "#94a3b8",
              lineHeight: 1.6,
            }}
          >
            Loading clinical details, medicines, investigations and patient
            instructions...
          </Typography>

          {/* Steps */}
          <Box
            sx={{
              mt: 2.25,

              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 0.75,
            }}
          >
            {[
              {
                label: "Clinical",
                color: "#16a34a",
                bg: "#f0fdf4",
              },
              {
                label: "Tests",
                color: "#2563eb",
                bg: "#eff6ff",
              },
              {
                label: "Medicines",
                color: "#ea580c",
                bg: "#fff7ed",
              },
              {
                label: "Advice",
                color: "#ca8a04",
                bg: "#fefce8",
              },
            ].map((item) => (
              <Box
                key={item.label}
                sx={{
                  py: 0.75,
                  px: 0.5,

                  borderRadius: "8px",

                  bgcolor: item.bg,

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.45,
                }}
              >
                <Box
                  sx={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
                    bgcolor: item.color,
                  }}
                />

                <Typography
                  sx={{
                    fontSize: ".58rem",
                    fontWeight: 700,
                    color: item.color,
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Bottom message */}
          <Typography
            sx={{
              mt: 2,
              fontSize: ".6rem",
              color: "#94a3b8",
            }}
          >
            Please wait while your prescription is being prepared
          </Typography>
        </Box>
      </Dialog>
      <Dialog
        open={loadingDraft}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "14px",
            px: 2,
            py: 2.5,
            boxShadow: "0 20px 50px rgba(15,23,42,.15)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            py: 1,
          }}
        >
          {/* Loader */}
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              bgcolor: "#eff6ff",
              color: "#2563eb",
              border: "1px solid #bfdbfe",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1.5,
            }}
          >
            <CircularProgress
              size={23}
              thickness={4}
              sx={{
                color: "#2563eb",
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: "#1e293b",
              mb: 0.5,
            }}
          >
            Loading Prescription
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: "#64748b",
              lineHeight: 1.5,
              maxWidth: 300,
            }}
          >
            Retrieving the patient's saved prescription data. Please wait...
          </Typography>
        </Box>
      </Dialog>
    </Box>
  );
}

const fieldStyle = {
  "& .MuiOutlinedInput-root": {
    minHeight: 44,
    borderRadius: "9px",
    bgcolor: "#fff",

    "& fieldset": {
      borderColor: "#e2e8f0",
    },

    "&:hover fieldset": {
      borderColor: "#cbd5e1",
    },

    "&.Mui-focused": {
      boxShadow: "0 0 0 3px rgba(37,99,235,.10)",
    },

    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      borderWidth: "1px",
    },

    "& input": {
      fontSize: ".84rem",
      color: "#334155",
    },
  },
};

const EmptyText = ({ text }) => (
  <Typography
    sx={{
      fontSize: ".7rem",
      color: "#94a3b8",
      fontStyle: "italic",
    }}
  >
    {text}
  </Typography>
);
